const en = {
  // ── Sidebar sections & items ──
  'nav.browse': 'Browse',
  'nav.home': 'Home',
  'nav.settings': 'Settings',
  'nav.genres': 'Genres',
  'nav.history': 'History',
  'nav.support': 'Support',
  'nav.devices': 'Devices',
  'nav.prism': 'Prism DSP',
  'devices.title': 'Devices',
  'devices.subtitle': 'Configure your audio zones',
  'nav.services': 'Services',
  'nav.playlists': 'My Playlists',
  'nav.my_playlists': 'My Playlists',
  'nav.favorites': 'Favorites',
  'nav.audiophile': 'High-End Demo Music',
  'nav.genre_playlists': 'Styles',
  'nav.mood_playlists': 'Moods',
  'nav.season_playlists': 'Seasons',
  'nav.discover': 'Discover',
  'nav.valet_picks': "{valetName}'s Picks",
  'nav.trending': 'Trending',
  'nav.new_releases': 'New Releases',
  'nav.community': 'Community',
  'nav.personalize': 'Personalize',
  'nav.my_library': 'My Library',
  'nav.your_library': 'Your Library',
  'nav.local_library': 'Local Library',
  'nav.my_music': 'My Streamed Music',
  'nav.local_files': 'My Local Files',
  'nav.tools': 'Tools',
  'nav.recently_played': 'Recently Played',
  'nav.manage': 'Manage',
  'nav.local': 'Local',
  'nav.albums': 'My Albums',
  'nav.library': 'Library',
  'nav.artists': 'My Artists',
  'nav.lib_playlists': 'Playlists',
  'nav.lib_albums': 'Albums',
  'nav.lib_artists': 'Artists',
  'nav.tracks': 'Tracks',
  'nav.composers': 'Composers',
  'nav.my_live_radio': 'My Live Radio',
  'nav.folders': 'Folders',
  'nav.standard': 'Standard',
  'nav.full_featured': 'Full Featured',
  'help.local_features': 'Library & Network Players',
  'trackMenu.removeFromPlaylist': 'Remove from playlist',
  'trackMenu.playNow': 'Play Now',
  'trackMenu.playNext': 'Play Next',
  'trackMenu.addToQueue': 'Add to Queue',

  // ── Settings ──
  'settings.dark_mode': 'Dark Mode',
  'settings.dark_mode_desc': 'Switch between light and dark themes',
  'settings.theme': 'Theme',
  'settings.theme_desc': 'Choose your visual style',
  'settings.theme_light': 'Light',
  'settings.theme_dark': 'Dark',
  'settings.theme_high_contrast': 'High Contrast',
  'settings.display_size': 'Display Size',
  'settings.display_size_desc': 'Scale the interface for your screen',
  'settings.size_small': 'Small',
  'settings.size_default': 'Default',
  'settings.size_large': 'Large',
  'settings.size_xl': 'X-Large',
  'home.jukebox_title': "Ella's Jukebox",
  'home.jukebox_desc': "30 albums you haven't heard in a while, played album by album",
  'home.jukebox_loading': 'Building your playlist...',
  'home.jukebox_loading_desc': 'Loading albums and tracks...',
  'settings.language': 'Language',
  'settings.language_desc': 'Choose your display language',
  'settings.desktop_full': 'Maestro Connector',
  'settings.desktop_full_desc': 'NAS browsing, network players, DSP',
  'settings.voice_search': 'Voice Search',
  'settings.voice_search_desc': 'Enable microphone for voice commands',
  'settings.ella_voice': 'Ella Voice',
  'settings.ella_voice_desc': 'What happens to your music when Ella speaks',
  'settings.ella_voice_duck': 'Lower',
  'settings.ella_voice_pause': 'Pause',
  'settings.ella_voice_off': 'Off',
  'settings.services': 'Services',
  'settings.account': 'Account',
  'settings.subscription': 'Subscription',
  'settings.quick_settings': 'Quick Settings',
  'settings.connected': 'Connected',
  'settings.connect': 'Connect',
  'settings.coming_soon': 'Coming Soon',
  'settings.enabled': 'Enabled',
  'settings.disabled': 'Disabled',

  // ── Help ──
  'help.title': 'How to Use Maestro',
  'help.intro': "Maestro is your personal music companion. Here's everything you need to know to get the most out of it.",
  'help.getting_started': 'Getting Started',
  'help.playing_music': 'Playing Music',
  'help.streaming_services': 'Streaming Services',
  'help.your_valet': 'Ella',
  'help.full_featured': 'Library & Network Players',
  'help.playlists_favorites': 'Playlists & Favorites',
  'help.close': 'Close help',
  'help.footer': 'Need more help? Tap Settings → Email Support to reach our team.',
  'help.home_label': 'Home',
  'help.home_desc': 'Your personalized landing page with curated picks, recent plays, and new discoveries.',
  'help.settings_label': 'Settings',
  'help.settings_desc': 'Tap the gear icon in the sidebar to connect Qobuz, toggle dark mode, and manage your subscription.',
  'help.search_label': 'Search',
  'help.search_desc': 'Tap the magnifying glass in the header to search for artists, albums, tracks, and playlists. Voice search is available when enabled in Settings.',
  'help.play_track_label': 'Play a Track',
  'help.play_track_desc': 'Browse to any album or playlist and tap a track to start playing. The mini player appears at the bottom.',
  'help.mini_player_label': 'Mini Player',
  'help.mini_player_desc': 'Shows the current track with play/pause, skip, progress bar, and volume. Tap the artwork to see the full album.',
  'help.queue_label': 'Queue',
  'help.queue_desc': "Long-press or right-click a track to add it to your queue. The queue icon in the mini player shows what's coming next.",
  'help.qobuz_label': 'Qobuz',
  'help.qobuz_desc': "Connect your Qobuz account in Settings for full hi-res streaming. Without it, you'll hear 30-second previews.",
  'help.live_radio_label': 'Live Radio',
  'help.live_radio_desc': 'Enable Live Radio in Settings to browse curated internet radio stations.',
  'help.octave_radio_label': 'Octave Radio',
  'help.octave_radio_desc': "Paul McGowan's own curated radio station — enable it in Settings.",
  'help.picks_label': 'Personalized Picks',
  'help.picks_desc': 'Your valet learns your taste over time and suggests artists, albums, and playlists tailored to you.',
  'help.chat_label': 'Chat',
  'help.chat_desc': 'Tap the valet icon to ask questions about music, get recommendations, or explore genres.',
  'help.trending_label': 'Trending & New Releases',
  'help.trending_desc': "Stay current with what's popular and newly released in the sidebar under your valet's name.",
  'help.enable_label': 'Enable',
  'help.enable_desc': 'Install the Maestro Connector app to access NAS browsing, network player selection, and DSP controls.',
  'help.local_lib_label': 'Local Library',
  'help.local_lib_desc': 'Browse and play files from your NAS or local storage with the Maestro Connector.',
  'help.renderers_label': 'Network Players',
  'help.renderers_desc': 'Discover and play to UPnP/DLNA players on your network with the Maestro Connector.',
  'help.favorites_label': 'Favorites',
  'help.favorites_desc': 'Heart any artist, album, or track to save it to your Favorites for quick access.',
  'help.playlists_label': 'Playlists',
  'help.playlists_desc': 'Browse curated audiophile, genre, mood, and seasonal playlists — or create your own.',
  'help.search_pl_label': 'Search Playlists',
  'help.search_pl_desc': 'Use the search icon next to "Playlists" in the sidebar to find specific playlists by name.',

  // ── Search ──
  'search.placeholder': 'Search music...',
  'search.voice_search': 'Voice search',
  'search.stop_listening': 'Stop listening',
  'search.listening': 'Listening...',
  'search.top_result': 'Top Result',
  'search.try_again': 'Try Again',
  'search.show_albums': 'Show Albums',
  'search.showing_results_for': 'Showing results for',
  'search.albums': 'Albums',
  'search.artists': 'Artists',
  'search.tracks': 'Tracks',
  'search.all': 'All',
  'search.playlists': 'Playlists',
  'search.failed': 'Search failed. Please try again.',
  'search.no_results': 'No playable results found',
  'search.no_results_hint': 'Try a different search term or check your connected services.',
  'search.empty_title': 'Search across all your music services',
  'search.empty_hint_voice': 'Speak or type to find artists, albums, and tracks',
  'search.empty_hint': 'Type to find artists, albums, and tracks',
  'search.back': 'Back to search',
  'search.new_search': 'New search',
  'search.view_artist': 'View full profile',

  // ── Player ──
  'player.this_computer': 'System Audio (beta)',
  'player.iphone': 'iPhone',
  'player.system_output': 'System Output',
  'player.audio_output': 'Audio Output',
  'player.playback_zone': 'Playback Zone',
  'player.scanning': 'Scanning for devices...',
  'player.play': 'Play',
  'player.pause': 'Pause',
  'player.seek': 'Seek',
  'player.volume': 'Volume',
  'player.queue': 'Queue',
  'player.output_device': 'Output Device',
  'player.single_zone': 'Single Zone',
  'player.multi_zone': 'Multi-Zone',
  'player.master': 'Master',
  'player.zone_volumes': 'Zone Volumes',
  'player.zones_active': '{count} Zones Active',
  'player.select_two_zones': 'Select 2 or more zones',
  'player.multi_zone_count': 'Multi-Zone ({count})',
  'player.multi_label': 'Multi',
  'player.playing_on': 'Playing on {zone}',
  'player.network_renderers': 'Network Players',
  'player.find_my_dac': "Can't find your DAC? Enter its IP address",
  'player.find_dac_title': 'Find My DAC',
  'player.find_dac_search': 'Search',
  'player.find_dac_searching': 'Searching...',
  'player.find_dac_found': 'Found',
  'player.find_dac_not_found': 'No device found at this IP',
  'player.find_dac_invalid_ip': 'Please enter a valid IP address (e.g. 192.168.1.29)',
  'player.find_dac_hint': "Find your DAC's IP in its display or your router's device list",
  'player.this_device': 'System Audio',
  'player.usb_dac': 'USB DAC',
  'player.usb_dac_connected': 'Connected',
  'player.usb_dac_win_hint': 'USB DAC not showing? You may need to install your manufacturer\'s driver.',
  'player.local_audio_outputs': 'Local audio outputs',
  'player.change_output': 'Change...',

  // ── Exclusive Audio Engine ──
  'exclusive.format_error_title': 'Format Not Supported',
  'exclusive.switch_system_audio': 'Switch to System Audio',
  'exclusive.bit_perfect': 'Bit-Perfect',

  // ── DSD / DoP ──
  'dsd.native_dsd_label': 'Native DSD',
  'dsd.dop_supported': 'Yes (up to {rate} via DoP)',
  'dsd.pcm_only': 'No (PCM only)',
  'dsd.unknown_dac': 'Unknown DAC: defaulting to PCM',
  'dsd.force_pcm': 'Force PCM (disable DoP)',
  'dsd.force_pcm_hint': 'Play DSD as high-res PCM instead of native DSD',

  // ── Common ──
  'common.continue': 'Continue',
  'common.skip': 'Skip',
  'common.skip_step': 'Skip this step',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.back': 'Back',
  'common.close': 'Close',
  'common.search': 'Search',
  'common.menu': 'Menu',
  'common.home': 'Home',
  'common.help': 'Help',
  'common.about': 'About Maestro',

  // ── Onboarding ──
  'onboard.step_of': 'Step {step} of {total}',
  'onboard.welcome_name': 'Welcome, {name}!',
  'onboard.welcome_generic': 'Welcome to Maestro!',
  'onboard.welcome_intro': "I'm Paul McGowan, creator of Maestro, and I'm thrilled you're here.",
  'onboard.welcome_body': "Maestro is something I've dreamed of building for years — a music companion that's as beautiful to use as the music is to hear. Together, we're going to reshape how you discover, manage, and enjoy your music.",
  'onboard.welcome_cta': 'Getting started is easy — just three quick steps and you\'ll be listening.',
  'onboard.step1_title': 'Secure Your Account',
  'onboard.step1_desc': 'Choose a password to protect your music',
  'onboard.step2_title': 'Tell Us What You Love',
  'onboard.step2_desc': 'Pick genres and artists so Maestro knows your taste',
  'onboard.step3_title': 'Connect Your Music',
  'onboard.step3_desc': 'Link Qobuz for full hi-res streaming, or explore with previews',
  'onboard.all_set': "You're all set",
  'onboard.account_ready': 'Your account is ready.',
  'onboard.start_step1': "Let's start with Step 1",
  'onboard.choose_password': 'Choose a password to secure your account.',
  'onboard.loading_account': 'Loading your account info…',
  'onboard.signed_in_as': 'Signed in as',
  'onboard.get_started': 'Get Started →',
  'onboard.label_email': 'Email',
  'onboard.label_password': 'Password',
  'onboard.label_confirm': 'Confirm Password',
  'onboard.label_phone': 'Mobile Number',
  'onboard.phone_helper': "Forget your password? No worries — we'll text you a magic code to get back in.",
  'onboard.setting_up': 'Setting up…',
  'onboard.error_password_length': 'Password must be at least 8 characters',
  'onboard.error_password_match': 'Passwords do not match',
  'onboard.choose_language': 'Choose your language',
  'onboard.choose_language_desc': 'You can change this anytime in Settings.',
  'onboard.genre_title': 'What kind of music do you love?',
  'onboard.genre_desc': 'Pick at least 3. This helps us find music you\'ll enjoy.',
  'onboard.genre_hint_0': 'Pick at least 3 genres you enjoy',
  'onboard.genre_hint_few': '{count} selected — pick {remaining} more',
  'onboard.genre_hint_ready': '{count} selected — nice!',
  'onboard.genre_tap': 'Tap your favorites to get started',
  'onboard.streaming_title': 'Connect your music',
  'onboard.streaming_desc': 'Maestro works best with a streaming service, but you can explore with free previews.',
  'onboard.favs_title': 'Pick some favorites',
  'onboard.favs_desc': "We'll use these to personalize your home screen.",
  'onboard.complete_title': "You're all set!",
  'onboard.complete_desc': 'Maestro is ready to conduct your perfect listening experience.',
  'onboard.start_listening': 'Start Listening →',
  'onboard.saving': 'Saving your preferences…',
  'onboard.i_like_everything': 'I like everything',
  'onboard.almost_there': 'Almost there!',
  'onboard.experience_maestro': "You're about to experience Maestro!",
  'onboard.favs_hint_0': 'Pick a few artists you love',
  'onboard.favs_hint_few': '{count} selected — pick {remaining} more',
  'onboard.favs_hint_ready': '{count} selected — great taste!',
  'onboard.almost_done': 'Almost done!',
  'onboard.preview_note': "You'll hear 30-second previews of every track.\nConnect a service anytime to hear full songs.",
  // ── Feature Tour Modal ──
  'tour.skip': 'Skip Tour',
  'tour.next': 'Next →',
  'tour.start_exploring': 'Start Exploring →',
  'tour.section_browse': 'Browse',
  'tour.section_services': 'Services',
  'tour.section_valet': 'Ella',
  'tour.settings_title': 'Settings',
  'tour.settings_body': 'Choose your streaming services, customize your theme colors, and manage your subscription.',
  'tour.home_title': 'Home',
  'tour.home_body': 'Your personalized music dashboard. Albums, playlists, and recommendations based on your taste.',
  'tour.genres_title': 'Genres',
  'tour.genres_body': 'Browse music by genre. Discover new albums in Jazz, Classical, Rock, and more.',
  'tour.qobuz_title': 'Qobuz',
  'tour.qobuz_body': 'Your hi-res streaming service. Browse millions of tracks in stunning quality — or enjoy 30-second previews.',
  'tour.valet_title': "Ella's Picks",
  'tour.valet_body': "Ella is your personal music valet. She learns what you love and suggests albums you'll enjoy. The more you listen, the better she knows you.",
  'tour.radio_title': 'Live Radio',
  'tour.radio_body': 'Thousands of stations from around the world, right at your fingertips. Jazz, classical, world music, and more.',
  'tour.done_title': 'Have Fun! 🎶',
  'tour.done_body': "You're ready to explore. Discover, listen, and enjoy your music like never before.",

  // ── Smart Playlist ──
  'smart.title': "{valetName}'s Picks",
  'smart.ask_ella': "Ask {valetName}",
  'smart.tell_ella': "Tell {valetName} what you'd like to hear",
  'smart.type_request': "Or type your request here...",
  'smart.cancel': "Cancel",
  'smart.create': "Create",
  'smart.creating': "Creating...",
  'smart.crafting': "{valetName} is crafting your playlist...",
  'smart.crafting_sub': "Finding the perfect tracks, sequencing for flow",
  'smart.ella_acknowledged': "Thanks! I've got your instructions. Give me a minute to build your playlist.",
  'smart.no_playlists': "No playlists yet",
  'smart.no_playlists_sub': "Ask {valetName} to create one — describe the mood, the moment, and let her build your perfect journey.",
  'smart.play_all': "Play All",
  'smart.talk_to_ella': "Edit This Playlist",
  'smart.tell_change': "Tell {valetName} what to change...",
  'smart.fixing': "Sending...",
  'smart.ella_thinking': "{valetName} is thinking...",
  'smart.changes_applied': "Here's what changed",
  'smart.happy_with_this': "Happy with this?",
  'smart.keep_changes': "Looks great",
  'smart.try_different': "Not quite",
  'smart.rename': "Rename",
  'smart.fix_it': "Send",
  'smart.back': "Back",
  'smart.tracks': "tracks",
  'smart.min': "min",
  'smart.score': "Score",
  'smart.match': "match",
  'smart.refined': "refined",
  'smart.listening': "Listening...",
  'smart.not_found': "Playlist not found",
  'smart.error_generate': "I'm sorry, I had trouble putting that together. Could you try again?",
  'smart.loved': "Loved",
  'smart.disliked': "Not for me",
  'smart.created': "Created {date}",
  'smart.revised': "Revised {date}",
  'smart.save_to_library': "Save to My Playlists",
  'smart.saved_to_library': "Saved to My Playlists",
  'smart.delete_or_replace': "Delete or replace this track?",
  'smart.delete_track': "Delete",
  'smart.replace_track': "Replace",
  'smart.edit_or_delete': "What would you like to do with this track?",
  'smart.edit_track': "Edit",
  'smart.replace_ask': "No problem. What kind of track would you like to replace this with?",
  'smart.replace_working': "Ok, I'm on it.",
  'smart.replace_done': "Let me know if this is what you wanted.",
  'smart.add_to_my_playlists': "Add to My Playlists",
  'smart.added_to_playlists': "Added!",
  'smart.review_title': "Review your playlist",
  'smart.looks_good': "Looks good — play it!",
  'smart.send': "Send",
  'smart.try_again': "Try Again",

  // ── Qobuz playlist import ──
  'qobuz.playlists.title': 'Qobuz Playlists',
  'qobuz.playlists.description': 'Copy your Qobuz playlists into My Playlists so you can edit them and so Maestro can learn your taste.',
  'qobuz.playlists.refresh': 'Refresh Qobuz Playlists',
  'qobuz.playlists.importing': 'Importing…',
  'qobuz.playlists.complete': 'Added {added}, updated {updated}.',
  'qobuz.playlists.preservedEdited': '{n} edited in Maestro were preserved.',
  'qobuz.playlists.error': 'Import failed.',
  // ── Station Tweaks ──
  'tweak_title': 'Tweak Station',
  'tweak_btn': 'Tweak',
  'tweak_tune_btn': 'Tune',
  'tweak_queue_btn': 'Queue',
  'tweak_placeholder': 'Tell Ella how to adjust this station…',
  'tweak_examples_label': 'Try something like:',
  'tweak_example_1': 'No music older than 10 years',
  'tweak_example_2': 'More deep cuts, fewer hits',
  'tweak_example_3': 'Keep it mellow and acoustic',
  'tweak_example_4': 'Add more female vocalists',
  'fda.title': 'Maestro needs permission to access your music library',
  'fda.description': 'macOS removed Maestro\'s file access permission, likely after the last app update. Your music library is fine — we just need to re-grant access.',
  'fda.open_settings': 'Open System Settings',
  'fda.recheck': 'I\'ve granted it — re-check',
  'source_health.offline_disconnected': 'Offline for {minutes} min — drive disconnected',
  'source_health.offline_timeout': 'Offline for {minutes} min — slow response',
  'source_health.toast_offline': 'This music is on \'{source_name}\', which is currently offline. Reconnect the drive and try again.',
  'source_health.toast_permission': 'Maestro can\'t read \'{source_name}\'. Check folder permissions.',
  'faq.title': 'Frequently Asked Questions',
  'faq.subtitle': 'Quick answers to common questions',
  'faq.empty': 'No FAQs available yet.',
  'faq.loading': 'Loading…',
  'support.message_paul': 'Message Paul',
  'support.goes_to': 'Goes straight to paul@psaudio.com',
  'support.intro': "Thanks for being part of the Maestro Beta team. I'd love to hear your comments, bug reports, and ideas — every message comes straight to me.",
  'support.name': 'Name',
  'support.name_placeholder': 'Your name',
  'support.email': 'Email',
  'support.email_placeholder': 'your@email.com',
  'support.subject': 'Subject',
  'support.subject_placeholder': "What's on your mind?",
  'support.message': 'Message',
  'support.message_placeholder': "Tell me what's on your mind...",
  'support.platform': 'Platform',
  'support.send': 'Send Message',
  'support.sending': 'Sending…',
  'support.sent': 'Message sent ({ticketId})! You\'ll get a confirmation email, and you can track our conversation below.',
  'support.version': 'Version',
  'support.diagnostic.title': 'Diagnostic Mode',
  'support.diagnostic.checking': 'Checking…',
  'support.diagnostic.state_a_body': 'If Maestro support has asked you to enable diagnostic logging, you can activate it here. This shares connection details with our team to help diagnose your issue.',
  'support.diagnostic.contact_support': 'Contact support to enable',
  'support.diagnostic.state_b_body_ticket': 'Diagnostic logging is available for your support ticket {ticket}.',
  'support.diagnostic.state_b_body': 'Diagnostic logging is available.',
  'support.diagnostic.state_c_instruction': 'Diagnostic data is being captured. Use Maestro normally until the issue occurs, then come back here and send the log.',
  'support.diagnostic.available_expires': 'Available — expires {time}',
  'support.diagnostic.recording_expires': 'Recording — expires {time}',
  'support.diagnostic.send_log': 'Send Log',
  'support.diagnostic.sending': 'Sending…',
  'support.diagnostic.log_sent': 'Log sent to support',
  'support.diagnostic.reference': 'reference',
  'support.diagnostic.send_failed': 'Could not send log. Try again.',
  'support.diagnostic.expired': 'expired',
};

const es = {
  'nav.browse': 'Explorar',
  'nav.home': 'Inicio',
  'nav.settings': 'Ajustes',
  'nav.genres': 'Géneros',
  'nav.history': 'Historial',
  'nav.support': 'Soporte',
  'nav.devices': 'Dispositivos',
  'nav.prism': 'Prism DSP',
  'devices.title': 'Dispositivos',
  'devices.subtitle': 'Configura tus zonas de audio',
  'nav.services': 'Servicios',
  'nav.playlists': 'Mis Listas',
  'nav.my_playlists': 'Mis Listas',
  'nav.favorites': 'Favoritos',
  'nav.audiophile': 'Demos de Alta Fidelidad',
  'nav.genre_playlists': 'Estilos',
  'nav.mood_playlists': 'Estados de ánimo',
  'nav.season_playlists': 'Estaciones',
  'nav.discover': 'Descubrir',
  'nav.valet_picks': 'Selecciones de {valetName}',
  'nav.trending': 'Tendencias',
  'nav.new_releases': 'Novedades',
  'nav.community': 'Comunidad',
  'nav.personalize': 'Personalizar',
  'nav.my_library': 'Mi Biblioteca',
  'nav.your_library': 'Tu Biblioteca',
  'nav.local_library': 'Biblioteca Local',
  'nav.my_music': 'Mi Música en Streaming',
  'nav.local_files': 'Mis Archivos Locales',
  'nav.tools': 'Herramientas',
  'nav.recently_played': 'Reproducido Recientemente',
  'nav.manage': 'Administrar',
  'nav.local': 'Local',
  'nav.albums': 'Mis Álbumes',
  'nav.library': 'Biblioteca',
  'nav.artists': 'Mis Artistas',
  'nav.lib_playlists': 'Listas',
  'nav.lib_albums': 'Álbumes',
  'nav.lib_artists': 'Artistas',
  'nav.tracks': 'Pistas',
  'nav.composers': 'Compositores',
  'nav.my_live_radio': 'Mi Radio en Vivo',
  'nav.folders': 'Carpetas',
  'nav.standard': 'Estándar',
  'nav.full_featured': 'Completo',
  'help.local_features': 'Biblioteca y Reproductores de Red',
  'trackMenu.removeFromPlaylist': 'Quitar de la lista',
  'trackMenu.playNow': 'Reproducir ahora',
  'trackMenu.playNext': 'Reproducir siguiente',
  'trackMenu.addToQueue': 'Añadir a la cola',
  'settings.dark_mode': 'Modo Oscuro',
  'settings.dark_mode_desc': 'Cambiar entre temas claro y oscuro',
  'settings.theme': 'Tema',
  'settings.theme_desc': 'Elige tu estilo visual',
  'settings.theme_light': 'Claro',
  'settings.theme_dark': 'Oscuro',
  'settings.theme_high_contrast': 'Alto Contraste',
  'settings.display_size': 'Tamaño de pantalla',
  'settings.display_size_desc': 'Ajusta la interfaz para tu pantalla',
  'settings.size_small': 'Pequeño',
  'settings.size_default': 'Normal',
  'settings.size_large': 'Grande',
  'settings.size_xl': 'Muy grande',
  'home.jukebox_title': 'La Rocola de Ella',
  'home.jukebox_desc': '30 álbumes que no has escuchado en mucho tiempo, álbum por álbum',
  'home.jukebox_loading': 'Creando tu playlist...',
  'home.jukebox_loading_desc': 'Cargando álbumes y pistas...',
  'settings.language': 'Idioma',
  'settings.language_desc': 'Elige tu idioma de visualización',
  'settings.desktop_full': 'Maestro Connector',
  'settings.desktop_full_desc': 'NAS, reproductores de red, DSP',
  'settings.voice_search': 'Búsqueda por Voz',
  'settings.voice_search_desc': 'Habilitar micrófono para comandos de voz',
  'settings.ella_voice': 'Voz de Ella',
  'settings.ella_voice_desc': 'Qué pasa con tu música cuando Ella habla',
  'settings.ella_voice_duck': 'Bajar',
  'settings.ella_voice_pause': 'Pausar',
  'settings.ella_voice_off': 'Apagar',
  'settings.services': 'Servicios',
  'settings.account': 'Cuenta',
  'settings.subscription': 'Suscripción',
  'settings.quick_settings': 'Ajustes Rápidos',
  'settings.connected': 'Conectado',
  'settings.connect': 'Conectar',
  'settings.coming_soon': 'Próximamente',
  'help.title': 'Cómo usar Maestro',
  'help.intro': 'Maestro es tu compañero musical personal. Aquí tienes todo lo que necesitas saber.',
  'help.getting_started': 'Primeros Pasos',
  'help.playing_music': 'Reproducir Música',
  'help.streaming_services': 'Servicios de Streaming',
  'help.your_valet': 'Ella',
  'help.full_featured': 'Biblioteca y Reproductores de Red',
  'help.playlists_favorites': 'Listas y Favoritos',
  'help.close': 'Cerrar ayuda',
  'help.footer': '¿Necesitas más ayuda? Toca Ajustes → Soporte por Email para contactarnos.',
  'help.home_label': 'Inicio',
  'help.home_desc': 'Tu página de inicio personalizada con selecciones curadas, reproducciones recientes y nuevos descubrimientos.',
  'help.settings_label': 'Ajustes',
  'help.settings_desc': 'Toca el icono de engranaje en la barra lateral para conectar Qobuz, alternar el modo oscuro y gestionar tu suscripción.',
  'help.search_label': 'Buscar',
  'help.search_desc': 'Toca la lupa en el encabezado para buscar artistas, álbumes, pistas y listas. La búsqueda por voz está disponible cuando se activa en Ajustes.',
  'help.play_track_label': 'Reproducir una Pista',
  'help.play_track_desc': 'Navega a cualquier álbum o lista y toca una pista para empezar a reproducir. El mini reproductor aparece en la parte inferior.',
  'help.mini_player_label': 'Mini Reproductor',
  'help.mini_player_desc': 'Muestra la pista actual con play/pausa, saltar, barra de progreso y volumen. Toca la portada para ver el álbum completo.',
  'help.queue_label': 'Cola',
  'help.queue_desc': 'Mantén pulsada o haz clic derecho en una pista para añadirla a tu cola. El icono de cola en el mini reproductor muestra lo que viene después.',
  'help.qobuz_label': 'Qobuz',
  'help.qobuz_desc': 'Conecta tu cuenta de Qobuz en Ajustes para streaming en alta resolución. Sin ella, escucharás previews de 30 segundos.',
  'help.live_radio_label': 'Radio en Vivo',
  'help.live_radio_desc': 'Activa Radio en Vivo en Ajustes para explorar estaciones de radio por internet curadas.',
  'help.octave_radio_label': 'Octave Radio',
  'help.octave_radio_desc': 'La estación de radio curada de Paul McGowan — actívala en Ajustes.',
  'help.picks_label': 'Selecciones Personalizadas',
  'help.picks_desc': 'Tu valet aprende tus gustos con el tiempo y sugiere artistas, álbumes y listas adaptadas a ti.',
  'help.chat_label': 'Chat',
  'help.chat_desc': 'Toca el icono del valet para hacer preguntas sobre música, obtener recomendaciones o explorar géneros.',
  'help.trending_label': 'Tendencias y Novedades',
  'help.trending_desc': 'Mantente al día con lo popular y los nuevos lanzamientos en la barra lateral bajo el nombre de tu valet.',
  'help.enable_label': 'Activar',
  'help.enable_desc': 'Instala la app Maestro Connector para acceder a navegación NAS, selección de reproductores de red y controles DSP.',
  'help.local_lib_label': 'Biblioteca Local',
  'help.local_lib_desc': 'Explora y reproduce archivos de tu NAS o almacenamiento local con Maestro Connector.',
  'help.renderers_label': 'Reproductores de Red',
  'help.renderers_desc': 'Descubre y reproduce en reproductores UPnP/DLNA en tu red con Maestro Connector.',
  'help.favorites_label': 'Favoritos',
  'help.favorites_desc': 'Dale corazón a cualquier artista, álbum o pista para guardarlo en tus Favoritos para acceso rápido.',
  'help.playlists_label': 'Listas',
  'help.playlists_desc': 'Explora listas curadas de audiófilo, género, estado de ánimo y temporada — o crea las tuyas.',
  'help.search_pl_label': 'Buscar Listas',
  'help.search_pl_desc': 'Usa el icono de búsqueda junto a "Listas" en la barra lateral para encontrar listas específicas por nombre.',
  'search.placeholder': 'Buscar música...',
  'search.voice_search': 'Búsqueda por voz',
  'search.stop_listening': 'Dejar de escuchar',
  'search.listening': 'Escuchando...',
  'search.top_result': 'Mejor resultado',
  'search.try_again': 'Intentar de nuevo',
  'search.show_albums': 'Ver álbumes',
  'search.showing_results_for': 'Mostrando resultados para',
  'search.albums': 'Álbumes',
  'search.artists': 'Artistas',
  'search.tracks': 'Pistas',
  'search.all': 'Todo',
  'search.playlists': 'Playlists',
  'search.failed': 'Error en la búsqueda. Inténtalo de nuevo.',
  'search.no_results': 'No se encontraron resultados',
  'search.no_results_hint': 'Prueba otro término o revisa tus servicios conectados.',
  'search.empty_title': 'Busca en todos tus servicios de música',
  'search.empty_hint_voice': 'Habla o escribe para encontrar artistas, álbumes y pistas',
  'search.empty_hint': 'Escribe para encontrar artistas, álbumes y pistas',
  'search.back': 'Volver a buscar',
  'search.new_search': 'Nueva búsqueda',
  'search.view_artist': 'Ver perfil completo',
  'player.this_computer': 'Audio del Sistema (beta)',
  'player.iphone': 'iPhone',
  'player.system_output': 'Salida del Sistema',
  'player.audio_output': 'Salida de Audio',
  'player.playback_zone': 'Zona de Reproducción',
  'player.scanning': 'Buscando dispositivos...',
  'player.play': 'Reproducir',
  'player.pause': 'Pausa',
  'player.volume': 'Volumen',
  'player.queue': 'Cola',
  'player.single_zone': 'Zona Única',
  'player.multi_zone': 'Multi-Zona',
  'player.master': 'Maestro',
  'player.zone_volumes': 'Volumen por Zona',
  'player.zones_active': '{count} Zonas Activas',
  'player.select_two_zones': 'Seleccione 2 o más zonas',
  'player.multi_zone_count': 'Multi-Zona ({count})',
  'player.multi_label': 'Multi',
  'player.playing_on': 'Reproduciendo en {zone}',
  'player.network_renderers': 'Reproductores de Red',
  'player.find_my_dac': '¿No encuentra su DAC? Ingrese su dirección IP',
  'player.find_dac_title': 'Buscar Mi DAC',
  'player.find_dac_search': 'Buscar',
  'player.find_dac_searching': 'Buscando...',
  'player.find_dac_found': 'Encontrado',
  'player.find_dac_not_found': 'No se encontró dispositivo en esta IP',
  'player.find_dac_invalid_ip': 'Ingrese una dirección IP válida (ej. 192.168.1.29)',
  'player.find_dac_hint': 'Encuentre la IP de su DAC en su pantalla o en la lista de dispositivos de su router',
  'player.this_device': 'Audio del Sistema',
  'player.usb_dac': 'DAC USB',
  'player.usb_dac_connected': 'Conectado',
  'player.usb_dac_win_hint': '¿No aparece su DAC USB? Es posible que necesite instalar el controlador del fabricante.',
  'player.local_audio_outputs': 'Salidas de audio locales',
  'player.change_output': 'Cambiar...',
  'exclusive.format_error_title': 'Formato no compatible',
  'exclusive.switch_system_audio': 'Cambiar a Audio del Sistema',
  'exclusive.bit_perfect': 'Bit-Perfect',
  'dsd.native_dsd_label': 'DSD Nativo',
  'dsd.dop_supported': 'Sí (hasta {rate} vía DoP)',
  'dsd.pcm_only': 'No (solo PCM)',
  'dsd.unknown_dac': 'DAC desconocido: predeterminado a PCM',
  'dsd.force_pcm': 'Forzar PCM (desactivar DoP)',
  'dsd.force_pcm_hint': 'Reproducir DSD como PCM de alta resolución',
  'common.continue': 'Continuar',
  'common.skip': 'Omitir',
  'common.skip_step': 'Omitir este paso',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar',
  'common.back': 'Atrás',
  'common.close': 'Cerrar',
  'common.search': 'Buscar',
  'common.menu': 'Menú',
  'common.home': 'Inicio',
  'common.help': 'Ayuda',
  'common.about': 'Acerca de Maestro',
  'onboard.step_of': 'Paso {step} de {total}',
  'onboard.welcome_name': '¡Bienvenido, {name}!',
  'onboard.welcome_generic': '¡Bienvenido a Maestro!',
  'onboard.welcome_intro': 'Soy Paul McGowan, creador de Maestro, y estoy encantado de que estés aquí.',
  'onboard.welcome_body': 'Maestro es algo que he soñado construir durante años — un compañero musical tan hermoso de usar como la música es de escuchar. Juntos, vamos a transformar cómo descubres, gestionas y disfrutas tu música.',
  'onboard.welcome_cta': 'Empezar es fácil — solo tres pasos rápidos y estarás escuchando.',
  'onboard.step1_title': 'Asegura tu Cuenta',
  'onboard.step1_desc': 'Elige una contraseña para proteger tu música',
  'onboard.step2_title': 'Cuéntanos lo que te Gusta',
  'onboard.step2_desc': 'Elige géneros y artistas para que Maestro conozca tu gusto',
  'onboard.step3_title': 'Conecta tu Música',
  'onboard.step3_desc': 'Vincula Qobuz para streaming en alta resolución, o explora con previews',
  'onboard.all_set': 'Todo listo',
  'onboard.account_ready': 'Tu cuenta está lista.',
  'onboard.start_step1': 'Empecemos con el Paso 1',
  'onboard.choose_password': 'Elige una contraseña para asegurar tu cuenta.',
  'onboard.loading_account': 'Cargando información de tu cuenta…',
  'onboard.signed_in_as': 'Conectado como',
  'onboard.get_started': 'Empezar →',
  'onboard.label_email': 'Email',
  'onboard.label_password': 'Contraseña',
  'onboard.label_confirm': 'Confirmar Contraseña',
  'onboard.label_phone': 'Número Móvil',
  'onboard.phone_helper': '¿Olvidaste tu contraseña? No te preocupes — te enviaremos un código mágico para volver a entrar.',
  'onboard.setting_up': 'Configurando…',
  'onboard.error_password_length': 'La contraseña debe tener al menos 8 caracteres',
  'onboard.error_password_match': 'Las contraseñas no coinciden',
  'onboard.choose_language': 'Elige tu idioma',
  'onboard.choose_language_desc': 'Puedes cambiarlo en cualquier momento en Ajustes.',
  'onboard.genre_title': '¿Qué tipo de música te encanta?',
  'onboard.genre_desc': 'Elige al menos 3. Esto nos ayuda a encontrar música que disfrutarás.',
  'onboard.genre_hint_0': 'Elige al menos 3 géneros que disfrutes',
  'onboard.genre_hint_few': '{count} seleccionados — elige {remaining} más',
  'onboard.genre_hint_ready': '{count} seleccionados — ¡genial!',
  'onboard.genre_tap': 'Toca tus favoritos para comenzar',
  'onboard.streaming_title': 'Conecta tu música',
  'onboard.streaming_desc': 'Maestro funciona mejor con un servicio de streaming, pero puedes explorar con previews gratuitos.',
  'onboard.favs_title': 'Elige tus favoritos',
  'onboard.favs_desc': 'Los usaremos para personalizar tu pantalla de inicio.',
  'onboard.complete_title': '¡Todo listo!',
  'onboard.complete_desc': 'Maestro está listo para dirigir tu experiencia musical perfecta.',
  'onboard.start_listening': 'Empezar a Escuchar →',
  'onboard.saving': 'Guardando tus preferencias…',
  'onboard.almost_there': '¡Casi listo!',
  'onboard.experience_maestro': '¡Estás a punto de experimentar Maestro!',
  'onboard.favs_hint_0': 'Elige algunos artistas que te encanten',
  'onboard.favs_hint_few': '{count} seleccionados — elige {remaining} más',
  'onboard.favs_hint_ready': '{count} seleccionados — ¡gran gusto!',
  'onboard.almost_done': '¡Casi terminamos!',
  'onboard.preview_note': 'Escucharás previews de 30 segundos de cada pista.\nConecta un servicio en cualquier momento para escuchar canciones completas.',
  'tour.skip': 'Saltar Tour',
  'tour.next': 'Siguiente →',
  'tour.start_exploring': 'Empezar a Explorar →',
  'tour.section_browse': 'Explorar',
  'tour.section_services': 'Servicios',
  'tour.section_valet': 'Ella',
  'tour.settings_title': 'Ajustes',
  'tour.settings_body': 'Elige tus servicios de streaming, personaliza los colores del tema y gestiona tu suscripción.',
  'tour.home_title': 'Inicio',
  'tour.home_body': 'Tu panel de música personalizado. Álbumes, playlists y recomendaciones basadas en tu gusto.',
  'tour.genres_title': 'Géneros',
  'tour.genres_body': 'Explora música por género. Descubre nuevos álbumes en Jazz, Clásica, Rock y más.',
  'tour.qobuz_title': 'Qobuz',
  'tour.qobuz_body': 'Tu servicio de streaming en alta resolución. Millones de pistas en calidad asombrosa — o disfruta de previews de 30 segundos.',
  'tour.valet_title': 'Selecciones de Ella',
  'tour.valet_body': 'Tu valet musical personal. Aprende lo que te gusta y sugiere álbumes que disfrutarás. Cuanto más escuches, mejor te conoce.',
  'tour.radio_title': 'Radio en Vivo',
  'tour.radio_body': 'Miles de emisoras de todo el mundo, al alcance de tu mano. Jazz, clásica, música del mundo y más.',
  'tour.done_title': '¡A Disfrutar! 🎶',
  'tour.done_body': 'Estás listo para explorar. Descubre, escucha y disfruta tu música como nunca antes.',

  // ── Smart Playlist ──
  'smart.title': "Selecciones de {valetName}",
  'smart.ask_ella': "Pregúntale a {valetName}",
  'smart.tell_ella': "Dile a {valetName} qué te gustaría escuchar",
  'smart.type_request': "O escribe tu petición aquí...",
  'smart.cancel': "Cancelar",
  'smart.create': "Crear",
  'smart.creating': "Creando...",
  'smart.crafting': "{valetName} está preparando tu playlist...",
  'smart.crafting_sub': "Buscando las canciones perfectas, ordenando para el mejor flujo",
  'smart.ella_acknowledged': "¡Gracias! Ya tengo tus instrucciones. Dame un momento para armar tu playlist.",
  'smart.no_playlists': "Aún no tienes playlists",
  'smart.no_playlists_sub': "Pídele a {valetName} que cree una — describe el ambiente, el momento, y deja que construya tu viaje musical perfecto.",
  'smart.play_all': "Reproducir todo",
  'smart.talk_to_ella': "Editar esta playlist",
  'smart.tell_change': "Dile a {valetName} qué cambiar...",
  'smart.fixing': "Enviando...",
  'smart.ella_thinking': "{valetName} está pensando...",
  'smart.changes_applied': "Esto es lo que cambió",
  'smart.happy_with_this': "¿Te gusta así?",
  'smart.keep_changes': "Perfecto",
  'smart.try_different': "No del todo",
  'smart.rename': "Renombrar",
  'smart.fix_it': "Enviar",
  'smart.back': "Volver",
  'smart.tracks': "canciones",
  'smart.min': "min",
  'smart.score': "Puntuación",
  'smart.match': "coincidencia",
  'smart.refined': "refinada",
  'smart.listening': "Escuchando...",
  'smart.not_found': "Playlist no encontrada",
  'smart.error_generate': "Lo siento, tuve problemas para preparar eso. ¿Podrías intentarlo de nuevo?",
  'smart.loved': "Me encanta",
  'smart.disliked': "No es para mí",
  'smart.created': "Creada el {date}",
  'smart.revised': "Revisada el {date}",
  'smart.save_to_library': "Guardar en Mis Playlists",
  'smart.saved_to_library': "Guardada en Mis Playlists",
  'smart.delete_or_replace': "¿Eliminar o reemplazar esta canción?",
  'smart.delete_track': "Eliminar",
  'smart.replace_track': "Reemplazar",
  'smart.edit_or_delete': "¿Qué te gustaría hacer con esta canción?",
  'smart.edit_track': "Editar",
  'smart.replace_ask': "Sin problema. ¿Con qué tipo de canción te gustaría reemplazarla?",
  'smart.replace_working': "Ok, ya voy.",
  'smart.replace_done': "Dime si esto era lo que querías.",
  'smart.add_to_my_playlists': "Agregar a Mis Playlists",
  'smart.added_to_playlists': "¡Agregado!",
  'smart.review_title': "Revisa tu playlist",
  'smart.looks_good': "¡Se ve bien — reprodúcela!",
  'smart.send': "Enviar",
  'smart.try_again': "Intentar de nuevo",

  // ── Qobuz playlist import ──
  'qobuz.playlists.title': 'Listas de Qobuz',
  'qobuz.playlists.description': 'Copia tus listas de Qobuz a Mis Playlists para poder editarlas y para que Maestro aprenda tu gusto.',
  'qobuz.playlists.refresh': 'Actualizar listas de Qobuz',
  'qobuz.playlists.importing': 'Importando…',
  'qobuz.playlists.complete': 'Se agregaron {added}, se actualizaron {updated}.',
  'qobuz.playlists.preservedEdited': 'Se conservaron {n} editadas en Maestro.',
  'qobuz.playlists.error': 'La importación falló.',
  // ── Station Tweaks ──
  'tweak_title': 'Ajustar Estación',
  'tweak_btn': 'Ajustar',
  'tweak_tune_btn': 'Afinar',
  'tweak_queue_btn': 'Cola',
  'tweak_placeholder': 'Dile a Ella cómo ajustar esta estación…',
  'tweak_examples_label': 'Prueba algo como:',
  'tweak_example_1': 'Sin música de más de 10 años',
  'tweak_example_2': 'Más joyas ocultas, menos éxitos',
  'tweak_example_3': 'Mantenlo suave y acústico',
  'tweak_example_4': 'Añade más voces femeninas',
  'fda.title': 'Maestro necesita permiso para acceder a tu biblioteca musical',
  'fda.description': 'macOS eliminó el permiso de acceso a archivos de Maestro, probablemente después de la última actualización. Tu biblioteca musical está bien — solo necesitamos volver a conceder el acceso.',
  'fda.open_settings': 'Abrir Configuración del Sistema',
  'fda.recheck': 'Ya lo concedí — verificar',
  'source_health.offline_disconnected': 'Sin conexión hace {minutes} min — unidad desconectada',
  'source_health.offline_timeout': 'Sin conexión hace {minutes} min — respuesta lenta',
  'source_health.toast_offline': 'Esta música está en \'{source_name}\', que está sin conexión. Reconecta la unidad e inténtalo de nuevo.',
  'source_health.toast_permission': 'Maestro no puede leer \'{source_name}\'. Verifica los permisos de la carpeta.',
  'faq.title': 'Preguntas Frecuentes',
  'faq.subtitle': 'Respuestas rápidas a preguntas comunes',
  'faq.empty': 'Aún no hay preguntas frecuentes.',
  'faq.loading': 'Cargando…',
  'support.message_paul': 'Mensaje a Paul',
  'support.goes_to': 'Va directamente a paul@psaudio.com',
  'support.intro': 'Gracias por ser parte del equipo Beta de Maestro. Me encantaría escuchar tus comentarios, reportes de errores e ideas — cada mensaje me llega directamente.',
  'support.name': 'Nombre',
  'support.name_placeholder': 'Tu nombre',
  'support.email': 'Correo electrónico',
  'support.email_placeholder': 'tu@email.com',
  'support.subject': 'Asunto',
  'support.subject_placeholder': '¿Qué tienes en mente?',
  'support.message': 'Mensaje',
  'support.message_placeholder': 'Cuéntame qué tienes en mente...',
  'support.platform': 'Plataforma',
  'support.send': 'Enviar Mensaje',
  'support.sending': 'Enviando…',
  'support.sent': '¡Mensaje enviado ({ticketId})! Recibirás un correo de confirmación y podrás seguir nuestra conversación abajo.',
  'support.version': 'Versión',
  'support.diagnostic.title': 'Modo diagnóstico',
  'support.diagnostic.checking': 'Comprobando…',
  'support.diagnostic.state_a_body': 'Si el soporte de Maestro te pidió activar el registro de diagnóstico, puedes hacerlo aquí. Comparte detalles de conexión con nuestro equipo para ayudar a resolver el problema.',
  'support.diagnostic.contact_support': 'Contacta con soporte para activarlo',
  'support.diagnostic.state_b_body_ticket': 'El registro de diagnóstico está disponible para tu ticket de soporte {ticket}.',
  'support.diagnostic.state_b_body': 'El registro de diagnóstico está disponible.',
  'support.diagnostic.state_c_instruction': 'Se están capturando datos de diagnóstico. Usa Maestro con normalidad hasta que ocurra el problema; luego vuelve aquí y envía el registro.',
  'support.diagnostic.available_expires': 'Disponible — caduca en {time}',
  'support.diagnostic.recording_expires': 'Grabando — caduca en {time}',
  'support.diagnostic.send_log': 'Enviar registro',
  'support.diagnostic.sending': 'Enviando…',
  'support.diagnostic.log_sent': 'Registro enviado al soporte',
  'support.diagnostic.reference': 'referencia',
  'support.diagnostic.send_failed': 'No se pudo enviar el registro. Inténtalo de nuevo.',
  'support.diagnostic.expired': 'caducado',
};

const fr = {
  'nav.browse': 'Parcourir',
  'nav.home': 'Accueil',
  'nav.settings': 'Réglages',
  'nav.genres': 'Genres',
  'nav.history': 'Historique',
  'nav.support': 'Support',
  'nav.devices': 'Appareils',
  'nav.prism': 'Prism DSP',
  'devices.title': 'Appareils',
  'devices.subtitle': 'Configurez vos zones audio',
  'nav.services': 'Services',
  'nav.playlists': 'Mes Playlists',
  'nav.my_playlists': 'Mes Playlists',
  'nav.favorites': 'Favoris',
  'nav.audiophile': 'Démos Audiophiles',
  'nav.genre_playlists': 'Styles',
  'nav.mood_playlists': 'Ambiances',
  'nav.season_playlists': 'Saisons',
  'nav.discover': 'Découvrir',
  'nav.valet_picks': 'Choix de {valetName}',
  'nav.trending': 'Tendances',
  'nav.new_releases': 'Nouveautés',
  'nav.community': 'Communauté',
  'nav.personalize': 'Personnaliser',
  'nav.my_library': 'Ma Bibliothèque',
  'nav.your_library': 'Votre Bibliothèque',
  'nav.local_library': 'Bibliothèque Locale',
  'nav.my_music': 'Ma Musique en Streaming',
  'nav.local_files': 'Mes Fichiers Locaux',
  'nav.tools': 'Outils',
  'nav.recently_played': 'Écoutés Récemment',
  'nav.manage': 'Gérer',
  'nav.local': 'Local',
  'nav.albums': 'Mes Albums',
  'nav.library': 'Bibliothèque',
  'nav.artists': 'Mes Artistes',
  'nav.lib_playlists': 'Playlists',
  'nav.lib_albums': 'Albums',
  'nav.lib_artists': 'Artistes',
  'nav.tracks': 'Pistes',
  'nav.composers': 'Compositeurs',
  'nav.my_live_radio': 'Ma Radio en Direct',
  'nav.folders': 'Dossiers',
  'nav.standard': 'Standard',
  'nav.full_featured': 'Complet',
  'help.local_features': 'Bibliothèque et Lecteurs Réseau',
  'trackMenu.removeFromPlaylist': 'Retirer de la liste de lecture',
  'trackMenu.playNow': 'Lire maintenant',
  'trackMenu.playNext': 'Lire ensuite',
  'trackMenu.addToQueue': 'Ajouter à la file',
  'settings.dark_mode': 'Mode Sombre',
  'settings.dark_mode_desc': 'Basculer entre les thèmes clair et sombre',
  'settings.theme': 'Thème',
  'settings.theme_desc': 'Choisissez votre style visuel',
  'settings.theme_light': 'Clair',
  'settings.theme_dark': 'Sombre',
  'settings.theme_high_contrast': 'Contraste élevé',
  'settings.display_size': 'Taille d\'affichage',
  'settings.display_size_desc': 'Ajustez l\'interface pour votre écran',
  'settings.size_small': 'Petit',
  'settings.size_default': 'Normal',
  'settings.size_large': 'Grand',
  'settings.size_xl': 'Très grand',
  'home.jukebox_title': "Le Jukebox d'Ella",
  'home.jukebox_desc': "30 albums que vous n'avez pas écoutés depuis longtemps, album par album",
  'home.jukebox_loading': 'Création de votre playlist...',
  'home.jukebox_loading_desc': 'Chargement des albums et pistes...',
  'settings.language': 'Langue',
  'settings.language_desc': 'Choisissez votre langue d\'affichage',
  'settings.desktop_full': 'Maestro Connector',
  'settings.desktop_full_desc': 'NAS, lecteurs réseau, DSP',
  'settings.voice_search': 'Recherche Vocale',
  'settings.voice_search_desc': 'Activer le microphone pour les commandes vocales',
  'settings.ella_voice': 'Voix d\'Ella',
  'settings.ella_voice_desc': 'Ce qui arrive à votre musique quand Ella parle',
  'settings.ella_voice_duck': 'Baisser',
  'settings.ella_voice_pause': 'Pause',
  'settings.ella_voice_off': 'Désactivé',
  'settings.services': 'Services',
  'settings.account': 'Compte',
  'settings.subscription': 'Abonnement',
  'settings.quick_settings': 'Réglages Rapides',
  'settings.connected': 'Connecté',
  'settings.connect': 'Connecter',
  'settings.coming_soon': 'Bientôt',
  'help.title': 'Comment utiliser Maestro',
  'help.intro': 'Maestro est votre compagnon musical personnel. Voici tout ce que vous devez savoir.',
  'help.getting_started': 'Premiers Pas',
  'help.playing_music': 'Écouter de la Musique',
  'help.streaming_services': 'Services de Streaming',
  'help.your_valet': 'Ella',
  'help.full_featured': 'Bibliothèque et Lecteurs Réseau',
  'help.playlists_favorites': 'Playlists et Favoris',
  'help.close': 'Fermer l\'aide',
  'help.footer': 'Besoin d\'aide ? Allez dans Réglages → Support Email pour nous contacter.',
  'help.home_label': 'Accueil',
  'help.home_desc': 'Votre page d\'accueil personnalisée avec des sélections, vos écoutes récentes et de nouvelles découvertes.',
  'help.settings_label': 'Réglages',
  'help.settings_desc': 'Touchez l\'icône d\'engrenage dans la barre latérale pour connecter Qobuz, basculer le mode sombre et gérer votre abonnement.',
  'help.search_label': 'Rechercher',
  'help.search_desc': 'Touchez la loupe dans l\'en-tête pour chercher des artistes, albums, pistes et playlists. La recherche vocale est disponible dans les Réglages.',
  'help.play_track_label': 'Écouter une Piste',
  'help.play_track_desc': 'Naviguez vers un album ou une playlist et touchez une piste pour lancer la lecture. Le mini lecteur apparaît en bas.',
  'help.mini_player_label': 'Mini Lecteur',
  'help.mini_player_desc': 'Affiche la piste en cours avec lecture/pause, suivant, barre de progression et volume. Touchez la pochette pour voir l\'album.',
  'help.queue_label': 'File d\'attente',
  'help.queue_desc': 'Appui long ou clic droit sur une piste pour l\'ajouter à votre file d\'attente. L\'icône de file dans le mini lecteur montre ce qui suit.',
  'help.qobuz_label': 'Qobuz',
  'help.qobuz_desc': 'Connectez votre compte Qobuz dans les Réglages pour le streaming hi-res. Sans cela, vous entendrez des extraits de 30 secondes.',
  'help.live_radio_label': 'Radio en Direct',
  'help.live_radio_desc': 'Activez la Radio en Direct dans les Réglages pour parcourir des stations de radio internet sélectionnées.',
  'help.octave_radio_label': 'Octave Radio',
  'help.octave_radio_desc': 'La station de radio de Paul McGowan — activez-la dans les Réglages.',
  'help.picks_label': 'Sélections Personnalisées',
  'help.picks_desc': 'Votre valet apprend vos goûts au fil du temps et vous suggère des artistes, albums et playlists sur mesure.',
  'help.chat_label': 'Chat',
  'help.chat_desc': 'Touchez l\'icône du valet pour poser des questions sur la musique, obtenir des recommandations ou explorer des genres.',
  'help.trending_label': 'Tendances et Nouveautés',
  'help.trending_desc': 'Restez à jour avec ce qui est populaire et les nouvelles sorties dans la barre latérale sous le nom de votre valet.',
  'help.enable_label': 'Activer',
  'help.enable_desc': 'Installez l\'application Maestro Connector pour accéder à la navigation NAS, à la sélection de lecteurs réseau et aux contrôles DSP.',
  'help.local_lib_label': 'Bibliothèque Locale',
  'help.local_lib_desc': 'Parcourez et lisez des fichiers depuis votre NAS ou stockage local avec Maestro Connector.',
  'help.renderers_label': 'Lecteurs Réseau',
  'help.renderers_desc': 'Découvrez et diffusez vers des lecteurs UPnP/DLNA sur votre réseau avec Maestro Connector.',
  'help.favorites_label': 'Favoris',
  'help.favorites_desc': 'Ajoutez un cœur à n\'importe quel artiste, album ou piste pour le sauvegarder dans vos Favoris.',
  'help.playlists_label': 'Playlists',
  'help.playlists_desc': 'Parcourez des playlists audiophiles, par genre, ambiance et saison — ou créez les vôtres.',
  'help.search_pl_label': 'Rechercher des Playlists',
  'help.search_pl_desc': 'Utilisez l\'icône de recherche à côté de "Playlists" dans la barre latérale pour trouver des playlists par nom.',
  'search.placeholder': 'Rechercher de la musique...',
  'search.voice_search': 'Recherche vocale',
  'search.stop_listening': 'Arrêter d\'écouter',
  'search.listening': 'Écoute en cours...',
  'search.top_result': 'Meilleur résultat',
  'search.try_again': 'Réessayer',
  'search.show_albums': 'Voir les albums',
  'search.showing_results_for': 'Résultats pour',
  'search.albums': 'Albums',
  'search.artists': 'Artistes',
  'search.tracks': 'Pistes',
  'search.all': 'Tout',
  'search.playlists': 'Playlists',
  'search.failed': 'Échec de la recherche. Veuillez réessayer.',
  'search.no_results': 'Aucun résultat trouvé',
  'search.no_results_hint': 'Essayez un autre terme ou vérifiez vos services connectés.',
  'search.empty_title': 'Recherchez dans tous vos services de musique',
  'search.empty_hint_voice': 'Parlez ou tapez pour trouver des artistes, albums et pistes',
  'search.empty_hint': 'Tapez pour trouver des artistes, albums et pistes',
  'search.back': 'Retour à la recherche',
  'search.new_search': 'Nouvelle recherche',
  'search.view_artist': 'Voir le profil complet',
  'player.this_computer': 'Audio Système (bêta)',
  'player.iphone': 'iPhone',
  'player.system_output': 'Sortie Système',
  'player.audio_output': 'Sortie Audio',
  'player.playback_zone': 'Zone de Lecture',
  'player.scanning': 'Recherche d\'appareils...',
  'player.play': 'Lecture',
  'player.pause': 'Pause',
  'player.volume': 'Volume',
  'player.queue': 'File d\'attente',
  'player.single_zone': 'Zone Unique',
  'player.multi_zone': 'Multi-Zone',
  'player.master': 'Maître',
  'player.zone_volumes': 'Volumes par Zone',
  'player.zones_active': '{count} Zones Actives',
  'player.select_two_zones': 'Sélectionnez 2 zones ou plus',
  'player.multi_zone_count': 'Multi-Zone ({count})',
  'player.multi_label': 'Multi',
  'player.playing_on': 'Lecture sur {zone}',
  'player.network_renderers': 'Lecteurs Réseau',
  'player.find_my_dac': 'Votre DAC est introuvable ? Entrez son adresse IP',
  'player.find_dac_title': 'Trouver Mon DAC',
  'player.find_dac_search': 'Chercher',
  'player.find_dac_searching': 'Recherche...',
  'player.find_dac_found': 'Trouvé',
  'player.find_dac_not_found': 'Aucun appareil trouvé à cette adresse IP',
  'player.find_dac_invalid_ip': 'Veuillez entrer une adresse IP valide (ex. 192.168.1.29)',
  'player.find_dac_hint': "Trouvez l'IP de votre DAC sur son écran ou dans la liste des appareils de votre routeur",
  'player.this_device': 'Audio Système',
  'player.usb_dac': 'DAC USB',
  'player.usb_dac_connected': 'Connecté',
  'player.usb_dac_win_hint': 'Votre DAC USB n\'apparaît pas ? Vous devrez peut-être installer le pilote du fabricant.',
  'player.local_audio_outputs': 'Sorties audio locales',
  'player.change_output': 'Changer...',
  'exclusive.format_error_title': 'Format non pris en charge',
  'exclusive.switch_system_audio': 'Passer à Audio Système',
  'exclusive.bit_perfect': 'Bit-Perfect',
  'dsd.native_dsd_label': 'DSD natif',
  'dsd.dop_supported': 'Oui (jusqu\'à {rate} via DoP)',
  'dsd.pcm_only': 'Non (PCM uniquement)',
  'dsd.unknown_dac': 'DAC inconnu : PCM par défaut',
  'dsd.force_pcm': 'Forcer PCM (désactiver DoP)',
  'dsd.force_pcm_hint': 'Lire le DSD en PCM haute résolution',
  'common.continue': 'Continuer',
  'common.skip': 'Passer',
  'common.skip_step': 'Passer cette étape',
  'common.cancel': 'Annuler',
  'common.save': 'Enregistrer',
  'common.back': 'Retour',
  'common.close': 'Fermer',
  'common.search': 'Rechercher',
  'common.menu': 'Menu',
  'common.home': 'Accueil',
  'common.help': 'Aide',
  'common.about': 'À propos de Maestro',
  'onboard.step_of': 'Étape {step} sur {total}',
  'onboard.welcome_name': 'Bienvenue, {name} !',
  'onboard.welcome_generic': 'Bienvenue sur Maestro !',
  'onboard.welcome_intro': 'Je suis Paul McGowan, créateur de Maestro, et je suis ravi que vous soyez ici.',
  'onboard.welcome_body': 'Maestro est un projet dont je rêve depuis des années — un compagnon musical aussi beau à utiliser que la musique est belle à écouter. Ensemble, nous allons transformer la façon dont vous découvrez, gérez et appréciez votre musique.',
  'onboard.welcome_cta': 'C\'est facile de commencer — trois étapes rapides et vous écouterez.',
  'onboard.step1_title': 'Sécurisez votre Compte',
  'onboard.step1_desc': 'Choisissez un mot de passe pour protéger votre musique',
  'onboard.step2_title': 'Dites-nous ce que vous Aimez',
  'onboard.step2_desc': 'Choisissez des genres et artistes pour que Maestro connaisse vos goûts',
  'onboard.step3_title': 'Connectez votre Musique',
  'onboard.step3_desc': 'Liez Qobuz pour le streaming hi-res, ou explorez avec des extraits',
  'onboard.all_set': 'Tout est prêt',
  'onboard.account_ready': 'Votre compte est prêt.',
  'onboard.start_step1': 'Commençons par l\'Étape 1',
  'onboard.choose_password': 'Choisissez un mot de passe pour sécuriser votre compte.',
  'onboard.loading_account': 'Chargement des informations de votre compte…',
  'onboard.signed_in_as': 'Connecté en tant que',
  'onboard.get_started': 'Commencer →',
  'onboard.label_email': 'Email',
  'onboard.label_password': 'Mot de passe',
  'onboard.label_confirm': 'Confirmer le Mot de passe',
  'onboard.label_phone': 'Numéro de Mobile',
  'onboard.phone_helper': 'Mot de passe oublié ? Pas de souci — nous vous enverrons un code magique pour vous reconnecter.',
  'onboard.setting_up': 'Configuration…',
  'onboard.error_password_length': 'Le mot de passe doit contenir au moins 8 caractères',
  'onboard.error_password_match': 'Les mots de passe ne correspondent pas',
  'onboard.choose_language': 'Choisissez votre langue',
  'onboard.choose_language_desc': 'Vous pouvez la modifier à tout moment dans les Réglages.',
  'onboard.genre_title': 'Quel type de musique aimez-vous ?',
  'onboard.genre_desc': 'Choisissez au moins 3. Cela nous aide à trouver la musique que vous aimerez.',
  'onboard.genre_hint_0': 'Choisissez au moins 3 genres que vous aimez',
  'onboard.genre_hint_few': '{count} sélectionnés — choisissez-en {remaining} de plus',
  'onboard.genre_hint_ready': '{count} sélectionnés — super !',
  'onboard.genre_tap': 'Touchez vos favoris pour commencer',
  'onboard.streaming_title': 'Connectez votre musique',
  'onboard.streaming_desc': 'Maestro fonctionne mieux avec un service de streaming, mais vous pouvez explorer avec des extraits gratuits.',
  'onboard.favs_title': 'Choisissez vos favoris',
  'onboard.favs_desc': 'Nous les utiliserons pour personnaliser votre écran d\'accueil.',
  'onboard.complete_title': 'Tout est prêt !',
  'onboard.complete_desc': 'Maestro est prêt à orchestrer votre expérience musicale parfaite.',
  'onboard.start_listening': 'Commencer à Écouter →',
  'onboard.saving': 'Enregistrement de vos préférences…',
  'onboard.almost_there': 'Presque fini !',
  'onboard.experience_maestro': 'Vous êtes sur le point de découvrir Maestro !',
  'onboard.favs_hint_0': 'Choisissez quelques artistes que vous aimez',
  'onboard.favs_hint_few': '{count} sélectionnés — choisissez-en {remaining} de plus',
  'onboard.favs_hint_ready': '{count} sélectionnés — excellent goût !',
  'onboard.almost_done': 'Presque terminé !',
  'onboard.preview_note': 'Vous entendrez des extraits de 30 secondes.\nConnectez un service à tout moment pour écouter les morceaux complets.',
  'tour.skip': 'Passer le Tour',
  'tour.next': 'Suivant →',
  'tour.start_exploring': 'Commencer à Explorer →',
  'tour.section_browse': 'Parcourir',
  'tour.section_services': 'Services',
  'tour.section_valet': 'Ella',
  'tour.settings_title': 'Paramètres',
  'tour.settings_body': 'Choisissez vos services de streaming, personnalisez les couleurs du thème et gérez votre abonnement.',
  'tour.home_title': 'Accueil',
  'tour.home_body': 'Votre tableau de bord musical personnalisé. Albums, playlists et recommandations basées sur vos goûts.',
  'tour.genres_title': 'Genres',
  'tour.genres_body': 'Parcourez la musique par genre. Découvrez de nouveaux albums en Jazz, Classique, Rock et plus.',
  'tour.qobuz_title': 'Qobuz',
  'tour.qobuz_body': 'Votre service de streaming hi-res. Des millions de titres en qualité exceptionnelle — ou des extraits de 30 secondes.',
  'tour.valet_title': 'Choix d\'Ella',
  'tour.valet_body': 'Votre valet musical personnel. Il apprend ce que vous aimez et suggère des albums que vous apprécierez. Plus vous écoutez, mieux il vous connaît.',
  'tour.radio_title': 'Radio en Direct',
  'tour.radio_body': 'Des milliers de stations du monde entier, à portée de main. Jazz, classique, musiques du monde et plus.',
  'tour.done_title': 'Amusez-vous ! 🎶',
  'tour.done_body': 'Vous êtes prêt à explorer. Découvrez, écoutez et profitez de votre musique comme jamais.',

  // ── Smart Playlist ──
  'smart.title': "Les choix de {valetName}",
  'smart.ask_ella': "Demander à {valetName}",
  'smart.tell_ella': "Dites à {valetName} ce que vous aimeriez écouter",
  'smart.type_request': "Ou tapez votre demande ici...",
  'smart.cancel': "Annuler",
  'smart.create': "Créer",
  'smart.creating': "Création...",
  'smart.crafting': "{valetName} prépare votre playlist...",
  'smart.crafting_sub': "Recherche des morceaux parfaits, séquençage pour un flux idéal",
  'smart.ella_acknowledged': "Merci ! J'ai bien noté vos instructions. Laissez-moi un instant pour créer votre playlist.",
  'smart.no_playlists': "Pas encore de playlists",
  'smart.no_playlists_sub': "Demandez à {valetName} d'en créer une — décrivez l'ambiance, le moment, et laissez-la composer votre voyage musical parfait.",
  'smart.play_all': "Tout écouter",
  'smart.talk_to_ella': "Modifier cette playlist",
  'smart.tell_change': "Dites à {valetName} ce qu'il faut changer...",
  'smart.fixing': "Envoi...",
  'smart.ella_thinking': "{valetName} réfléchit...",
  'smart.changes_applied': "Voici ce qui a changé",
  'smart.happy_with_this': "Ça vous convient ?",
  'smart.keep_changes': "Parfait",
  'smart.try_different': "Pas tout à fait",
  'smart.rename': "Renommer",
  'smart.fix_it': "Envoyer",
  'smart.back': "Retour",
  'smart.tracks': "morceaux",
  'smart.min': "min",
  'smart.score': "Score",
  'smart.match': "correspondance",
  'smart.refined': "affinée",
  'smart.listening': "Écoute en cours...",
  'smart.not_found': "Playlist introuvable",
  'smart.error_generate': "Désolée, j'ai eu du mal à préparer ça. Pourriez-vous réessayer ?",
  'smart.loved': "J'adore",
  'smart.disliked': "Pas pour moi",
  'smart.created': "Créée le {date}",
  'smart.revised': "Révisée le {date}",
  'smart.save_to_library': "Enregistrer dans Mes Playlists",
  'smart.saved_to_library': "Enregistrée dans Mes Playlists",
  'smart.delete_or_replace': "Supprimer ou remplacer ce morceau ?",
  'smart.delete_track': "Supprimer",
  'smart.replace_track': "Remplacer",
  'smart.edit_or_delete': "Que souhaitez-vous faire avec ce morceau ?",
  'smart.edit_track': "Modifier",
  'smart.replace_ask': "Pas de problème. Quel genre de morceau aimeriez-vous à la place ?",
  'smart.replace_working': "Ok, je m'en occupe.",
  'smart.replace_done': "Dites-moi si c'est ce que vous vouliez.",
  'smart.add_to_my_playlists': "Ajouter à Mes Playlists",
  'smart.added_to_playlists': "Ajouté !",
  'smart.review_title': "Vérifiez votre playlist",
  'smart.looks_good': "Ça a l'air bien — lancez !",
  'smart.send': "Envoyer",
  'smart.try_again': "Réessayer",

  // ── Qobuz playlist import ──
  'qobuz.playlists.title': 'Playlists Qobuz',
  'qobuz.playlists.description': 'Copiez vos playlists Qobuz dans Mes Playlists pour pouvoir les modifier et pour que Maestro apprenne vos goûts.',
  'qobuz.playlists.refresh': 'Actualiser les playlists Qobuz',
  'qobuz.playlists.importing': 'Importation…',
  'qobuz.playlists.complete': '{added} ajoutées, {updated} mises à jour.',
  'qobuz.playlists.preservedEdited': '{n} modifiées dans Maestro ont été conservées.',
  'qobuz.playlists.error': "L'importation a échoué.",
  // ── Station Tweaks ──
  'tweak_title': 'Ajuster la Station',
  'tweak_btn': 'Ajuster',
  'tweak_tune_btn': 'Régler',
  'tweak_queue_btn': 'File',
  'tweak_placeholder': 'Dites à Ella comment ajuster cette station…',
  'tweak_examples_label': 'Essayez quelque chose comme :',
  'tweak_example_1': 'Pas de musique de plus de 10 ans',
  'tweak_example_2': 'Plus de raretés, moins de tubes',
  'tweak_example_3': 'Gardez-le doux et acoustique',
  'tweak_example_4': 'Ajoutez plus de voix féminines',
  'fda.title': 'Maestro a besoin de l\'autorisation d\'accéder à votre bibliothèque musicale',
  'fda.description': 'macOS a supprimé l\'autorisation d\'accès aux fichiers de Maestro, probablement après la dernière mise à jour. Votre bibliothèque musicale est intacte — il suffit de réaccorder l\'accès.',
  'fda.open_settings': 'Ouvrir les Préférences Système',
  'fda.recheck': 'C\'est fait — revérifier',
  'source_health.offline_disconnected': 'Hors ligne depuis {minutes} min — lecteur déconnecté',
  'source_health.offline_timeout': 'Hors ligne depuis {minutes} min — réponse lente',
  'source_health.toast_offline': 'Cette musique est sur \'{source_name}\', actuellement hors ligne. Reconnectez le lecteur et réessayez.',
  'source_health.toast_permission': 'Maestro ne peut pas lire \'{source_name}\'. Vérifiez les permissions du dossier.',
  'faq.title': 'Questions Fréquentes',
  'faq.subtitle': 'Réponses rapides aux questions courantes',
  'faq.empty': 'Aucune FAQ disponible pour le moment.',
  'faq.loading': 'Chargement…',
  'support.message_paul': 'Écrire à Paul',
  'support.goes_to': 'Va directement à paul@psaudio.com',
  'support.intro': "Merci de faire partie de l'équipe Beta de Maestro. J'adorerais entendre vos commentaires, rapports de bugs et idées — chaque message me parvient directement.",
  'support.name': 'Nom',
  'support.name_placeholder': 'Votre nom',
  'support.email': 'E-mail',
  'support.email_placeholder': 'votre@email.com',
  'support.subject': 'Sujet',
  'support.subject_placeholder': "Qu'avez-vous en tête ?",
  'support.message': 'Message',
  'support.message_placeholder': 'Dites-moi ce que vous avez en tête...',
  'support.platform': 'Plateforme',
  'support.send': 'Envoyer le message',
  'support.sending': 'Envoi en cours…',
  'support.sent': 'Message envoyé ({ticketId}) ! Vous recevrez un e-mail de confirmation et pourrez suivre notre conversation ci-dessous.',
  'support.version': 'Version',
  'support.diagnostic.title': 'Mode diagnostic',
  'support.diagnostic.checking': 'Vérification…',
  'support.diagnostic.state_a_body': 'Si l’équipe support Maestro vous a demandé d’activer la journalisation de diagnostic, vous pouvez le faire ici. Cela partage les détails de connexion avec notre équipe.',
  'support.diagnostic.contact_support': 'Contactez le support pour activer',
  'support.diagnostic.state_b_body_ticket': 'La journalisation de diagnostic est disponible pour votre ticket {ticket}.',
  'support.diagnostic.state_b_body': 'La journalisation de diagnostic est disponible.',
  'support.diagnostic.state_c_instruction': 'Les données de diagnostic sont en cours d’enregistrement. Utilisez Maestro normalement jusqu’au problème, puis revenez ici pour envoyer le journal.',
  'support.diagnostic.available_expires': 'Disponible — expire dans {time}',
  'support.diagnostic.recording_expires': 'Enregistrement — expire dans {time}',
  'support.diagnostic.send_log': 'Envoyer le journal',
  'support.diagnostic.sending': 'Envoi…',
  'support.diagnostic.log_sent': 'Journal envoyé au support',
  'support.diagnostic.reference': 'référence',
  'support.diagnostic.send_failed': 'Impossible d’envoyer le journal. Réessayez.',
  'support.diagnostic.expired': 'expiré',
};

const de = {
  'nav.browse': 'Durchsuchen',
  'nav.home': 'Startseite',
  'nav.settings': 'Einstellungen',
  'nav.genres': 'Genres',
  'nav.history': 'Verlauf',
  'nav.support': 'Support',
  'nav.devices': 'Geräte',
  'nav.prism': 'Prism DSP',
  'devices.title': 'Geräte',
  'devices.subtitle': 'Konfigurieren Sie Ihre Audiozonen',
  'nav.services': 'Dienste',
  'nav.playlists': 'Meine Playlists',
  'nav.my_playlists': 'Meine Playlists',
  'nav.favorites': 'Favoriten',
  'nav.audiophile': 'High-End Demo-Musik',
  'nav.genre_playlists': 'Stile',
  'nav.mood_playlists': 'Stimmungen',
  'nav.season_playlists': 'Jahreszeiten',
  'nav.discover': 'Entdecken',
  'nav.valet_picks': '{valetName}s Auswahl',
  'nav.trending': 'Im Trend',
  'nav.new_releases': 'Neuerscheinungen',
  'nav.community': 'Community',
  'nav.personalize': 'Personalisieren',
  'nav.my_library': 'Meine Bibliothek',
  'nav.your_library': 'Deine Bibliothek',
  'nav.local_library': 'Lokale Bibliothek',
  'nav.my_music': 'Meine Streaming-Musik',
  'nav.local_files': 'Meine Lokalen Dateien',
  'nav.tools': 'Werkzeuge',
  'nav.recently_played': 'Kürzlich Gespielt',
  'nav.manage': 'Verwalten',
  'nav.local': 'Lokal',
  'nav.albums': 'Meine Alben',
  'nav.library': 'Bibliothek',
  'nav.artists': 'Meine Künstler',
  'nav.lib_playlists': 'Playlists',
  'nav.lib_albums': 'Alben',
  'nav.lib_artists': 'Künstler',
  'nav.tracks': 'Titel',
  'nav.composers': 'Komponisten',
  'nav.my_live_radio': 'Mein Live-Radio',
  'nav.folders': 'Ordner',
  'nav.standard': 'Standard',
  'nav.full_featured': 'Vollversion',
  'help.local_features': 'Bibliothek & Netzwerk-Player',
  'trackMenu.removeFromPlaylist': 'Aus der Wiedergabeliste entfernen',
  'trackMenu.playNow': 'Jetzt abspielen',
  'trackMenu.playNext': 'Als Nächstes',
  'trackMenu.addToQueue': 'Zur Warteschlange',
  'settings.dark_mode': 'Dunkelmodus',
  'settings.dark_mode_desc': 'Zwischen hellem und dunklem Design wechseln',
  'settings.theme': 'Design',
  'settings.theme_desc': 'Wählen Sie Ihren visuellen Stil',
  'settings.theme_light': 'Hell',
  'settings.theme_dark': 'Dunkel',
  'settings.theme_high_contrast': 'Hoher Kontrast',
  'settings.display_size': 'Anzeigegröße',
  'settings.display_size_desc': 'Passen Sie die Oberfläche für Ihren Bildschirm an',
  'settings.size_small': 'Klein',
  'settings.size_default': 'Normal',
  'settings.size_large': 'Groß',
  'settings.size_xl': 'Sehr groß',
  'home.jukebox_title': 'Ellas Jukebox',
  'home.jukebox_desc': '30 Alben, die du lange nicht gehört hast — Album für Album',
  'home.jukebox_loading': 'Playlist wird erstellt...',
  'home.jukebox_loading_desc': 'Alben und Titel werden geladen...',
  'settings.language': 'Sprache',
  'settings.language_desc': 'Wählen Sie Ihre Anzeigesprache',
  'settings.desktop_full': 'Maestro Connector',
  'settings.desktop_full_desc': 'NAS, Netzwerk-Player, DSP',
  'settings.voice_search': 'Sprachsuche',
  'settings.voice_search_desc': 'Mikrofon für Sprachbefehle aktivieren',
  'settings.ella_voice': 'Ellas Stimme',
  'settings.ella_voice_desc': 'Was mit Ihrer Musik passiert, wenn Ella spricht',
  'settings.ella_voice_duck': 'Leiser',
  'settings.ella_voice_pause': 'Pause',
  'settings.ella_voice_off': 'Aus',
  'settings.services': 'Dienste',
  'settings.account': 'Konto',
  'settings.subscription': 'Abonnement',
  'settings.quick_settings': 'Schnelleinstellungen',
  'settings.connected': 'Verbunden',
  'settings.connect': 'Verbinden',
  'settings.coming_soon': 'Demnächst',
  'help.title': 'So verwenden Sie Maestro',
  'help.intro': 'Maestro ist Ihr persönlicher Musikbegleiter. Hier erfahren Sie alles, was Sie wissen müssen.',
  'help.getting_started': 'Erste Schritte',
  'help.playing_music': 'Musik abspielen',
  'help.streaming_services': 'Streaming-Dienste',
  'help.your_valet': 'Ella',
  'help.full_featured': 'Bibliothek & Netzwerk-Player',
  'help.playlists_favorites': 'Playlists & Favoriten',
  'help.close': 'Hilfe schließen',
  'help.footer': 'Brauchen Sie mehr Hilfe? Gehen Sie zu Einstellungen → E-Mail-Support.',
  'help.home_label': 'Startseite',
  'help.home_desc': 'Ihre personalisierte Startseite mit kuratierten Empfehlungen, kürzlich gespielten Titeln und neuen Entdeckungen.',
  'help.settings_label': 'Einstellungen',
  'help.settings_desc': 'Tippen Sie auf das Zahnrad-Symbol in der Seitenleiste, um Qobuz zu verbinden, den Dunkelmodus umzuschalten und Ihr Abonnement zu verwalten.',
  'help.search_label': 'Suchen',
  'help.search_desc': 'Tippen Sie auf die Lupe in der Kopfzeile, um nach Künstlern, Alben, Titeln und Playlists zu suchen. Die Sprachsuche ist verfügbar, wenn sie in den Einstellungen aktiviert ist.',
  'help.play_track_label': 'Titel abspielen',
  'help.play_track_desc': 'Navigieren Sie zu einem Album oder einer Playlist und tippen Sie auf einen Titel. Der Mini-Player erscheint am unteren Rand.',
  'help.mini_player_label': 'Mini-Player',
  'help.mini_player_desc': 'Zeigt den aktuellen Titel mit Play/Pause, Überspringen, Fortschrittsbalken und Lautstärke. Tippen Sie auf das Artwork, um das Album zu sehen.',
  'help.queue_label': 'Warteschlange',
  'help.queue_desc': 'Halten Sie einen Titel gedrückt oder klicken Sie mit der rechten Maustaste, um ihn zur Warteschlange hinzuzufügen.',
  'help.qobuz_label': 'Qobuz',
  'help.qobuz_desc': 'Verbinden Sie Ihr Qobuz-Konto in den Einstellungen für Hi-Res-Streaming. Ohne Konto hören Sie 30-Sekunden-Vorschauen.',
  'help.live_radio_label': 'Live-Radio',
  'help.live_radio_desc': 'Aktivieren Sie Live-Radio in den Einstellungen, um kuratierte Internetradiosender zu durchstöbern.',
  'help.octave_radio_label': 'Octave Radio',
  'help.octave_radio_desc': 'Paul McGowans eigener kuratierter Radiosender — aktivieren Sie ihn in den Einstellungen.',
  'help.picks_label': 'Personalisierte Empfehlungen',
  'help.picks_desc': 'Ella lernt Ihren Geschmack und schlägt Künstler, Alben und Playlists vor, die zu Ihnen passen.',
  'help.chat_label': 'Chat',
  'help.chat_desc': 'Tippen Sie auf das Ella-Symbol, um Fragen über Musik zu stellen, Empfehlungen zu erhalten oder Genres zu erkunden.',
  'help.trending_label': 'Trends & Neuerscheinungen',
  'help.trending_desc': 'Bleiben Sie auf dem Laufenden mit Beliebtem und Neuerscheinungen in der Seitenleiste unter Ella.',
  'help.enable_label': 'Aktivieren',
  'help.enable_desc': 'Installieren Sie die Maestro Connector App für NAS-Browsing, Netzwerk-Player-Auswahl und DSP-Steuerung.',
  'help.local_lib_label': 'Lokale Bibliothek',
  'help.local_lib_desc': 'Durchsuchen und spielen Sie Dateien von Ihrem NAS oder lokalem Speicher mit dem Maestro Connector.',
  'help.renderers_label': 'Netzwerk-Player',
  'help.renderers_desc': 'Entdecken und spielen Sie über UPnP/DLNA-Player in Ihrem Netzwerk mit dem Maestro Connector.',
  'help.favorites_label': 'Favoriten',
  'help.favorites_desc': 'Markieren Sie Künstler, Alben oder Titel mit einem Herz, um sie für schnellen Zugriff in Ihren Favoriten zu speichern.',
  'help.playlists_label': 'Playlists',
  'help.playlists_desc': 'Durchstöbern Sie kuratierte Audiophile-, Genre-, Stimmungs- und Jahreszeiten-Playlists — oder erstellen Sie Ihre eigenen.',
  'help.search_pl_label': 'Playlists suchen',
  'help.search_pl_desc': 'Verwenden Sie das Suchsymbol neben "Playlists" in der Seitenleiste, um bestimmte Playlists nach Namen zu finden.',
  'search.placeholder': 'Musik suchen...',
  'search.voice_search': 'Sprachsuche',
  'search.stop_listening': 'Zuhören beenden',
  'search.listening': 'Höre zu...',
  'search.top_result': 'Bestes Ergebnis',
  'search.try_again': 'Erneut versuchen',
  'search.show_albums': 'Alben anzeigen',
  'search.showing_results_for': 'Ergebnisse für',
  'search.albums': 'Alben',
  'search.artists': 'Künstler',
  'search.tracks': 'Titel',
  'search.all': 'Alle',
  'search.playlists': 'Playlists',
  'search.failed': 'Suche fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'search.no_results': 'Keine Ergebnisse gefunden',
  'search.no_results_hint': 'Versuchen Sie einen anderen Suchbegriff.',
  'search.empty_title': 'Durchsuchen Sie alle Ihre Musikdienste',
  'search.empty_hint_voice': 'Sprechen oder tippen Sie, um Künstler, Alben und Titel zu finden',
  'search.empty_hint': 'Tippen Sie, um Künstler, Alben und Titel zu finden',
  'search.back': 'Zurück zur Suche',
  'search.new_search': 'Neue Suche',
  'search.view_artist': 'Vollständiges Profil ansehen',
  'player.this_computer': 'Systemaudio (Beta)',
  'player.iphone': 'iPhone',
  'player.system_output': 'Systemausgabe',
  'player.audio_output': 'Audioausgabe',
  'player.playback_zone': 'Wiedergabezone',
  'player.scanning': 'Suche nach Geräten...',
  'player.play': 'Abspielen',
  'player.pause': 'Pause',
  'player.volume': 'Lautstärke',
  'player.queue': 'Warteschlange',
  'player.single_zone': 'Einzelzone',
  'player.multi_zone': 'Multi-Zone',
  'player.master': 'Master',
  'player.zone_volumes': 'Zonen-Lautstärke',
  'player.zones_active': '{count} Zonen Aktiv',
  'player.select_two_zones': 'Wählen Sie 2 oder mehr Zonen',
  'player.multi_zone_count': 'Multi-Zone ({count})',
  'player.multi_label': 'Multi',
  'player.playing_on': 'Wiedergabe auf {zone}',
  'player.network_renderers': 'Netzwerk-Player',
  'player.find_my_dac': 'DAC nicht gefunden? IP-Adresse eingeben',
  'player.find_dac_title': 'Meinen DAC finden',
  'player.find_dac_search': 'Suchen',
  'player.find_dac_searching': 'Suche...',
  'player.find_dac_found': 'Gefunden',
  'player.find_dac_not_found': 'Kein Gerät unter dieser IP gefunden',
  'player.find_dac_invalid_ip': 'Bitte geben Sie eine gültige IP-Adresse ein (z.B. 192.168.1.29)',
  'player.find_dac_hint': 'Die IP-Adresse Ihres DACs finden Sie auf dem Display oder in der Geräteliste Ihres Routers',
  'player.this_device': 'Systemaudio',
  'player.usb_dac': 'USB-DAC',
  'player.usb_dac_connected': 'Verbunden',
  'player.usb_dac_win_hint': 'USB-DAC wird nicht angezeigt? Möglicherweise müssen Sie den Treiber des Herstellers installieren.',
  'player.local_audio_outputs': 'Lokale Audioausgänge',
  'player.change_output': 'Ändern...',
  'exclusive.format_error_title': 'Format nicht unterstützt',
  'exclusive.switch_system_audio': 'Zu Systemausgabe wechseln',
  'exclusive.bit_perfect': 'Bit-Perfect',
  'dsd.native_dsd_label': 'Natives DSD',
  'dsd.dop_supported': 'Ja (bis {rate} über DoP)',
  'dsd.pcm_only': 'Nein (nur PCM)',
  'dsd.unknown_dac': 'Unbekannter DAC: Standard ist PCM',
  'dsd.force_pcm': 'PCM erzwingen (DoP deaktivieren)',
  'dsd.force_pcm_hint': 'DSD als hochauflösendes PCM wiedergeben',
  'common.continue': 'Weiter',
  'common.skip': 'Überspringen',
  'common.skip_step': 'Diesen Schritt überspringen',
  'common.cancel': 'Abbrechen',
  'common.save': 'Speichern',
  'common.back': 'Zurück',
  'common.close': 'Schließen',
  'common.search': 'Suchen',
  'common.menu': 'Menü',
  'common.home': 'Startseite',
  'common.help': 'Hilfe',
  'common.about': 'Über Maestro',
  'onboard.step_of': 'Schritt {step} von {total}',
  'onboard.welcome_name': 'Willkommen, {name}!',
  'onboard.welcome_generic': 'Willkommen bei Maestro!',
  'onboard.welcome_intro': 'Ich bin Paul McGowan, Schöpfer von Maestro, und ich freue mich sehr, dass Sie hier sind.',
  'onboard.welcome_body': 'Maestro ist etwas, von dem ich seit Jahren träume — ein Musikbegleiter, der genauso schön zu benutzen ist, wie die Musik schön zu hören ist. Gemeinsam werden wir die Art verändern, wie Sie Musik entdecken, verwalten und genießen.',
  'onboard.welcome_cta': 'Der Einstieg ist einfach — nur drei kurze Schritte und Sie hören Musik.',
  'onboard.step1_title': 'Konto sichern',
  'onboard.step1_desc': 'Wählen Sie ein Passwort zum Schutz Ihrer Musik',
  'onboard.step2_title': 'Erzählen Sie uns, was Sie lieben',
  'onboard.step2_desc': 'Wählen Sie Genres und Künstler, damit Maestro Ihren Geschmack kennt',
  'onboard.step3_title': 'Verbinden Sie Ihre Musik',
  'onboard.step3_desc': 'Verknüpfen Sie Qobuz für Hi-Res-Streaming oder erkunden Sie mit Vorschauen',
  'onboard.all_set': 'Alles bereit',
  'onboard.account_ready': 'Ihr Konto ist bereit.',
  'onboard.start_step1': 'Beginnen wir mit Schritt 1',
  'onboard.choose_password': 'Wählen Sie ein Passwort für Ihr Konto.',
  'onboard.loading_account': 'Kontoinformationen werden geladen…',
  'onboard.signed_in_as': 'Angemeldet als',
  'onboard.get_started': 'Loslegen →',
  'onboard.label_email': 'E-Mail',
  'onboard.label_password': 'Passwort',
  'onboard.label_confirm': 'Passwort bestätigen',
  'onboard.label_phone': 'Mobilnummer',
  'onboard.phone_helper': 'Passwort vergessen? Kein Problem — wir senden Ihnen einen magischen Code zum Wiedereinloggen.',
  'onboard.setting_up': 'Einrichtung…',
  'onboard.error_password_length': 'Das Passwort muss mindestens 8 Zeichen lang sein',
  'onboard.error_password_match': 'Die Passwörter stimmen nicht überein',
  'onboard.choose_language': 'Wählen Sie Ihre Sprache',
  'onboard.choose_language_desc': 'Sie können dies jederzeit in den Einstellungen ändern.',
  'onboard.genre_title': 'Welche Musik lieben Sie?',
  'onboard.genre_desc': 'Wählen Sie mindestens 3. Das hilft uns, Musik zu finden, die Ihnen gefällt.',
  'onboard.genre_hint_0': 'Wählen Sie mindestens 3 Genres, die Ihnen gefallen',
  'onboard.genre_hint_few': '{count} ausgewählt — wählen Sie noch {remaining}',
  'onboard.genre_hint_ready': '{count} ausgewählt — großartig!',
  'onboard.genre_tap': 'Tippen Sie auf Ihre Favoriten',
  'onboard.streaming_title': 'Verbinden Sie Ihre Musik',
  'onboard.streaming_desc': 'Maestro funktioniert am besten mit einem Streaming-Dienst, aber Sie können auch mit kostenlosen Vorschauen erkunden.',
  'onboard.favs_title': 'Wählen Sie Ihre Favoriten',
  'onboard.favs_desc': 'Wir nutzen diese, um Ihre Startseite zu personalisieren.',
  'onboard.complete_title': 'Alles bereit!',
  'onboard.complete_desc': 'Maestro ist bereit, Ihr perfektes Musikerlebnis zu dirigieren.',
  'onboard.start_listening': 'Jetzt Hören →',
  'onboard.saving': 'Ihre Einstellungen werden gespeichert…',
  'onboard.almost_there': 'Fast geschafft!',
  'onboard.experience_maestro': 'Sie stehen kurz davor, Maestro zu erleben!',
  'onboard.favs_hint_0': 'Wählen Sie einige Künstler, die Sie lieben',
  'onboard.favs_hint_few': '{count} ausgewählt — wählen Sie noch {remaining}',
  'onboard.favs_hint_ready': '{count} ausgewählt — toller Geschmack!',
  'onboard.almost_done': 'Fast fertig!',
  'onboard.preview_note': 'Sie hören 30-Sekunden-Vorschauen jedes Titels.\nVerbinden Sie jederzeit einen Dienst, um ganze Songs zu hören.',
  'tour.skip': 'Tour Überspringen',
  'tour.next': 'Weiter →',
  'tour.start_exploring': 'Entdecken →',
  'tour.section_browse': 'Durchsuchen',
  'tour.section_services': 'Dienste',
  'tour.section_valet': 'Ella',
  'tour.settings_title': 'Einstellungen',
  'tour.settings_body': 'Wählen Sie Ihre Streaming-Dienste, passen Sie die Themenfarben an und verwalten Sie Ihr Abonnement.',
  'tour.home_title': 'Startseite',
  'tour.home_body': 'Ihr personalisiertes Musik-Dashboard. Alben, Playlists und Empfehlungen basierend auf Ihrem Geschmack.',
  'tour.genres_title': 'Genres',
  'tour.genres_body': 'Musik nach Genre durchsuchen. Entdecken Sie neue Alben in Jazz, Klassik, Rock und mehr.',
  'tour.qobuz_title': 'Qobuz',
  'tour.qobuz_body': 'Ihr Hi-Res-Streaming-Dienst. Millionen von Titeln in atemberaubender Qualität — oder 30-Sekunden-Vorschauen.',
  'tour.valet_title': 'Ellas Auswahl',
  'tour.valet_body': 'Ella ist Ihre persönliche Musikbegleiterin. Sie lernt, was Sie lieben, und schlägt Alben vor, die Ihnen gefallen. Je mehr Sie hören, desto besser kennt sie Sie.',
  'tour.radio_title': 'Live-Radio',
  'tour.radio_body': 'Tausende Sender aus der ganzen Welt, direkt griffbereit. Jazz, Klassik, Weltmusik und mehr.',
  'tour.done_title': 'Viel Spaß! 🎶',
  'tour.done_body': 'Sie sind bereit zum Entdecken. Entdecken, hören und genießen Sie Ihre Musik wie nie zuvor.',

  // ── Smart Playlist ──
  'smart.title': "{valetName}s Auswahl",
  'smart.ask_ella': "{valetName} fragen",
  'smart.tell_ella': "Sag {valetName}, was du hören möchtest",
  'smart.type_request': "Oder tippe deine Anfrage hier ein...",
  'smart.cancel': "Abbrechen",
  'smart.create': "Erstellen",
  'smart.creating': "Wird erstellt...",
  'smart.crafting': "{valetName} stellt deine Playlist zusammen...",
  'smart.crafting_sub': "Suche nach den perfekten Tracks, Sortierung für den besten Fluss",
  'smart.ella_acknowledged': "Danke! Ich habe deine Wünsche. Gib mir einen Moment, ich stelle deine Playlist zusammen.",
  'smart.no_playlists': "Noch keine Playlists",
  'smart.no_playlists_sub': "Bitte {valetName}, eine zu erstellen — beschreibe die Stimmung, den Moment, und lass sie deine perfekte musikalische Reise gestalten.",
  'smart.play_all': "Alle abspielen",
  'smart.talk_to_ella': "Diese Playlist bearbeiten",
  'smart.tell_change': "Sag {valetName}, was geändert werden soll...",
  'smart.fixing': "Wird gesendet...",
  'smart.ella_thinking': "{valetName} denkt nach...",
  'smart.changes_applied': "Das hat sich geändert",
  'smart.happy_with_this': "Zufrieden damit?",
  'smart.keep_changes': "Sieht gut aus",
  'smart.try_different': "Noch nicht ganz",
  'smart.rename': "Umbenennen",
  'smart.fix_it': "Senden",
  'smart.back': "Zurück",
  'smart.tracks': "Titel",
  'smart.min': "Min.",
  'smart.score': "Bewertung",
  'smart.match': "Übereinstimmung",
  'smart.refined': "verfeinert",
  'smart.listening': "Höre zu...",
  'smart.not_found': "Playlist nicht gefunden",
  'smart.error_generate': "Entschuldigung, da ist etwas schiefgelaufen. Könntest du es noch einmal versuchen?",
  'smart.loved': "Gefällt mir",
  'smart.disliked': "Nicht mein Geschmack",
  'smart.created': "Erstellt am {date}",
  'smart.revised': "Überarbeitet am {date}",
  'smart.save_to_library': "In Meine Playlists speichern",
  'smart.saved_to_library': "In Meine Playlists gespeichert",
  'smart.delete_or_replace': "Diesen Track löschen oder ersetzen?",
  'smart.delete_track': "Löschen",
  'smart.replace_track': "Ersetzen",
  'smart.edit_or_delete': "Was möchtest du mit diesem Track machen?",
  'smart.edit_track': "Bearbeiten",
  'smart.replace_ask': "Kein Problem. Was für einen Track hättest du stattdessen gern?",
  'smart.replace_working': "Ok, bin dran.",
  'smart.replace_done': "Sag mir, ob das passt.",
  'smart.add_to_my_playlists': "Zu meinen Playlists hinzufügen",
  'smart.added_to_playlists': "Hinzugefügt!",
  'smart.review_title': "Überprüfe deine Playlist",
  'smart.looks_good': "Sieht gut aus — abspielen!",
  'smart.send': "Senden",
  'smart.try_again': "Erneut versuchen",

  // ── Qobuz playlist import ──
  'qobuz.playlists.title': 'Qobuz-Playlists',
  'qobuz.playlists.description': 'Kopieren Sie Ihre Qobuz-Playlists in „Meine Playlists", damit Sie sie bearbeiten können und Maestro Ihren Geschmack kennenlernt.',
  'qobuz.playlists.refresh': 'Qobuz-Playlists aktualisieren',
  'qobuz.playlists.importing': 'Importiere…',
  'qobuz.playlists.complete': '{added} hinzugefügt, {updated} aktualisiert.',
  'qobuz.playlists.preservedEdited': '{n} in Maestro bearbeitete wurden beibehalten.',
  'qobuz.playlists.error': 'Import fehlgeschlagen.',
  // ── Station Tweaks ──
  'tweak_title': 'Sender Anpassen',
  'tweak_btn': 'Anpassen',
  'tweak_tune_btn': 'Tunen',
  'tweak_queue_btn': 'Warteschlange',
  'tweak_placeholder': 'Sag Ella, wie sie diesen Sender anpassen soll…',
  'tweak_examples_label': 'Probiere zum Beispiel:',
  'tweak_example_1': 'Keine Musik älter als 10 Jahre',
  'tweak_example_2': 'Mehr Geheimtipps, weniger Hits',
  'tweak_example_3': 'Halte es sanft und akustisch',
  'tweak_example_4': 'Mehr weibliche Stimmen',
  'fda.title': 'Maestro benötigt die Berechtigung, auf Ihre Musikbibliothek zuzugreifen',
  'fda.description': 'macOS hat die Dateizugriffsberechtigung von Maestro entfernt, wahrscheinlich nach dem letzten App-Update. Ihre Musikbibliothek ist in Ordnung — wir müssen nur den Zugriff erneut gewähren.',
  'fda.open_settings': 'Systemeinstellungen öffnen',
  'fda.recheck': 'Erledigt — erneut prüfen',
  'source_health.offline_disconnected': 'Offline seit {minutes} Min. — Laufwerk getrennt',
  'source_health.offline_timeout': 'Offline seit {minutes} Min. — langsame Antwort',
  'source_health.toast_offline': 'Diese Musik befindet sich auf \'{source_name}\', das derzeit offline ist. Verbinden Sie das Laufwerk erneut.',
  'source_health.toast_permission': 'Maestro kann \'{source_name}\' nicht lesen. Prüfen Sie die Ordnerberechtigungen.',
  'faq.title': 'Häufig gestellte Fragen',
  'faq.subtitle': 'Schnelle Antworten auf häufige Fragen',
  'faq.empty': 'Noch keine FAQs verfügbar.',
  'faq.loading': 'Wird geladen…',
  'support.message_paul': 'Nachricht an Paul',
  'support.goes_to': 'Geht direkt an paul@psaudio.com',
  'support.intro': 'Danke, dass du Teil des Maestro-Beta-Teams bist. Ich freue mich über Kommentare, Fehlerberichte und Ideen — jede Nachricht kommt direkt bei mir an.',
  'support.name': 'Name',
  'support.name_placeholder': 'Dein Name',
  'support.email': 'E-Mail',
  'support.email_placeholder': 'deine@email.de',
  'support.subject': 'Betreff',
  'support.subject_placeholder': 'Was hast du auf dem Herzen?',
  'support.message': 'Nachricht',
  'support.message_placeholder': 'Erzähl mir, was dich beschäftigt...',
  'support.platform': 'Plattform',
  'support.send': 'Nachricht senden',
  'support.sending': 'Wird gesendet…',
  'support.sent': 'Nachricht gesendet ({ticketId})! Du erhältst eine Bestätigungs-E-Mail und kannst unser Gespräch unten verfolgen.',
  'support.version': 'Version',
  'support.diagnostic.title': 'Diagnosemodus',
  'support.diagnostic.checking': 'Wird geprüft…',
  'support.diagnostic.state_a_body': 'Wenn der Maestro-Support Sie gebeten hat, die Diagnoseprotokollierung zu aktivieren, können Sie das hier tun. Verbindungsdetails werden mit unserem Team geteilt.',
  'support.diagnostic.contact_support': 'Support kontaktieren zum Aktivieren',
  'support.diagnostic.state_b_body_ticket': 'Diagnoseprotokollierung ist für Ihr Support-Ticket {ticket} verfügbar.',
  'support.diagnostic.state_b_body': 'Diagnoseprotokollierung ist verfügbar.',
  'support.diagnostic.state_c_instruction': 'Diagnosedaten werden erfasst. Nutzen Sie Maestro normal, bis das Problem auftritt, und senden Sie dann das Protokoll.',
  'support.diagnostic.available_expires': 'Verfügbar — läuft ab in {time}',
  'support.diagnostic.recording_expires': 'Aufnahme — läuft ab in {time}',
  'support.diagnostic.send_log': 'Protokoll senden',
  'support.diagnostic.sending': 'Wird gesendet…',
  'support.diagnostic.log_sent': 'Protokoll an Support gesendet',
  'support.diagnostic.reference': 'Referenz',
  'support.diagnostic.send_failed': 'Protokoll konnte nicht gesendet werden. Bitte erneut versuchen.',
  'support.diagnostic.expired': 'abgelaufen',
};

const it = {
  'nav.browse': 'Esplora',
  'nav.home': 'Home',
  'nav.settings': 'Impostazioni',
  'nav.genres': 'Generi',
  'nav.history': 'Cronologia',
  'nav.support': 'Supporto',
  'nav.devices': 'Dispositivi',
  'nav.prism': 'Prism DSP',
  'devices.title': 'Dispositivi',
  'devices.subtitle': 'Configura le tue zone audio',
  'nav.services': 'Servizi',
  'nav.playlists': 'Le mie Playlist',
  'nav.my_playlists': 'Le mie Playlist',
  'nav.favorites': 'Preferiti',
  'nav.audiophile': 'Demo Hi-Fi',
  'nav.genre_playlists': 'Stili',
  'nav.mood_playlists': 'Atmosfere',
  'nav.season_playlists': 'Stagioni',
  'nav.discover': 'Scopri',
  'nav.valet_picks': 'Scelte di {valetName}',
  'nav.trending': 'Tendenze',
  'nav.new_releases': 'Novità',
  'nav.community': 'Community',
  'nav.personalize': 'Personalizza',
  'nav.my_library': 'La mia Libreria',
  'nav.your_library': 'La tua Libreria',
  'nav.local_library': 'Libreria Locale',
  'nav.my_music': 'La mia Musica in Streaming',
  'nav.local_files': 'I Miei File Locali',
  'nav.tools': 'Strumenti',
  'nav.recently_played': 'Ascoltati di Recente',
  'nav.manage': 'Gestisci',
  'nav.local': 'Locale',
  'nav.albums': 'I miei Album',
  'nav.library': 'Libreria',
  'nav.artists': 'I miei Artisti',
  'nav.lib_playlists': 'Playlist',
  'nav.lib_albums': 'Album',
  'nav.lib_artists': 'Artisti',
  'nav.tracks': 'Brani',
  'nav.composers': 'Compositori',
  'nav.my_live_radio': 'La mia Radio Live',
  'nav.folders': 'Cartelle',
  'nav.standard': 'Standard',
  'nav.full_featured': 'Completo',
  'help.local_features': 'Libreria e Lettori di Rete',
  'trackMenu.removeFromPlaylist': 'Rimuovi dalla playlist',
  'trackMenu.playNow': 'Riproduci ora',
  'trackMenu.playNext': 'Riproduci dopo',
  'trackMenu.addToQueue': 'Aggiungi alla coda',
  'settings.dark_mode': 'Modalità Scura',
  'settings.dark_mode_desc': 'Passa dal tema chiaro a quello scuro',
  'settings.theme': 'Tema',
  'settings.theme_desc': 'Scegli il tuo stile visivo',
  'settings.theme_light': 'Chiaro',
  'settings.theme_dark': 'Scuro',
  'settings.theme_high_contrast': 'Alto Contrasto',
  'settings.display_size': 'Dimensione display',
  'settings.display_size_desc': 'Regola l\'interfaccia per il tuo schermo',
  'settings.size_small': 'Piccolo',
  'settings.size_default': 'Normale',
  'settings.size_large': 'Grande',
  'settings.size_xl': 'Molto grande',
  'home.jukebox_title': 'Il Jukebox di Ella',
  'home.jukebox_desc': '30 album che non ascolti da tempo, album per album',
  'home.jukebox_loading': 'Creazione della playlist...',
  'home.jukebox_loading_desc': 'Caricamento album e brani...',
  'settings.language': 'Lingua',
  'settings.language_desc': 'Scegli la lingua di visualizzazione',
  'settings.desktop_full': 'Maestro Connector',
  'settings.desktop_full_desc': 'NAS, lettori di rete, DSP',
  'settings.voice_search': 'Ricerca Vocale',
  'settings.voice_search_desc': 'Abilita il microfono per i comandi vocali',
  'settings.ella_voice': 'Voce di Ella',
  'settings.ella_voice_desc': 'Cosa succede alla tua musica quando Ella parla',
  'settings.ella_voice_duck': 'Abbassa',
  'settings.ella_voice_pause': 'Pausa',
  'settings.ella_voice_off': 'Spento',
  'settings.services': 'Servizi',
  'settings.account': 'Account',
  'settings.subscription': 'Abbonamento',
  'settings.quick_settings': 'Impostazioni Rapide',
  'settings.connected': 'Connesso',
  'settings.connect': 'Connetti',
  'settings.coming_soon': 'In arrivo',
  'settings.enabled': 'Abilitato',
  'settings.disabled': 'Disabilitato',
  'help.title': 'Come usare Maestro',
  'help.intro': 'Maestro è il tuo compagno musicale personale. Ecco tutto quello che devi sapere per sfruttarlo al meglio.',
  'help.getting_started': 'Per Iniziare',
  'help.playing_music': 'Riprodurre Musica',
  'help.streaming_services': 'Servizi di Streaming',
  'help.your_valet': 'Ella',
  'help.full_featured': 'Libreria e Lettori di Rete',
  'help.playlists_favorites': 'Playlist e Preferiti',
  'help.close': 'Chiudi guida',
  'help.footer': 'Hai bisogno di ulteriore aiuto? Vai su Impostazioni → Supporto Email per contattarci.',
  'help.home_label': 'Home',
  'help.home_desc': 'La tua pagina iniziale personalizzata con selezioni curate, ascolti recenti e nuove scoperte.',
  'help.settings_label': 'Impostazioni',
  'help.settings_desc': 'Tocca l\'icona dell\'ingranaggio nella barra laterale per connettere Qobuz, attivare la modalità scura e gestire il tuo abbonamento.',
  'help.search_label': 'Cerca',
  'help.search_desc': 'Tocca la lente di ingrandimento nell\'intestazione per cercare artisti, album, brani e playlist. La ricerca vocale è disponibile quando abilitata nelle Impostazioni.',
  'help.play_track_label': 'Riproduci un Brano',
  'help.play_track_desc': 'Naviga verso un album o una playlist e tocca un brano per avviare la riproduzione. Il mini player appare in basso.',
  'help.mini_player_label': 'Mini Player',
  'help.mini_player_desc': 'Mostra il brano corrente con play/pausa, salta, barra di avanzamento e volume. Tocca la copertina per vedere l\'album completo.',
  'help.queue_label': 'Coda',
  'help.queue_desc': 'Tieni premuto o fai clic destro su un brano per aggiungerlo alla coda. L\'icona della coda nel mini player mostra cosa segue.',
  'help.qobuz_label': 'Qobuz',
  'help.qobuz_desc': 'Connetti il tuo account Qobuz nelle Impostazioni per lo streaming ad alta risoluzione. Senza di esso, sentirai anteprime di 30 secondi.',
  'help.live_radio_label': 'Radio Live',
  'help.live_radio_desc': 'Attiva la Radio Live nelle Impostazioni per esplorare stazioni radio internet curate.',
  'help.octave_radio_label': 'Octave Radio',
  'help.octave_radio_desc': 'La stazione radio curata di Paul McGowan — attivala nelle Impostazioni.',
  'help.picks_label': 'Selezioni Personalizzate',
  'help.picks_desc': 'Il tuo valet impara i tuoi gusti nel tempo e suggerisce artisti, album e playlist su misura per te.',
  'help.chat_label': 'Chat',
  'help.chat_desc': 'Tocca l\'icona del valet per fare domande sulla musica, ottenere consigli o esplorare generi.',
  'help.trending_label': 'Tendenze e Novità',
  'help.trending_desc': 'Resta aggiornato con ciò che è popolare e le nuove uscite nella barra laterale sotto il nome del tuo valet.',
  'help.enable_label': 'Attiva',
  'help.enable_desc': 'Installa l\'app Maestro Connector per accedere alla navigazione NAS, alla selezione dei lettori di rete e ai controlli DSP.',
  'help.local_lib_label': 'Libreria Locale',
  'help.local_lib_desc': 'Esplora e riproduci file dal tuo NAS o archivio locale con Maestro Connector.',
  'help.renderers_label': 'Lettori di Rete',
  'help.renderers_desc': 'Scopri e riproduci su lettori UPnP/DLNA nella tua rete con Maestro Connector.',
  'help.favorites_label': 'Preferiti',
  'help.favorites_desc': 'Aggiungi un cuore a qualsiasi artista, album o brano per salvarlo nei tuoi Preferiti.',
  'help.playlists_label': 'Playlist',
  'help.playlists_desc': 'Esplora playlist curate per audiofili, genere, atmosfera e stagione — o crea le tue.',
  'help.search_pl_label': 'Cerca Playlist',
  'help.search_pl_desc': 'Usa l\'icona di ricerca accanto a "Playlist" nella barra laterale per trovare playlist specifiche per nome.',
  'search.placeholder': 'Cerca musica...',
  'search.voice_search': 'Ricerca vocale',
  'search.stop_listening': 'Smetti di ascoltare',
  'search.listening': 'In ascolto...',
  'search.top_result': 'Miglior risultato',
  'search.try_again': 'Riprova',
  'search.show_albums': 'Mostra album',
  'search.showing_results_for': 'Risultati per',
  'search.albums': 'Album',
  'search.artists': 'Artisti',
  'search.tracks': 'Brani',
  'search.all': 'Tutti',
  'search.playlists': 'Playlist',
  'search.failed': 'Ricerca fallita. Riprova.',
  'search.no_results': 'Nessun risultato trovato',
  'search.no_results_hint': 'Prova un altro termine o controlla i servizi collegati.',
  'search.empty_title': 'Cerca in tutti i tuoi servizi musicali',
  'search.empty_hint_voice': 'Parla o digita per trovare artisti, album e brani',
  'search.empty_hint': 'Digita per trovare artisti, album e brani',
  'search.back': 'Torna alla ricerca',
  'search.new_search': 'Nuova ricerca',
  'search.view_artist': 'Visualizza profilo completo',
  'player.this_computer': 'Audio di Sistema (beta)',
  'player.iphone': 'iPhone',
  'player.system_output': 'Uscita di Sistema',
  'player.audio_output': 'Uscita Audio',
  'player.playback_zone': 'Zona di Riproduzione',
  'player.scanning': 'Ricerca dispositivi...',
  'player.play': 'Riproduci',
  'player.pause': 'Pausa',
  'player.seek': 'Cerca',
  'player.volume': 'Volume',
  'player.queue': 'Coda',
  'player.output_device': 'Dispositivo di Uscita',
  'player.single_zone': 'Zona Singola',
  'player.multi_zone': 'Multi-Zona',
  'player.master': 'Master',
  'player.zone_volumes': 'Volume per Zona',
  'player.zones_active': '{count} Zone Attive',
  'player.select_two_zones': 'Seleziona 2 o più zone',
  'player.multi_zone_count': 'Multi-Zona ({count})',
  'player.multi_label': 'Multi',
  'player.playing_on': 'In riproduzione su {zone}',
  'player.network_renderers': 'Lettori di Rete',
  'player.find_my_dac': 'Non trovi il tuo DAC? Inserisci il suo indirizzo IP',
  'player.find_dac_title': 'Trova il Mio DAC',
  'player.find_dac_search': 'Cerca',
  'player.find_dac_searching': 'Ricerca...',
  'player.find_dac_found': 'Trovato',
  'player.find_dac_not_found': 'Nessun dispositivo trovato a questo IP',
  'player.find_dac_invalid_ip': 'Inserisci un indirizzo IP valido (es. 192.168.1.29)',
  'player.find_dac_hint': "Trova l'IP del tuo DAC sul suo display o nella lista dispositivi del router",
  'player.this_device': 'Audio di Sistema',
  'player.usb_dac': 'DAC USB',
  'player.usb_dac_connected': 'Connesso',
  'player.usb_dac_win_hint': 'Il DAC USB non viene visualizzato? Potrebbe essere necessario installare il driver del produttore.',
  'player.local_audio_outputs': 'Uscite audio locali',
  'player.change_output': 'Cambia...',
  'exclusive.format_error_title': 'Formato non supportato',
  'exclusive.switch_system_audio': 'Passa ad Audio di Sistema',
  'exclusive.bit_perfect': 'Bit-Perfect',
  'dsd.native_dsd_label': 'DSD nativo',
  'dsd.dop_supported': 'Sì (fino a {rate} via DoP)',
  'dsd.pcm_only': 'No (solo PCM)',
  'dsd.unknown_dac': 'DAC sconosciuto: predefinito PCM',
  'dsd.force_pcm': 'Forza PCM (disabilita DoP)',
  'dsd.force_pcm_hint': 'Riproduci DSD come PCM ad alta risoluzione',
  'common.continue': 'Continua',
  'common.skip': 'Salta',
  'common.skip_step': 'Salta questo passaggio',
  'common.cancel': 'Annulla',
  'common.save': 'Salva',
  'common.back': 'Indietro',
  'common.close': 'Chiudi',
  'common.search': 'Cerca',
  'common.menu': 'Menu',
  'common.home': 'Home',
  'common.help': 'Aiuto',
  'common.about': 'Informazioni su Maestro',
  'onboard.step_of': 'Passo {step} di {total}',
  'onboard.welcome_name': 'Benvenuto, {name}!',
  'onboard.welcome_generic': 'Benvenuto su Maestro!',
  'onboard.welcome_intro': 'Sono Paul McGowan, creatore di Maestro, e sono felice che tu sia qui.',
  'onboard.welcome_body': 'Maestro è qualcosa che ho sognato di costruire per anni — un compagno musicale bello da usare quanto la musica è bella da ascoltare. Insieme, trasformeremo il modo in cui scopri, gestisci e godi della tua musica.',
  'onboard.welcome_cta': 'Iniziare è facile — solo tre rapidi passaggi e sarai in ascolto.',
  'onboard.step1_title': 'Proteggi il tuo Account',
  'onboard.step1_desc': 'Scegli una password per proteggere la tua musica',
  'onboard.step2_title': 'Dicci cosa ti Piace',
  'onboard.step2_desc': 'Scegli generi e artisti così Maestro conosce i tuoi gusti',
  'onboard.step3_title': 'Connetti la tua Musica',
  'onboard.step3_desc': 'Collega Qobuz per lo streaming hi-res, o esplora con le anteprime',
  'onboard.all_set': 'Tutto pronto',
  'onboard.account_ready': 'Il tuo account è pronto.',
  'onboard.start_step1': 'Iniziamo con il Passo 1',
  'onboard.choose_password': 'Scegli una password per proteggere il tuo account.',
  'onboard.loading_account': 'Caricamento informazioni account…',
  'onboard.signed_in_as': 'Connesso come',
  'onboard.get_started': 'Inizia →',
  'onboard.label_email': 'Email',
  'onboard.label_password': 'Password',
  'onboard.label_confirm': 'Conferma Password',
  'onboard.label_phone': 'Numero di Cellulare',
  'onboard.phone_helper': 'Hai dimenticato la password? Nessun problema — ti invieremo un codice magico per rientrare.',
  'onboard.setting_up': 'Configurazione…',
  'onboard.error_password_length': 'La password deve contenere almeno 8 caratteri',
  'onboard.error_password_match': 'Le password non corrispondono',
  'onboard.choose_language': 'Scegli la tua lingua',
  'onboard.choose_language_desc': 'Puoi cambiarla in qualsiasi momento nelle Impostazioni.',
  'onboard.genre_title': 'Che musica ami?',
  'onboard.genre_desc': 'Scegli almeno 3. Ci aiuterà a trovare musica che ti piacerà.',
  'onboard.genre_hint_0': 'Scegli almeno 3 generi che ti piacciono',
  'onboard.genre_hint_few': '{count} selezionati — scegline altri {remaining}',
  'onboard.genre_hint_ready': '{count} selezionati — ottimo!',
  'onboard.genre_tap': 'Tocca i tuoi preferiti per iniziare',
  'onboard.streaming_title': 'Collega la tua musica',
  'onboard.streaming_desc': 'Maestro funziona meglio con un servizio di streaming, ma puoi esplorare con anteprime gratuite.',
  'onboard.favs_title': 'Scegli i tuoi preferiti',
  'onboard.favs_desc': 'Li useremo per personalizzare la tua schermata iniziale.',
  'onboard.complete_title': 'Tutto pronto!',
  'onboard.complete_desc': 'Maestro è pronto a dirigere la tua esperienza musicale perfetta.',
  'onboard.start_listening': 'Inizia ad Ascoltare →',
  'onboard.saving': 'Salvataggio delle preferenze…',
  'onboard.i_like_everything': 'Mi piace tutto',
  'onboard.almost_there': 'Ci siamo quasi!',
  'onboard.experience_maestro': 'Stai per scoprire Maestro!',
  'onboard.favs_hint_0': 'Scegli alcuni artisti che ami',
  'onboard.favs_hint_few': '{count} selezionati — scegline altri {remaining}',
  'onboard.favs_hint_ready': '{count} selezionati — ottimo gusto!',
  'onboard.almost_done': 'Quasi finito!',
  'onboard.preview_note': 'Sentirai anteprime di 30 secondi per ogni brano.\nCollega un servizio in qualsiasi momento per ascoltare brani interi.',
  'tour.skip': 'Salta il Tour',
  'tour.next': 'Avanti →',
  'tour.start_exploring': 'Inizia a Esplorare →',
  'tour.section_browse': 'Sfoglia',
  'tour.section_services': 'Servizi',
  'tour.section_valet': 'Ella',
  'tour.settings_title': 'Impostazioni',
  'tour.settings_body': 'Scegli i tuoi servizi di streaming, personalizza i colori del tema e gestisci il tuo abbonamento.',
  'tour.home_title': 'Home',
  'tour.home_body': 'La tua dashboard musicale personalizzata. Album, playlist e raccomandazioni basate sui tuoi gusti.',
  'tour.genres_title': 'Generi',
  'tour.genres_body': 'Esplora musica per genere. Scopri nuovi album in Jazz, Classica, Rock e altro.',
  'tour.qobuz_title': 'Qobuz',
  'tour.qobuz_body': 'Il tuo servizio di streaming hi-res. Milioni di brani in qualità straordinaria — o anteprime di 30 secondi.',
  'tour.valet_title': 'Scelte di Ella',
  'tour.valet_body': 'Il tuo valet musicale personale. Impara ciò che ami e suggerisce album che ti piaceranno. Più ascolti, meglio ti conosce.',
  'tour.radio_title': 'Radio dal Vivo',
  'tour.radio_body': 'Migliaia di stazioni da tutto il mondo, a portata di mano. Jazz, classica, musica del mondo e altro.',
  'tour.done_title': 'Buon Divertimento! 🎶',
  'tour.done_body': 'Sei pronto per esplorare. Scopri, ascolta e goditi la tua musica come mai prima.',

  // ── Smart Playlist ──
  'smart.title': "Le scelte di {valetName}",
  'smart.ask_ella': "Chiedi a {valetName}",
  'smart.tell_ella': "Di' a {valetName} cosa vorresti ascoltare",
  'smart.type_request': "Oppure scrivi la tua richiesta qui...",
  'smart.cancel': "Annulla",
  'smart.create': "Crea",
  'smart.creating': "Creazione...",
  'smart.crafting': "{valetName} sta preparando la tua playlist...",
  'smart.crafting_sub': "Ricerca dei brani perfetti, ordinamento per il miglior flusso",
  'smart.ella_acknowledged': "Grazie! Ho le tue indicazioni. Dammi un attimo per costruire la tua playlist.",
  'smart.no_playlists': "Nessuna playlist ancora",
  'smart.no_playlists_sub': "Chiedi a {valetName} di crearne una — descrivi l'atmosfera, il momento, e lascia che costruisca il tuo viaggio musicale perfetto.",
  'smart.play_all': "Riproduci tutto",
  'smart.talk_to_ella': "Modifica questa playlist",
  'smart.tell_change': "Di' a {valetName} cosa cambiare...",
  'smart.fixing': "Invio...",
  'smart.ella_thinking': "{valetName} sta pensando...",
  'smart.changes_applied': "Ecco cosa è cambiato",
  'smart.happy_with_this': "Ti piace così?",
  'smart.keep_changes': "Perfetto",
  'smart.try_different': "Non proprio",
  'smart.rename': "Rinomina",
  'smart.fix_it': "Invia",
  'smart.back': "Indietro",
  'smart.tracks': "brani",
  'smart.min': "min",
  'smart.score': "Punteggio",
  'smart.match': "corrispondenza",
  'smart.refined': "raffinata",
  'smart.listening': "Ascolto...",
  'smart.not_found': "Playlist non trovata",
  'smart.error_generate': "Mi dispiace, ho avuto problemi a prepararla. Puoi riprovare?",
  'smart.loved': "Adoro",
  'smart.disliked': "Non fa per me",
  'smart.created': "Creata il {date}",
  'smart.revised': "Rivista il {date}",
  'smart.save_to_library': "Salva nelle Mie Playlist",
  'smart.saved_to_library': "Salvata nelle Mie Playlist",
  'smart.delete_or_replace': "Eliminare o sostituire questo brano?",
  'smart.delete_track': "Elimina",
  'smart.replace_track': "Sostituisci",
  'smart.edit_or_delete': "Cosa vorresti fare con questo brano?",
  'smart.edit_track': "Modifica",
  'smart.replace_ask': "Nessun problema. Che tipo di brano vorresti al suo posto?",
  'smart.replace_working': "Ok, ci penso io.",
  'smart.replace_done': "Fammi sapere se è quello che volevi.",
  'smart.add_to_my_playlists': "Aggiungi alle Mie Playlist",
  'smart.added_to_playlists': "Aggiunto!",
  'smart.review_title': "Rivedi la tua playlist",
  'smart.looks_good': "Perfetto — riproduci!",
  'smart.send': "Invia",
  'smart.try_again': "Riprova",

  // ── Qobuz playlist import ──
  'qobuz.playlists.title': 'Playlist di Qobuz',
  'qobuz.playlists.description': 'Copia le tue playlist di Qobuz in Le mie playlist per poterle modificare e far sì che Maestro impari i tuoi gusti.',
  'qobuz.playlists.refresh': 'Aggiorna playlist Qobuz',
  'qobuz.playlists.importing': 'Importazione…',
  'qobuz.playlists.complete': '{added} aggiunte, {updated} aggiornate.',
  'qobuz.playlists.preservedEdited': '{n} modificate in Maestro sono state mantenute.',
  'qobuz.playlists.error': 'Importazione fallita.',
  // ── Station Tweaks ──
  'tweak_title': 'Modifica Stazione',
  'tweak_btn': 'Modifica',
  'tweak_tune_btn': 'Regola',
  'tweak_queue_btn': 'Coda',
  'tweak_placeholder': 'Dì a Ella come modificare questa stazione…',
  'tweak_examples_label': 'Prova qualcosa come:',
  'tweak_example_1': 'Niente musica più vecchia di 10 anni',
  'tweak_example_2': 'Più perle nascoste, meno successi',
  'tweak_example_3': 'Mantienilo morbido e acustico',
  'tweak_example_4': 'Aggiungi più voci femminili',
  'fda.title': 'Maestro ha bisogno del permesso per accedere alla tua libreria musicale',
  'fda.description': 'macOS ha rimosso il permesso di accesso ai file di Maestro, probabilmente dopo l\'ultimo aggiornamento. La tua libreria musicale è al sicuro — dobbiamo solo riautorizzare l\'accesso.',
  'fda.open_settings': 'Apri Impostazioni di Sistema',
  'fda.recheck': 'Fatto — ricontrolla',
  'source_health.offline_disconnected': 'Offline da {minutes} min — unità disconnessa',
  'source_health.offline_timeout': 'Offline da {minutes} min — risposta lenta',
  'source_health.toast_offline': 'Questa musica è su \'{source_name}\', attualmente offline. Riconnetti l\'unità e riprova.',
  'source_health.toast_permission': 'Maestro non riesce a leggere \'{source_name}\'. Verifica i permessi della cartella.',
  'faq.title': 'Domande Frequenti',
  'faq.subtitle': 'Risposte rapide alle domande comuni',
  'faq.empty': 'Nessuna FAQ disponibile al momento.',
  'faq.loading': 'Caricamento…',
  'support.message_paul': 'Scrivi a Paul',
  'support.goes_to': 'Va direttamente a paul@psaudio.com',
  'support.intro': 'Grazie per far parte del team Beta di Maestro. Mi piacerebbe ricevere i tuoi commenti, segnalazioni di bug e idee — ogni messaggio arriva direttamente a me.',
  'support.name': 'Nome',
  'support.name_placeholder': 'Il tuo nome',
  'support.email': 'Email',
  'support.email_placeholder': 'tua@email.com',
  'support.subject': 'Oggetto',
  'support.subject_placeholder': 'Cosa hai in mente?',
  'support.message': 'Messaggio',
  'support.message_placeholder': 'Dimmi cosa hai in mente...',
  'support.platform': 'Piattaforma',
  'support.send': 'Invia messaggio',
  'support.sending': 'Invio in corso…',
  'support.sent': 'Messaggio inviato ({ticketId})! Riceverai un\'email di conferma e potrai seguire la nostra conversazione qui sotto.',
  'support.version': 'Versione',
  'support.diagnostic.title': 'Modalità diagnostica',
  'support.diagnostic.checking': 'Verifica…',
  'support.diagnostic.state_a_body': 'Se il supporto Maestro ti ha chiesto di attivare la registrazione diagnostica, puoi farlo qui. Condivide i dettagli di connessione con il nostro team.',
  'support.diagnostic.contact_support': 'Contatta il supporto per attivare',
  'support.diagnostic.state_b_body_ticket': 'La registrazione diagnostica è disponibile per il ticket di supporto {ticket}.',
  'support.diagnostic.state_b_body': 'La registrazione diagnostica è disponibile.',
  'support.diagnostic.state_c_instruction': 'I dati diagnostici vengono acquisiti. Usa Maestro normalmente fino al problema, poi torna qui e invia il registro.',
  'support.diagnostic.available_expires': 'Disponibile — scade tra {time}',
  'support.diagnostic.recording_expires': 'Registrazione — scade tra {time}',
  'support.diagnostic.send_log': 'Invia registro',
  'support.diagnostic.sending': 'Invio…',
  'support.diagnostic.log_sent': 'Registro inviato al supporto',
  'support.diagnostic.reference': 'riferimento',
  'support.diagnostic.send_failed': 'Impossibile inviare il registro. Riprova.',
  'support.diagnostic.expired': 'scaduto',
};

const pt = {
  'nav.browse': 'Explorar',
  'nav.home': 'Início',
  'nav.settings': 'Configurações',
  'nav.genres': 'Gêneros',
  'nav.history': 'Histórico',
  'nav.support': 'Suporte',
  'nav.devices': 'Dispositivos',
  'nav.prism': 'Prism DSP',
  'devices.title': 'Dispositivos',
  'devices.subtitle': 'Configure suas zonas de áudio',
  'nav.services': 'Serviços',
  'nav.playlists': 'Minhas Playlists',
  'nav.my_playlists': 'Minhas Playlists',
  'nav.favorites': 'Favoritos',
  'nav.audiophile': 'Demos Hi-Fi',
  'nav.genre_playlists': 'Estilos',
  'nav.mood_playlists': 'Climas',
  'nav.season_playlists': 'Estações',
  'nav.discover': 'Descobrir',
  'nav.valet_picks': 'Escolhas de {valetName}',
  'nav.trending': 'Em Alta',
  'nav.new_releases': 'Lançamentos',
  'nav.community': 'Comunidade',
  'nav.personalize': 'Personalizar',
  'nav.my_library': 'Minha Biblioteca',
  'nav.your_library': 'Sua Biblioteca',
  'nav.local_library': 'Biblioteca Local',
  'nav.my_music': 'Minha Música em Streaming',
  'nav.local_files': 'Meus Arquivos Locais',
  'nav.tools': 'Ferramentas',
  'nav.recently_played': 'Tocados Recentemente',
  'nav.manage': 'Gerenciar',
  'nav.local': 'Local',
  'nav.albums': 'Meus Álbuns',
  'nav.library': 'Biblioteca',
  'nav.artists': 'Meus Artistas',
  'nav.lib_playlists': 'Playlists',
  'nav.lib_albums': 'Álbuns',
  'nav.lib_artists': 'Artistas',
  'nav.tracks': 'Faixas',
  'nav.composers': 'Compositores',
  'nav.my_live_radio': 'Minha Rádio ao Vivo',
  'nav.folders': 'Pastas',
  'nav.standard': 'Padrão',
  'nav.full_featured': 'Completo',
  'help.local_features': 'Biblioteca e Reprodutores de Rede',
  'trackMenu.removeFromPlaylist': 'Remover da playlist',
  'trackMenu.playNow': 'Reproduzir agora',
  'trackMenu.playNext': 'Reproduzir a seguir',
  'trackMenu.addToQueue': 'Adicionar à fila',
  'settings.dark_mode': 'Modo Escuro',
  'settings.dark_mode_desc': 'Alternar entre os temas claro e escuro',
  'settings.theme': 'Tema',
  'settings.theme_desc': 'Escolha seu estilo visual',
  'settings.theme_light': 'Claro',
  'settings.theme_dark': 'Escuro',
  'settings.theme_high_contrast': 'Alto Contraste',
  'settings.display_size': 'Tamanho da tela',
  'settings.display_size_desc': 'Ajuste a interface para sua tela',
  'settings.size_small': 'Pequeno',
  'settings.size_default': 'Normal',
  'settings.size_large': 'Grande',
  'settings.size_xl': 'Muito grande',
  'home.jukebox_title': 'A Jukebox da Ella',
  'home.jukebox_desc': '30 álbuns que você não ouve há muito tempo, álbum por álbum',
  'home.jukebox_loading': 'Criando sua playlist...',
  'home.jukebox_loading_desc': 'Carregando álbuns e faixas...',
  'settings.language': 'Idioma',
  'settings.language_desc': 'Escolha o idioma de exibição',
  'settings.desktop_full': 'Maestro Connector',
  'settings.desktop_full_desc': 'NAS, renderizadores de rede, DSP',
  'settings.voice_search': 'Busca por Voz',
  'settings.voice_search_desc': 'Ativar microfone para comandos de voz',
  'settings.ella_voice': 'Voz da Ella',
  'settings.ella_voice_desc': 'O que acontece com sua música quando Ella fala',
  'settings.ella_voice_duck': 'Baixar',
  'settings.ella_voice_pause': 'Pausar',
  'settings.ella_voice_off': 'Desligado',
  'settings.services': 'Serviços',
  'settings.account': 'Conta',
  'settings.subscription': 'Assinatura',
  'settings.quick_settings': 'Configurações Rápidas',
  'settings.connected': 'Conectado',
  'settings.connect': 'Conectar',
  'settings.coming_soon': 'Em breve',
  'settings.enabled': 'Ativado',
  'settings.disabled': 'Desativado',
  'help.title': 'Como usar o Maestro',
  'help.intro': 'O Maestro é o seu companheiro musical pessoal. Aqui está tudo o que você precisa saber para aproveitá-lo ao máximo.',
  'help.getting_started': 'Primeiros Passos',
  'help.playing_music': 'Reproduzindo Música',
  'help.streaming_services': 'Serviços de Streaming',
  'help.your_valet': 'Ella',
  'help.full_featured': 'Biblioteca e Reprodutores de Rede',
  'help.playlists_favorites': 'Playlists e Favoritos',
  'help.close': 'Fechar ajuda',
  'help.footer': 'Precisa de mais ajuda? Vá em Configurações → Suporte por Email para entrar em contato.',
  'help.home_label': 'Início',
  'help.home_desc': 'Sua página inicial personalizada com seleções curadas, reproduções recentes e novas descobertas.',
  'help.settings_label': 'Configurações',
  'help.settings_desc': 'Toque no ícone de engrenagem na barra lateral para conectar o Qobuz, alternar o modo escuro e gerenciar sua assinatura.',
  'help.search_label': 'Buscar',
  'help.search_desc': 'Toque na lupa no cabeçalho para buscar artistas, álbuns, faixas e playlists. A busca por voz está disponível quando ativada nas Configurações.',
  'help.play_track_label': 'Reproduzir uma Faixa',
  'help.play_track_desc': 'Navegue até um álbum ou playlist e toque em uma faixa para começar a reproduzir. O mini player aparece na parte inferior.',
  'help.mini_player_label': 'Mini Player',
  'help.mini_player_desc': 'Mostra a faixa atual com play/pausa, avançar, barra de progresso e volume. Toque na capa para ver o álbum completo.',
  'help.queue_label': 'Fila',
  'help.queue_desc': 'Mantenha pressionado ou clique com o botão direito em uma faixa para adicioná-la à fila. O ícone de fila no mini player mostra o que vem a seguir.',
  'help.qobuz_label': 'Qobuz',
  'help.qobuz_desc': 'Conecte sua conta Qobuz nas Configurações para streaming em alta resolução. Sem ela, você ouvirá prévias de 30 segundos.',
  'help.live_radio_label': 'Rádio ao Vivo',
  'help.live_radio_desc': 'Ative a Rádio ao Vivo nas Configurações para explorar estações de rádio pela internet curadas.',
  'help.octave_radio_label': 'Octave Radio',
  'help.octave_radio_desc': 'A estação de rádio curada de Paul McGowan — ative-a nas Configurações.',
  'help.picks_label': 'Seleções Personalizadas',
  'help.picks_desc': 'Seu valet aprende seus gostos ao longo do tempo e sugere artistas, álbuns e playlists feitos para você.',
  'help.chat_label': 'Chat',
  'help.chat_desc': 'Toque no ícone do valet para fazer perguntas sobre música, obter recomendações ou explorar gêneros.',
  'help.trending_label': 'Em Alta e Lançamentos',
  'help.trending_desc': 'Fique por dentro do que é popular e dos novos lançamentos na barra lateral sob o nome do seu valet.',
  'help.enable_label': 'Ativar',
  'help.enable_desc': 'Instale o app Maestro Connector para acessar navegação NAS, seleção de reprodutores de rede e controles DSP.',
  'help.local_lib_label': 'Biblioteca Local',
  'help.local_lib_desc': 'Navegue e reproduza arquivos do seu NAS ou armazenamento local com o Maestro Connector.',
  'help.renderers_label': 'Reprodutores de Rede',
  'help.renderers_desc': 'Descubra e reproduza em reprodutores UPnP/DLNA na sua rede com o Maestro Connector.',
  'help.favorites_label': 'Favoritos',
  'help.favorites_desc': 'Adicione um coração a qualquer artista, álbum ou faixa para salvá-lo nos seus Favoritos.',
  'help.playlists_label': 'Playlists',
  'help.playlists_desc': 'Explore playlists curadas para audiófilos, gênero, clima e estação — ou crie as suas.',
  'help.search_pl_label': 'Buscar Playlists',
  'help.search_pl_desc': 'Use o ícone de busca ao lado de "Playlists" na barra lateral para encontrar playlists específicas por nome.',
  'search.placeholder': 'Buscar música...',
  'search.voice_search': 'Busca por voz',
  'search.stop_listening': 'Parar de ouvir',
  'search.listening': 'Ouvindo...',
  'search.top_result': 'Melhor resultado',
  'search.try_again': 'Tentar novamente',
  'search.show_albums': 'Ver álbuns',
  'search.showing_results_for': 'Mostrando resultados para',
  'search.albums': 'Álbuns',
  'search.artists': 'Artistas',
  'search.tracks': 'Faixas',
  'search.all': 'Tudo',
  'search.playlists': 'Playlists',
  'search.failed': 'Busca falhou. Tente novamente.',
  'search.no_results': 'Nenhum resultado encontrado',
  'search.no_results_hint': 'Tente outro termo ou verifique seus serviços conectados.',
  'search.empty_title': 'Busque em todos os seus serviços de música',
  'search.empty_hint_voice': 'Fale ou digite para encontrar artistas, álbuns e faixas',
  'search.empty_hint': 'Digite para encontrar artistas, álbuns e faixas',
  'search.back': 'Voltar à pesquisa',
  'search.new_search': 'Nova pesquisa',
  'search.view_artist': 'Ver perfil completo',
  'player.this_computer': 'Áudio do Sistema (beta)',
  'player.iphone': 'iPhone',
  'player.system_output': 'Saída do Sistema',
  'player.audio_output': 'Saída de Áudio',
  'player.playback_zone': 'Zona de Reprodução',
  'player.scanning': 'Procurando dispositivos...',
  'player.play': 'Reproduzir',
  'player.pause': 'Pausar',
  'player.seek': 'Buscar',
  'player.volume': 'Volume',
  'player.queue': 'Fila',
  'player.output_device': 'Dispositivo de Saída',
  'player.single_zone': 'Zona Única',
  'player.multi_zone': 'Multi-Zona',
  'player.master': 'Mestre',
  'player.zone_volumes': 'Volumes por Zona',
  'player.zones_active': '{count} Zonas Ativas',
  'player.select_two_zones': 'Selecione 2 ou mais zonas',
  'player.multi_zone_count': 'Multi-Zona ({count})',
  'player.multi_label': 'Multi',
  'player.playing_on': 'Reproduzindo em {zone}',
  'player.network_renderers': 'Reprodutores de Rede',
  'player.find_my_dac': 'Não encontra seu DAC? Digite o endereço IP',
  'player.find_dac_title': 'Encontrar Meu DAC',
  'player.find_dac_search': 'Buscar',
  'player.find_dac_searching': 'Buscando...',
  'player.find_dac_found': 'Encontrado',
  'player.find_dac_not_found': 'Nenhum dispositivo encontrado neste IP',
  'player.find_dac_invalid_ip': 'Digite um endereço IP válido (ex. 192.168.1.29)',
  'player.find_dac_hint': 'Encontre o IP do seu DAC no visor dele ou na lista de dispositivos do roteador',
  'player.this_device': 'Áudio do Sistema',
  'player.usb_dac': 'DAC USB',
  'player.usb_dac_connected': 'Conectado',
  'player.usb_dac_win_hint': 'O DAC USB não aparece? Pode ser necessário instalar o driver do fabricante.',
  'player.local_audio_outputs': 'Saídas de áudio locais',
  'player.change_output': 'Alterar...',
  'exclusive.format_error_title': 'Formato não suportado',
  'exclusive.switch_system_audio': 'Mudar para Áudio do Sistema',
  'exclusive.bit_perfect': 'Bit-Perfect',
  'dsd.native_dsd_label': 'DSD nativo',
  'dsd.dop_supported': 'Sim (até {rate} via DoP)',
  'dsd.pcm_only': 'Não (apenas PCM)',
  'dsd.unknown_dac': 'DAC desconhecido: padrão PCM',
  'dsd.force_pcm': 'Forçar PCM (desativar DoP)',
  'dsd.force_pcm_hint': 'Reproduzir DSD como PCM de alta resolução',
  'common.continue': 'Continuar',
  'common.skip': 'Pular',
  'common.skip_step': 'Pular esta etapa',
  'common.cancel': 'Cancelar',
  'common.save': 'Salvar',
  'common.back': 'Voltar',
  'common.close': 'Fechar',
  'common.search': 'Buscar',
  'common.menu': 'Menu',
  'common.home': 'Início',
  'common.help': 'Ajuda',
  'common.about': 'Sobre o Maestro',
  'onboard.step_of': 'Passo {step} de {total}',
  'onboard.welcome_name': 'Bem-vindo, {name}!',
  'onboard.welcome_generic': 'Bem-vindo ao Maestro!',
  'onboard.welcome_intro': 'Sou Paul McGowan, criador do Maestro, e estou muito feliz por você estar aqui.',
  'onboard.welcome_body': 'O Maestro é algo que sonhei construir por anos — um companheiro musical tão bonito de usar quanto a música é de ouvir. Juntos, vamos transformar a forma como você descobre, gerencia e aprecia sua música.',
  'onboard.welcome_cta': 'Começar é fácil — apenas três passos rápidos e você estará ouvindo.',
  'onboard.step1_title': 'Proteja sua Conta',
  'onboard.step1_desc': 'Escolha uma senha para proteger sua música',
  'onboard.step2_title': 'Conte-nos o que você Ama',
  'onboard.step2_desc': 'Escolha gêneros e artistas para que o Maestro conheça seu gosto',
  'onboard.step3_title': 'Conecte sua Música',
  'onboard.step3_desc': 'Vincule o Qobuz para streaming hi-res, ou explore com prévias',
  'onboard.all_set': 'Tudo pronto',
  'onboard.account_ready': 'Sua conta está pronta.',
  'onboard.start_step1': 'Vamos começar com o Passo 1',
  'onboard.choose_password': 'Escolha uma senha para proteger sua conta.',
  'onboard.loading_account': 'Carregando informações da conta…',
  'onboard.signed_in_as': 'Conectado como',
  'onboard.get_started': 'Começar →',
  'onboard.label_email': 'Email',
  'onboard.label_password': 'Senha',
  'onboard.label_confirm': 'Confirmar Senha',
  'onboard.label_phone': 'Número de Celular',
  'onboard.phone_helper': 'Esqueceu sua senha? Sem problemas — enviaremos um código mágico para você entrar novamente.',
  'onboard.setting_up': 'Configurando…',
  'onboard.error_password_length': 'A senha deve ter pelo menos 8 caracteres',
  'onboard.error_password_match': 'As senhas não coincidem',
  'onboard.choose_language': 'Escolha seu idioma',
  'onboard.choose_language_desc': 'Você pode alterar a qualquer momento nas Configurações.',
  'onboard.genre_title': 'Que tipo de música você ama?',
  'onboard.genre_desc': 'Escolha pelo menos 3. Isso nos ajuda a encontrar músicas que você vai gostar.',
  'onboard.genre_hint_0': 'Escolha pelo menos 3 gêneros que você gosta',
  'onboard.genre_hint_few': '{count} selecionados — escolha mais {remaining}',
  'onboard.genre_hint_ready': '{count} selecionados — ótimo!',
  'onboard.genre_tap': 'Toque nos seus favoritos para começar',
  'onboard.streaming_title': 'Conecte sua música',
  'onboard.streaming_desc': 'O Maestro funciona melhor com um serviço de streaming, mas você pode explorar com prévias gratuitas.',
  'onboard.favs_title': 'Escolha seus favoritos',
  'onboard.favs_desc': 'Vamos usá-los para personalizar sua tela inicial.',
  'onboard.complete_title': 'Tudo pronto!',
  'onboard.complete_desc': 'O Maestro está pronto para conduzir sua experiência musical perfeita.',
  'onboard.start_listening': 'Começar a Ouvir →',
  'onboard.saving': 'Salvando suas preferências…',
  'onboard.i_like_everything': 'Gosto de tudo',
  'onboard.almost_there': 'Quase lá!',
  'onboard.experience_maestro': 'Você está prestes a conhecer o Maestro!',
  'onboard.favs_hint_0': 'Escolha alguns artistas que você ama',
  'onboard.favs_hint_few': '{count} selecionados — escolha mais {remaining}',
  'onboard.favs_hint_ready': '{count} selecionados — ótimo gosto!',
  'onboard.almost_done': 'Quase pronto!',
  'onboard.preview_note': 'Você ouvirá prévias de 30 segundos de cada faixa.\nConecte um serviço a qualquer momento para ouvir músicas inteiras.',
  'tour.skip': 'Pular Tour',
  'tour.next': 'Próximo →',
  'tour.start_exploring': 'Começar a Explorar →',
  'tour.section_browse': 'Navegar',
  'tour.section_services': 'Serviços',
  'tour.section_valet': 'Ella',
  'tour.settings_title': 'Configurações',
  'tour.settings_body': 'Escolha seus serviços de streaming, personalize as cores do tema e gerencie sua assinatura.',
  'tour.home_title': 'Início',
  'tour.home_body': 'Seu painel de música personalizado. Álbuns, playlists e recomendações baseadas no seu gosto.',
  'tour.genres_title': 'Gêneros',
  'tour.genres_body': 'Explore música por gênero. Descubra novos álbuns em Jazz, Clássico, Rock e mais.',
  'tour.qobuz_title': 'Qobuz',
  'tour.qobuz_body': 'Seu serviço de streaming hi-res. Milhões de faixas em qualidade incrível — ou prévias de 30 segundos.',
  'tour.valet_title': 'Escolhas de Ella',
  'tour.valet_body': 'Seu valet musical pessoal. Ele aprende o que você ama e sugere álbuns que você vai gostar. Quanto mais você ouve, melhor ele te conhece.',
  'tour.radio_title': 'Rádio ao Vivo',
  'tour.radio_body': 'Milhares de estações de todo o mundo, na ponta dos seus dedos. Jazz, clássico, música do mundo e mais.',
  'tour.done_title': 'Divirta-se! 🎶',
  'tour.done_body': 'Você está pronto para explorar. Descubra, ouça e aproveite sua música como nunca antes.',

  // ── Smart Playlist ──
  'smart.title': "Seleções de {valetName}",
  'smart.ask_ella': "Perguntar a {valetName}",
  'smart.tell_ella': "Diga a {valetName} o que você gostaria de ouvir",
  'smart.type_request': "Ou digite seu pedido aqui...",
  'smart.cancel': "Cancelar",
  'smart.create': "Criar",
  'smart.creating': "Criando...",
  'smart.crafting': "{valetName} está preparando sua playlist...",
  'smart.crafting_sub': "Encontrando as faixas perfeitas, organizando para o melhor fluxo",
  'smart.ella_acknowledged': "Obrigada! Recebi suas instruções. Me dá um minutinho para montar sua playlist.",
  'smart.no_playlists': "Nenhuma playlist ainda",
  'smart.no_playlists_sub': "Peça a {valetName} para criar uma — descreva o clima, o momento, e deixe que ela construa sua jornada musical perfeita.",
  'smart.play_all': "Reproduzir tudo",
  'smart.talk_to_ella': "Editar esta playlist",
  'smart.tell_change': "Diga a {valetName} o que mudar...",
  'smart.fixing': "Enviando...",
  'smart.ella_thinking': "{valetName} está pensando...",
  'smart.changes_applied': "Eis o que mudou",
  'smart.happy_with_this': "Ficou bom assim?",
  'smart.keep_changes': "Perfeito",
  'smart.try_different': "Não exatamente",
  'smart.rename': "Renomear",
  'smart.fix_it': "Enviar",
  'smart.back': "Voltar",
  'smart.tracks': "faixas",
  'smart.min': "min",
  'smart.score': "Pontuação",
  'smart.match': "compatibilidade",
  'smart.refined': "refinada",
  'smart.listening': "Ouvindo...",
  'smart.not_found': "Playlist não encontrada",
  'smart.error_generate': "Desculpe, tive dificuldade em preparar isso. Pode tentar novamente?",
  'smart.loved': "Adorei",
  'smart.disliked': "Não é pra mim",
  'smart.created': "Criada em {date}",
  'smart.revised': "Revisada em {date}",
  'smart.save_to_library': "Salvar em Minhas Playlists",
  'smart.saved_to_library': "Salva em Minhas Playlists",
  'smart.delete_or_replace': "Excluir ou substituir esta faixa?",
  'smart.delete_track': "Excluir",
  'smart.replace_track': "Substituir",
  'smart.edit_or_delete': "O que você gostaria de fazer com esta faixa?",
  'smart.edit_track': "Editar",
  'smart.replace_ask': "Sem problema. Que tipo de faixa você gostaria no lugar?",
  'smart.replace_working': "Ok, já vou.",
  'smart.replace_done': "Me diz se era isso que você queria.",
  'smart.add_to_my_playlists': "Adicionar às Minhas Playlists",
  'smart.added_to_playlists': "Adicionado!",
  'smart.review_title': "Revise sua playlist",
  'smart.looks_good': "Ficou ótimo — toca!",
  'smart.send': "Enviar",
  'smart.try_again': "Tentar novamente",

  // ── Qobuz playlist import ──
  'qobuz.playlists.title': 'Playlists do Qobuz',
  'qobuz.playlists.description': 'Copie as suas playlists do Qobuz para Minhas Playlists para poder editá-las e para o Maestro aprender o seu gosto.',
  'qobuz.playlists.refresh': 'Atualizar playlists do Qobuz',
  'qobuz.playlists.importing': 'Importando…',
  'qobuz.playlists.complete': '{added} adicionadas, {updated} atualizadas.',
  'qobuz.playlists.preservedEdited': '{n} editadas no Maestro foram preservadas.',
  'qobuz.playlists.error': 'A importação falhou.',
  // ── Station Tweaks ──
  'tweak_title': 'Ajustar Estação',
  'tweak_btn': 'Ajustar',
  'tweak_tune_btn': 'Afinar',
  'tweak_queue_btn': 'Fila',
  'tweak_placeholder': 'Diga à Ella como ajustar esta estação…',
  'tweak_examples_label': 'Tente algo como:',
  'tweak_example_1': 'Sem música com mais de 10 anos',
  'tweak_example_2': 'Mais raridades, menos sucessos',
  'tweak_example_3': 'Mantenha suave e acústico',
  'tweak_example_4': 'Adicione mais vozes femininas',
  'fda.title': 'Maestro precisa de permissão para acessar sua biblioteca musical',
  'fda.description': 'O macOS removeu a permissão de acesso a arquivos do Maestro, provavelmente após a última atualização. Sua biblioteca musical está segura — só precisamos conceder o acesso novamente.',
  'fda.open_settings': 'Abrir Configurações do Sistema',
  'fda.recheck': 'Feito — verificar novamente',
  'source_health.offline_disconnected': 'Offline há {minutes} min — unidade desconectada',
  'source_health.offline_timeout': 'Offline há {minutes} min — resposta lenta',
  'source_health.toast_offline': 'Esta música está em \'{source_name}\', que está offline. Reconecte a unidade e tente novamente.',
  'source_health.toast_permission': 'Maestro não consegue ler \'{source_name}\'. Verifique as permissões da pasta.',
  'faq.title': 'Perguntas Frequentes',
  'faq.subtitle': 'Respostas rápidas para perguntas comuns',
  'faq.empty': 'Nenhuma FAQ disponível ainda.',
  'faq.loading': 'Carregando…',
  'support.message_paul': 'Mensagem para Paul',
  'support.goes_to': 'Vai direto para paul@psaudio.com',
  'support.intro': 'Obrigado por fazer parte da equipe Beta do Maestro. Adoraria ouvir seus comentários, relatórios de bugs e ideias — cada mensagem chega diretamente a mim.',
  'support.name': 'Nome',
  'support.name_placeholder': 'Seu nome',
  'support.email': 'Email',
  'support.email_placeholder': 'seu@email.com',
  'support.subject': 'Assunto',
  'support.subject_placeholder': 'O que você tem em mente?',
  'support.message': 'Mensagem',
  'support.message_placeholder': 'Me conte o que está pensando...',
  'support.platform': 'Plataforma',
  'support.send': 'Enviar mensagem',
  'support.sending': 'Enviando…',
  'support.sent': 'Mensagem enviada ({ticketId})! Você receberá um email de confirmação e poderá acompanhar nossa conversa abaixo.',
  'support.version': 'Versão',
  'support.diagnostic.title': 'Modo de diagnóstico',
  'support.diagnostic.checking': 'A verificar…',
  'support.diagnostic.state_a_body': 'Se o suporte Maestro pediu para ativar o registo de diagnóstico, pode fazê-lo aqui. Partilha detalhes de ligação com a nossa equipa.',
  'support.diagnostic.contact_support': 'Contacte o suporte para ativar',
  'support.diagnostic.state_b_body_ticket': 'O registo de diagnóstico está disponível para o seu ticket {ticket}.',
  'support.diagnostic.state_b_body': 'O registo de diagnóstico está disponível.',
  'support.diagnostic.state_c_instruction': 'Os dados de diagnóstico estão a ser capturados. Use o Maestro normalmente até o problema ocorrer; depois volte aqui e envie o registo.',
  'support.diagnostic.available_expires': 'Disponível — expira em {time}',
  'support.diagnostic.recording_expires': 'A gravar — expira em {time}',
  'support.diagnostic.send_log': 'Enviar registo',
  'support.diagnostic.sending': 'A enviar…',
  'support.diagnostic.log_sent': 'Registo enviado ao suporte',
  'support.diagnostic.reference': 'referência',
  'support.diagnostic.send_failed': 'Não foi possível enviar o registo. Tente novamente.',
  'support.diagnostic.expired': 'expirado',
};

const ja = {
  'nav.browse': 'ブラウズ',
  'nav.home': 'ホーム',
  'nav.settings': '設定',
  'nav.genres': 'ジャンル',
  'nav.history': '履歴',
  'nav.support': 'サポート',
  'nav.devices': 'デバイス',
  'nav.prism': 'Prism DSP',
  'devices.title': 'デバイス',
  'devices.subtitle': 'オーディオゾーンを設定',
  'nav.services': 'サービス',
  'nav.playlists': 'マイプレイリスト',
  'nav.my_playlists': 'マイプレイリスト',
  'nav.favorites': 'お気に入り',
  'nav.audiophile': 'ハイエンドデモ',
  'nav.genre_playlists': 'スタイル',
  'nav.mood_playlists': 'ムード',
  'nav.season_playlists': '季節',
  'nav.discover': 'ディスカバー',
  'nav.valet_picks': '{valetName}のおすすめ',
  'nav.trending': 'トレンド',
  'nav.new_releases': '新着',
  'nav.community': 'コミュニティ',
  'nav.personalize': 'パーソナライズ',
  'nav.my_library': 'マイライブラリ',
  'nav.your_library': 'あなたのライブラリ',
  'nav.local_library': 'ローカルライブラリ',
  'nav.my_music': 'ストリーミング音楽',
  'nav.local_files': 'マイローカルファイル',
  'nav.tools': 'ツール',
  'nav.recently_played': '最近再生した曲',
  'nav.manage': '管理',
  'nav.local': 'ローカル',
  'nav.albums': 'マイアルバム',
  'nav.library': 'ライブラリ',
  'nav.artists': 'マイアーティスト',
  'nav.lib_playlists': 'プレイリスト',
  'nav.lib_albums': 'アルバム',
  'nav.lib_artists': 'アーティスト',
  'nav.tracks': 'トラック',
  'nav.composers': '作曲家',
  'nav.my_live_radio': 'マイライブラジオ',
  'nav.folders': 'フォルダ',
  'nav.standard': 'スタンダード',
  'nav.full_featured': 'フル機能',
  'help.local_features': 'ライブラリとネットワークプレーヤー',
  'trackMenu.removeFromPlaylist': 'プレイリストから削除',
  'trackMenu.playNow': '今すぐ再生',
  'trackMenu.playNext': '次に再生',
  'trackMenu.addToQueue': 'キューに追加',
  'settings.dark_mode': 'ダークモード',
  'settings.dark_mode_desc': 'ライトテーマとダークテーマを切り替える',
  'settings.theme': 'テーマ',
  'settings.theme_desc': 'ビジュアルスタイルを選択',
  'settings.theme_light': 'ライト',
  'settings.theme_dark': 'ダーク',
  'settings.theme_high_contrast': 'ハイコントラスト',
  'settings.display_size': '表示サイズ',
  'settings.display_size_desc': '画面に合わせてインターフェースを調整',
  'settings.size_small': '小',
  'settings.size_default': '標準',
  'settings.size_large': '大',
  'settings.size_xl': '特大',
  'home.jukebox_title': 'エラのジュークボックス',
  'home.jukebox_desc': 'しばらく聴いていない30枚のアルバムをアルバムごとに再生',
  'home.jukebox_loading': 'プレイリストを作成中...',
  'home.jukebox_loading_desc': 'アルバムとトラックを読み込み中...',
  'settings.language': '言語',
  'settings.language_desc': '表示言語を選択してください',
  'settings.desktop_full': 'Maestro Connector',
  'settings.desktop_full_desc': 'NASブラウジング、ネットワークレンダラー、DSP',
  'settings.voice_search': '音声検索',
  'settings.voice_search_desc': '音声コマンド用にマイクを有効にする',
  'settings.ella_voice': 'Ellaの声',
  'settings.ella_voice_desc': 'Ellaが話しているときの音楽の動作',
  'settings.ella_voice_duck': '小さく',
  'settings.ella_voice_pause': '一時停止',
  'settings.ella_voice_off': 'オフ',
  'settings.services': 'サービス',
  'settings.account': 'アカウント',
  'settings.subscription': 'サブスクリプション',
  'settings.quick_settings': 'クイック設定',
  'settings.connected': '接続済み',
  'settings.connect': '接続',
  'settings.coming_soon': '近日公開',
  'settings.enabled': '有効',
  'settings.disabled': '無効',
  'help.title': 'Maestroの使い方',
  'help.intro': 'Maestroはあなた専属の音楽コンパニオンです。最大限に活用するために知っておくべきことをご紹介します。',
  'help.getting_started': 'はじめに',
  'help.playing_music': '音楽を再生する',
  'help.streaming_services': 'ストリーミングサービス',
  'help.your_valet': 'あなたのバレー',
  'help.full_featured': 'ライブラリとネットワークプレーヤー',
  'help.playlists_favorites': 'プレイリストとお気に入り',
  'help.close': 'ヘルプを閉じる',
  'help.footer': 'さらにサポートが必要ですか？設定 → メールサポートからお問い合わせください。',
  'help.home_label': 'ホーム',
  'help.home_desc': 'おすすめの曲、最近の再生履歴、新しい発見が集まるパーソナライズされたホーム画面です。',
  'help.settings_label': '設定',
  'help.settings_desc': 'サイドバーの歯車アイコンをタップして、Qobuzの接続、ダークモードの切り替え、サブスクリプションの管理ができます。',
  'help.search_label': '検索',
  'help.search_desc': 'ヘッダーの虫めがねをタップして、アーティスト、アルバム、トラック、プレイリストを検索できます。設定で有効にすると音声検索も利用できます。',
  'help.play_track_label': 'トラックを再生',
  'help.play_track_desc': 'アルバムやプレイリストに移動してトラックをタップすると再生が始まります。ミニプレーヤーが画面下部に表示されます。',
  'help.mini_player_label': 'ミニプレーヤー',
  'help.mini_player_desc': '現在のトラックが再生/一時停止、スキップ、プログレスバー、音量とともに表示されます。アートワークをタップするとアルバム全体が表示されます。',
  'help.queue_label': 'キュー',
  'help.queue_desc': 'トラックを長押しまたは右クリックしてキューに追加できます。ミニプレーヤーのキューアイコンで次の曲を確認できます。',
  'help.qobuz_label': 'Qobuz',
  'help.qobuz_desc': '設定でQobuzアカウントを接続するとハイレゾストリーミングが利用できます。接続しない場合は30秒のプレビューが再生されます。',
  'help.live_radio_label': 'ライブラジオ',
  'help.live_radio_desc': '設定でライブラジオを有効にすると、厳選されたインターネットラジオ局を閲覧できます。',
  'help.octave_radio_label': 'Octave Radio',
  'help.octave_radio_desc': 'ポール・マクゴーワンが厳選したラジオ局です。設定で有効にしてください。',
  'help.picks_label': 'パーソナライズされたおすすめ',
  'help.picks_desc': 'あなたのバレーが好みを学習し、あなたに合ったアーティスト、アルバム、プレイリストを提案します。',
  'help.chat_label': 'チャット',
  'help.chat_desc': 'バレーアイコンをタップして、音楽について質問したり、おすすめをもらったり、ジャンルを探索できます。',
  'help.trending_label': 'トレンドと新着',
  'help.trending_desc': 'サイドバーのバレー名の下に、人気の曲や新着リリースが表示されます。',
  'help.enable_label': '有効にする',
  'help.enable_desc': 'Maestro Connectorアプリをインストールすると、NASブラウジング、ネットワークプレーヤー選択、DSPコントロールにアクセスできます。',
  'help.local_lib_label': 'ローカルライブラリ',
  'help.local_lib_desc': 'Maestro Connectorを使ってNASやローカルストレージのファイルを閲覧・再生できます。',
  'help.renderers_label': 'ネットワークプレーヤー',
  'help.renderers_desc': 'Maestro Connectorでネットワーク上のUPnP/DLNAプレーヤーを検出して再生できます。',
  'help.favorites_label': 'お気に入り',
  'help.favorites_desc': 'アーティスト、アルバム、トラックにハートをつけてお気に入りに保存し、すぐにアクセスできます。',
  'help.playlists_label': 'プレイリスト',
  'help.playlists_desc': 'オーディオファイル、ジャンル、ムード、季節の厳選プレイリストを閲覧したり、自分のプレイリストを作成できます。',
  'help.search_pl_label': 'プレイリスト検索',
  'help.search_pl_desc': 'サイドバーの「プレイリスト」横にある検索アイコンで、名前から特定のプレイリストを検索できます。',
  'search.placeholder': '音楽を検索...',
  'search.voice_search': '音声検索',
  'search.stop_listening': '聞き取りを停止',
  'search.listening': '聞き取り中...',
  'search.top_result': 'トップ結果',
  'search.try_again': 'もう一度',
  'search.show_albums': 'アルバムを表示',
  'search.showing_results_for': '検索結果:',
  'search.albums': 'アルバム',
  'search.artists': 'アーティスト',
  'search.tracks': 'トラック',
  'search.all': 'すべて',
  'search.playlists': 'プレイリスト',
  'search.failed': '検索に失敗しました。もう一度お試しください。',
  'search.no_results': '再生可能な結果が見つかりません',
  'search.no_results_hint': '別の検索語を試すか、接続されたサービスを確認してください。',
  'search.empty_title': 'すべての音楽サービスを横断検索',
  'search.empty_hint_voice': '話すか入力して、アーティスト、アルバム、トラックを検索',
  'search.empty_hint': '入力してアーティスト、アルバム、トラックを検索',
  'search.back': '検索に戻る',
  'search.new_search': '新しい検索',
  'search.view_artist': 'プロフィールを見る',
  'player.this_computer': 'システムオーディオ (ベータ)',
  'player.iphone': 'iPhone',
  'player.system_output': 'システム出力',
  'player.audio_output': 'オーディオ出力',
  'player.playback_zone': '再生ゾーン',
  'player.scanning': 'デバイスを検索中...',
  'player.play': '再生',
  'player.pause': '一時停止',
  'player.seek': 'シーク',
  'player.volume': '音量',
  'player.queue': 'キュー',
  'player.output_device': '出力デバイス',
  'player.single_zone': 'シングルゾーン',
  'player.multi_zone': 'マルチゾーン',
  'player.master': 'マスター',
  'player.zone_volumes': 'ゾーン音量',
  'player.zones_active': '{count}ゾーンがアクティブ',
  'player.select_two_zones': '2つ以上のゾーンを選択',
  'player.multi_zone_count': 'マルチゾーン ({count})',
  'player.multi_label': 'マルチ',
  'player.playing_on': '{zone}で再生中',
  'player.network_renderers': 'ネットワークプレーヤー',
  'player.find_my_dac': 'DACが見つかりませんか？IPアドレスを入力してください',
  'player.find_dac_title': 'DACを探す',
  'player.find_dac_search': '検索',
  'player.find_dac_searching': '検索中...',
  'player.find_dac_found': '見つかりました',
  'player.find_dac_not_found': 'このIPにデバイスが見つかりません',
  'player.find_dac_invalid_ip': '有効なIPアドレスを入力してください（例: 192.168.1.29）',
  'player.find_dac_hint': 'DACのIPアドレスはDACの画面またはルーターのデバイス一覧で確認できます',
  'player.this_device': 'システムオーディオ',
  'player.usb_dac': 'USB DAC',
  'player.usb_dac_connected': '接続済み',
  'player.usb_dac_win_hint': 'USB DACが表示されませんか？メーカーのドライバーのインストールが必要な場合があります。',
  'player.local_audio_outputs': 'ローカル音声出力',
  'player.change_output': '変更...',
  'exclusive.format_error_title': 'フォーマット非対応',
  'exclusive.switch_system_audio': 'システムオーディオに切替',
  'exclusive.bit_perfect': 'Bit-Perfect',
  'dsd.native_dsd_label': 'ネイティブDSD',
  'dsd.dop_supported': 'はい（{rate}までDoP対応）',
  'dsd.pcm_only': 'いいえ（PCMのみ）',
  'dsd.unknown_dac': '不明なDAC：PCMがデフォルト',
  'dsd.force_pcm': 'PCM強制（DoP無効）',
  'dsd.force_pcm_hint': 'DSDをハイレゾPCMとして再生',
  'common.continue': '続ける',
  'common.skip': 'スキップ',
  'common.skip_step': 'このステップをスキップ',
  'common.cancel': 'キャンセル',
  'common.save': '保存',
  'common.back': '戻る',
  'common.close': '閉じる',
  'common.search': '検索',
  'common.menu': 'メニュー',
  'common.home': 'ホーム',
  'common.help': 'ヘルプ',
  'common.about': 'Maestroについて',
  'onboard.step_of': 'ステップ {step} / {total}',
  'onboard.welcome_name': 'ようこそ、{name}さん！',
  'onboard.welcome_generic': 'Maestroへようこそ！',
  'onboard.welcome_intro': 'Maestroの創設者、ポール・マクゴーワンです。ご参加いただきとても嬉しいです。',
  'onboard.welcome_body': 'Maestroは長年夢見てきたもの — 音楽を聴くのと同じくらい美しく使える音楽コンパニオンです。一緒に、音楽の発見、管理、そして楽しみ方を変えていきましょう。',
  'onboard.welcome_cta': '始めるのは簡単です — たった3つのステップですぐに音楽を楽しめます。',
  'onboard.step1_title': 'アカウントを保護',
  'onboard.step1_desc': '音楽を守るパスワードを選んでください',
  'onboard.step2_title': 'お好みを教えてください',
  'onboard.step2_desc': 'Maestroがあなたの好みを知るために、ジャンルとアーティストを選んでください',
  'onboard.step3_title': '音楽を接続',
  'onboard.step3_desc': 'Qobuzを接続してハイレゾストリーミング、またはプレビューで探索',
  'onboard.all_set': '準備完了',
  'onboard.account_ready': 'アカウントの準備ができました。',
  'onboard.start_step1': 'ステップ1から始めましょう',
  'onboard.choose_password': 'アカウントを保護するパスワードを選んでください。',
  'onboard.loading_account': 'アカウント情報を読み込み中…',
  'onboard.signed_in_as': 'ログイン中：',
  'onboard.get_started': '始める →',
  'onboard.label_email': 'メールアドレス',
  'onboard.label_password': 'パスワード',
  'onboard.label_confirm': 'パスワード確認',
  'onboard.label_phone': '携帯電話番号',
  'onboard.phone_helper': 'パスワードを忘れましたか？ご心配なく — マジックコードをお送りしてログインできます。',
  'onboard.setting_up': '設定中…',
  'onboard.error_password_length': 'パスワードは8文字以上である必要があります',
  'onboard.error_password_match': 'パスワードが一致しません',
  'onboard.choose_language': '言語を選択してください',
  'onboard.choose_language_desc': '設定でいつでも変更できます。',
  'onboard.genre_title': 'どんな音楽が好きですか？',
  'onboard.genre_desc': '3つ以上選んでください。あなたが楽しめる音楽を見つけるのに役立ちます。',
  'onboard.genre_hint_0': '好きなジャンルを3つ以上選んでください',
  'onboard.genre_hint_few': '{count}つ選択済み — あと{remaining}つ選んでください',
  'onboard.genre_hint_ready': '{count}つ選択済み — いいですね！',
  'onboard.genre_tap': 'お気に入りをタップして始めましょう',
  'onboard.streaming_title': '音楽を接続しましょう',
  'onboard.streaming_desc': 'Maestroはストリーミングサービスと一緒に使うと最高ですが、無料プレビューでも楽しめます。',
  'onboard.favs_title': 'お気に入りを選んでください',
  'onboard.favs_desc': 'ホーム画面をパーソナライズするために使用します。',
  'onboard.complete_title': '準備完了！',
  'onboard.complete_desc': 'Maestroがあなたの完璧な音楽体験を指揮する準備ができました。',
  'onboard.start_listening': '聴き始める →',
  'onboard.saving': '設定を保存中…',
  'onboard.i_like_everything': '全部好きです',
  'onboard.almost_there': 'もう少しです！',
  'onboard.experience_maestro': 'まもなくMaestroを体験できます！',
  'onboard.favs_hint_0': '好きなアーティストを何人か選んでください',
  'onboard.favs_hint_few': '{count}人選択済み — あと{remaining}人選んでください',
  'onboard.favs_hint_ready': '{count}人選択済み — 素晴らしいセンスです！',
  'onboard.almost_done': 'もうすぐ完了です！',
  'onboard.preview_note': '各トラックの30秒プレビューが再生されます。\nいつでもサービスを接続してフルの曲を聴けます。',
  'tour.skip': 'ツアーをスキップ',
  'tour.next': '次へ →',
  'tour.start_exploring': '探索を始める →',
  'tour.section_browse': 'ブラウズ',
  'tour.section_services': 'サービス',
  'tour.section_valet': 'バレー',
  'tour.settings_title': '設定',
  'tour.settings_body': 'ストリーミングサービスの選択、テーマカラーのカスタマイズ、サブスクリプションの管理ができます。',
  'tour.home_title': 'ホーム',
  'tour.home_body': 'パーソナライズされた音楽ダッシュボード。あなたの好みに基づいたアルバム、プレイリスト、おすすめ。',
  'tour.genres_title': 'ジャンル',
  'tour.genres_body': 'ジャンル別に音楽を探索。ジャズ、クラシック、ロックなどで新しいアルバムを発見。',
  'tour.qobuz_title': 'Qobuz',
  'tour.qobuz_body': 'ハイレゾストリーミングサービス。数百万のトラックを驚異的な品質で — または30秒のプレビューで。',
  'tour.valet_title': 'バレーのおすすめ',
  'tour.valet_body': 'あなた専属の音楽バレー。好みを学習し、気に入るアルバムを提案します。聴けば聴くほど、あなたをよく知るようになります。',
  'tour.radio_title': 'ライブラジオ',
  'tour.radio_body': '世界中の何千もの放送局がすぐそこに。ジャズ、クラシック、ワールドミュージックなど。',
  'tour.done_title': '楽しんでください！🎶',
  'tour.done_body': '探索の準備ができました。これまでにない方法で音楽を発見し、聴き、楽しんでください。',

  // ── Smart Playlist ──
  'smart.title': "{valetName}のおすすめ",
  'smart.ask_ella': "{valetName}に聞く",
  'smart.tell_ella': "{valetName}に聴きたい音楽を伝えてください",
  'smart.type_request': "またはここにリクエストを入力...",
  'smart.cancel': "キャンセル",
  'smart.create': "作成",
  'smart.creating': "作成中...",
  'smart.crafting': "{valetName}がプレイリストを作成中...",
  'smart.crafting_sub': "最高のトラックを探し、流れを考えて並べています",
  'smart.ella_acknowledged': "ありがとう！リクエストを受け取りました。プレイリストを作るので少しお待ちくださいね。",
  'smart.no_playlists': "プレイリストはまだありません",
  'smart.no_playlists_sub': "{valetName}に作成をお願いしましょう — 気分やシーンを伝えて、あなたにぴったりの音楽の旅を作ってもらいましょう。",
  'smart.play_all': "すべて再生",
  'smart.talk_to_ella': "このプレイリストを編集",
  'smart.tell_change': "{valetName}に変更を伝えて...",
  'smart.fixing': "送信中...",
  'smart.ella_thinking': "{valetName}が考えています...",
  'smart.changes_applied': "変更点はこちらです",
  'smart.happy_with_this': "これでよろしいですか？",
  'smart.keep_changes': "いいですね",
  'smart.try_different': "もう少し",
  'smart.rename': "名前を変更",
  'smart.fix_it': "送信",
  'smart.back': "戻る",
  'smart.tracks': "曲",
  'smart.min': "分",
  'smart.score': "スコア",
  'smart.match': "一致",
  'smart.refined': "調整済み",
  'smart.listening': "聴いています...",
  'smart.not_found': "プレイリストが見つかりません",
  'smart.error_generate': "申し訳ありません、準備がうまくいきませんでした。もう一度お試しいただけますか？",
  'smart.loved': "お気に入り",
  'smart.disliked': "好みではない",
  'smart.created': "{date}に作成",
  'smart.revised': "{date}に改訂",
  'smart.save_to_library': "マイプレイリストに保存",
  'smart.saved_to_library': "マイプレイリストに保存済み",
  'smart.delete_or_replace': "このトラックを削除しますか、それとも置き換えますか？",
  'smart.delete_track': "削除",
  'smart.replace_track': "置き換え",
  'smart.edit_or_delete': "このトラックをどうしますか？",
  'smart.edit_track': "編集",
  'smart.replace_ask': "わかりました。代わりにどんな曲がいいですか？",
  'smart.replace_working': "了解、やりますね。",
  'smart.replace_done': "これでよかったか教えてくださいね。",
  'smart.add_to_my_playlists': "マイプレイリストに追加",
  'smart.added_to_playlists': "追加しました！",
  'smart.review_title': "プレイリストを確認",
  'smart.looks_good': "いいね — 再生！",
  'smart.send': "送信",
  'smart.try_again': "もう一度",

  // ── Qobuz playlist import ──
  'qobuz.playlists.title': 'Qobuzのプレイリスト',
  'qobuz.playlists.description': 'QobuzのプレイリストをMyプレイリストにコピーすれば、編集でき、Maestroがあなたの好みを学習します。',
  'qobuz.playlists.refresh': 'Qobuzプレイリストを更新',
  'qobuz.playlists.importing': 'インポート中…',
  'qobuz.playlists.complete': '{added}件追加、{updated}件更新しました。',
  'qobuz.playlists.preservedEdited': 'Maestroで編集した{n}件はそのまま保持されました。',
  'qobuz.playlists.error': 'インポートに失敗しました。',
  // ── Station Tweaks ──
  'tweak_title': 'ステーションを調整',
  'tweak_btn': '調整',
  'tweak_tune_btn': 'チューン',
  'tweak_queue_btn': 'キュー',
  'tweak_placeholder': 'ステーションの調整をEllaに伝えてください…',
  'tweak_examples_label': '例えば：',
  'tweak_example_1': '10年以上前の音楽は不要',
  'tweak_example_2': '隠れた名曲を多く、ヒット曲を少なく',
  'tweak_example_3': '穏やかでアコースティックに',
  'tweak_example_4': '女性ボーカルを増やして',
  'fda.title': 'Maestroが音楽ライブラリにアクセスする許可が必要です',
  'fda.description': 'macOSがMaestroのファイルアクセス許可を取り消しました（おそらく最後のアプリ更新後）。音楽ライブラリは問題ありません — アクセスを再度許可するだけです。',
  'fda.open_settings': 'システム設定を開く',
  'fda.recheck': '許可しました — 再確認',
  'source_health.offline_disconnected': '{minutes}分間オフライン — ドライブが切断されています',
  'source_health.offline_timeout': '{minutes}分間オフライン — 応答が遅い',
  'source_health.toast_offline': 'この音楽は現在オフラインの「{source_name}」にあります。ドライブを再接続してください。',
  'source_health.toast_permission': 'Maestroは「{source_name}」を読み取れません。フォルダの権限を確認してください。',
  'faq.title': 'よくある質問',
  'faq.subtitle': 'よくある質問への簡単な回答',
  'faq.empty': 'まだFAQはありません。',
  'faq.loading': '読み込み中…',
  'support.message_paul': 'Paulにメッセージ',
  'support.goes_to': 'paul@psaudio.comに直接届きます',
  'support.intro': 'Maestroベータチームの一員としてご参加いただきありがとうございます。コメント、バグ報告、アイデアをお聞かせください — すべてのメッセージが直接私に届きます。',
  'support.name': '名前',
  'support.name_placeholder': 'お名前',
  'support.email': 'メール',
  'support.email_placeholder': 'your@email.com',
  'support.subject': '件名',
  'support.subject_placeholder': 'お問い合わせ内容は？',
  'support.message': 'メッセージ',
  'support.message_placeholder': 'お気軽にお書きください...',
  'support.platform': 'プラットフォーム',
  'support.send': 'メッセージを送信',
  'support.sending': '送信中…',
  'support.sent': 'メッセージが送信されました（{ticketId}）！確認メールが届きます。以下で会話を追跡できます。',
  'support.version': 'バージョン',
  'support.diagnostic.title': '診断モード',
  'support.diagnostic.checking': '確認中…',
  'support.diagnostic.state_a_body': 'Maestroサポートから診断ログの有効化を依頼された場合、ここで有効にできます。接続情報がチームと共有され、問題の調査に役立ちます。',
  'support.diagnostic.contact_support': '有効化するにはサポートへ連絡',
  'support.diagnostic.state_b_body_ticket': 'サポートチケット {ticket} 向けに診断ログが利用できます。',
  'support.diagnostic.state_b_body': '診断ログが利用できます。',
  'support.diagnostic.state_c_instruction': '診断データを記録中です。問題が起きるまで通常どおりMaestroをご利用ください。その後、ここに戻りログを送信してください。',
  'support.diagnostic.available_expires': '利用可能 — 残り {time}',
  'support.diagnostic.recording_expires': '記録中 — 残り {time}',
  'support.diagnostic.send_log': 'ログを送信',
  'support.diagnostic.sending': '送信中…',
  'support.diagnostic.log_sent': 'ログをサポートに送信しました',
  'support.diagnostic.reference': '参照',
  'support.diagnostic.send_failed': 'ログを送信できませんでした。もう一度お試しください。',
  'support.diagnostic.expired': '期限切れ',
};

const ko = {
  'nav.browse': '탐색',
  'nav.home': '홈',
  'nav.settings': '설정',
  'nav.genres': '장르',
  'nav.history': '기록',
  'nav.support': '지원',
  'nav.devices': '장치',
  'nav.prism': 'Prism DSP',
  'devices.title': '장치',
  'devices.subtitle': '오디오 존 설정',
  'nav.services': '서비스',
  'nav.playlists': '내 플레이리스트',
  'nav.my_playlists': '내 플레이리스트',
  'nav.favorites': '즐겨찾기',
  'nav.audiophile': '하이엔드 데모 음악',
  'nav.genre_playlists': '스타일',
  'nav.mood_playlists': '분위기',
  'nav.season_playlists': '계절',
  'nav.discover': '발견',
  'nav.valet_picks': '{valetName}의 추천',
  'nav.trending': '트렌드',
  'nav.new_releases': '신규 발매',
  'nav.community': '커뮤니티',
  'nav.personalize': '개인화',
  'nav.my_library': '내 라이브러리',
  'nav.your_library': '내 라이브러리',
  'nav.local_library': '로컬 라이브러리',
  'nav.my_music': '내 스트리밍 음악',
  'nav.local_files': '내 로컬 파일',
  'nav.tools': '도구',
  'nav.recently_played': '최근 재생',
  'nav.manage': '관리',
  'nav.local': '로컬',
  'nav.albums': '내 앨범',
  'nav.library': '라이브러리',
  'nav.artists': '내 아티스트',
  'nav.lib_playlists': '플레이리스트',
  'nav.lib_albums': '앨범',
  'nav.lib_artists': '아티스트',
  'nav.tracks': '트랙',
  'nav.composers': '작곡가',
  'nav.my_live_radio': '내 라이브 라디오',
  'nav.folders': '폴더',
  'nav.standard': '스탠다드',
  'nav.full_featured': '전체 기능',
  'help.local_features': '라이브러리 및 네트워크 플레이어',
  'trackMenu.removeFromPlaylist': '재생 목록에서 삭제',
  'trackMenu.playNow': '지금 재생',
  'trackMenu.playNext': '다음에 재생',
  'trackMenu.addToQueue': '대기열에 추가',
  'settings.dark_mode': '다크 모드',
  'settings.dark_mode_desc': '라이트 테마와 다크 테마를 전환합니다',
  'settings.theme': '테마',
  'settings.theme_desc': '시각적 스타일을 선택하세요',
  'settings.theme_light': '라이트',
  'settings.theme_dark': '다크',
  'settings.theme_high_contrast': '고대비',
  'settings.display_size': '화면 크기',
  'settings.display_size_desc': '화면에 맞게 인터페이스를 조정합니다',
  'settings.size_small': '작게',
  'settings.size_default': '기본',
  'settings.size_large': '크게',
  'settings.size_xl': '매우 크게',
  'home.jukebox_title': '엘라의 주크박스',
  'home.jukebox_desc': '오랫동안 듣지 않은 30장의 앨범을 앨범 단위로 재생',
  'home.jukebox_loading': '플레이리스트 만드는 중...',
  'home.jukebox_loading_desc': '앨범과 트랙을 불러오는 중...',
  'settings.language': '언어',
  'settings.language_desc': '표시 언어를 선택하세요',
  'settings.desktop_full': 'Maestro Connector',
  'settings.desktop_full_desc': 'NAS 탐색, 네트워크 렌더러, DSP',
  'settings.voice_search': '음성 검색',
  'settings.voice_search_desc': '음성 명령을 위해 마이크를 활성화합니다',
  'settings.ella_voice': 'Ella 음성',
  'settings.ella_voice_desc': 'Ella가 말할 때 음악에 적용되는 동작',
  'settings.ella_voice_duck': '줄이기',
  'settings.ella_voice_pause': '일시정지',
  'settings.ella_voice_off': '끄기',
  'settings.services': '서비스',
  'settings.account': '계정',
  'settings.subscription': '구독',
  'settings.quick_settings': '빠른 설정',
  'settings.connected': '연결됨',
  'settings.connect': '연결',
  'settings.coming_soon': '곧 출시',
  'settings.enabled': '활성화됨',
  'settings.disabled': '비활성화됨',
  'help.title': 'Maestro 사용법',
  'help.intro': 'Maestro는 당신만의 음악 동반자입니다. 최대한 활용하기 위해 알아야 할 모든 것을 소개합니다.',
  'help.getting_started': '시작하기',
  'help.playing_music': '음악 재생',
  'help.streaming_services': '스트리밍 서비스',
  'help.your_valet': '나의 발레',
  'help.full_featured': '라이브러리 및 네트워크 플레이어',
  'help.playlists_favorites': '플레이리스트와 즐겨찾기',
  'help.close': '도움말 닫기',
  'help.footer': '추가 도움이 필요하신가요? 설정 → 이메일 지원에서 연락해 주세요.',
  'help.home_label': '홈',
  'help.home_desc': '큐레이션된 추천, 최근 재생 기록, 새로운 발견이 모인 맞춤형 홈 화면입니다.',
  'help.settings_label': '설정',
  'help.settings_desc': '사이드바의 톱니바퀴 아이콘을 탭하여 Qobuz 연결, 다크 모드 전환, 구독 관리를 할 수 있습니다.',
  'help.search_label': '검색',
  'help.search_desc': '헤더의 돋보기를 탭하여 아티스트, 앨범, 트랙, 플레이리스트를 검색하세요. 설정에서 활성화하면 음성 검색도 사용할 수 있습니다.',
  'help.play_track_label': '트랙 재생',
  'help.play_track_desc': '앨범이나 플레이리스트로 이동하여 트랙을 탭하면 재생이 시작됩니다. 미니 플레이어가 하단에 표시됩니다.',
  'help.mini_player_label': '미니 플레이어',
  'help.mini_player_desc': '재생/일시정지, 건너뛰기, 진행 바, 볼륨과 함께 현재 트랙을 표시합니다. 앨범 아트를 탭하면 전체 앨범을 볼 수 있습니다.',
  'help.queue_label': '대기열',
  'help.queue_desc': '트랙을 길게 누르거나 우클릭하여 대기열에 추가하세요. 미니 플레이어의 대기열 아이콘에서 다음 곡을 확인할 수 있습니다.',
  'help.qobuz_label': 'Qobuz',
  'help.qobuz_desc': '설정에서 Qobuz 계정을 연결하면 고해상도 스트리밍을 이용할 수 있습니다. 연결하지 않으면 30초 미리듣기가 재생됩니다.',
  'help.live_radio_label': '라이브 라디오',
  'help.live_radio_desc': '설정에서 라이브 라디오를 활성화하면 큐레이션된 인터넷 라디오 방송을 탐색할 수 있습니다.',
  'help.octave_radio_label': 'Octave Radio',
  'help.octave_radio_desc': '폴 맥고완이 큐레이션한 라디오 채널입니다. 설정에서 활성화하세요.',
  'help.picks_label': '맞춤 추천',
  'help.picks_desc': '발레가 시간이 지나면서 당신의 취향을 학습하여 맞춤형 아티스트, 앨범, 플레이리스트를 추천합니다.',
  'help.chat_label': '채팅',
  'help.chat_desc': '발레 아이콘을 탭하여 음악에 대해 질문하거나 추천을 받거나 장르를 탐색하세요.',
  'help.trending_label': '트렌드와 신규 발매',
  'help.trending_desc': '사이드바의 발레 이름 아래에서 인기 음악과 신규 발매를 확인하세요.',
  'help.enable_label': '활성화',
  'help.enable_desc': 'Maestro Connector 앱을 설치하면 NAS 탐색, 네트워크 플레이어 선택, DSP 제어에 액세스할 수 있습니다.',
  'help.local_lib_label': '로컬 라이브러리',
  'help.local_lib_desc': 'Maestro Connector로 NAS나 로컬 저장소의 파일을 탐색하고 재생할 수 있습니다.',
  'help.renderers_label': '네트워크 플레이어',
  'help.renderers_desc': 'Maestro Connector로 네트워크의 UPnP/DLNA 플레이어를 검색하고 재생할 수 있습니다.',
  'help.favorites_label': '즐겨찾기',
  'help.favorites_desc': '아티스트, 앨범, 트랙에 하트를 눌러 즐겨찾기에 저장하고 빠르게 액세스하세요.',
  'help.playlists_label': '플레이리스트',
  'help.playlists_desc': '오디오파일, 장르, 분위기, 계절별 큐레이션 플레이리스트를 탐색하거나 직접 만드세요.',
  'help.search_pl_label': '플레이리스트 검색',
  'help.search_pl_desc': '사이드바의 "플레이리스트" 옆 검색 아이콘으로 이름으로 특정 플레이리스트를 검색하세요.',
  'search.placeholder': '음악 검색...',
  'search.voice_search': '음성 검색',
  'search.stop_listening': '듣기 중지',
  'search.listening': '듣는 중...',
  'search.top_result': '최고 결과',
  'search.try_again': '다시 시도',
  'search.show_albums': '앨범 보기',
  'search.showing_results_for': '검색 결과:',
  'search.albums': '앨범',
  'search.artists': '아티스트',
  'search.tracks': '트랙',
  'search.all': '전체',
  'search.playlists': '플레이리스트',
  'search.failed': '검색에 실패했습니다. 다시 시도해 주세요.',
  'search.no_results': '재생 가능한 결과를 찾을 수 없습니다',
  'search.no_results_hint': '다른 검색어를 시도하거나 연결된 서비스를 확인해 주세요.',
  'search.empty_title': '모든 음악 서비스에서 검색하세요',
  'search.empty_hint_voice': '말하거나 입력하여 아티스트, 앨범, 트랙을 찾으세요',
  'search.empty_hint': '입력하여 아티스트, 앨범, 트랙을 찾으세요',
  'search.back': '검색으로 돌아가기',
  'search.new_search': '새 검색',
  'search.view_artist': '전체 프로필 보기',
  'player.this_computer': '시스템 오디오 (베타)',
  'player.iphone': 'iPhone',
  'player.system_output': '시스템 출력',
  'player.audio_output': '오디오 출력',
  'player.playback_zone': '재생 존',
  'player.scanning': '기기 검색 중...',
  'player.play': '재생',
  'player.pause': '일시정지',
  'player.seek': '탐색',
  'player.volume': '볼륨',
  'player.queue': '대기열',
  'player.output_device': '출력 기기',
  'player.single_zone': '단일 존',
  'player.multi_zone': '멀티 존',
  'player.master': '마스터',
  'player.zone_volumes': '존 볼륨',
  'player.zones_active': '{count}개 존 활성',
  'player.select_two_zones': '2개 이상의 존을 선택하세요',
  'player.multi_zone_count': '멀티 존 ({count})',
  'player.multi_label': '멀티',
  'player.playing_on': '{zone}에서 재생 중',
  'player.network_renderers': '네트워크 플레이어',
  'player.find_my_dac': 'DAC를 찾을 수 없나요? IP 주소를 입력하세요',
  'player.find_dac_title': 'DAC 찾기',
  'player.find_dac_search': '검색',
  'player.find_dac_searching': '검색 중...',
  'player.find_dac_found': '발견됨',
  'player.find_dac_not_found': '이 IP에서 기기를 찾을 수 없습니다',
  'player.find_dac_invalid_ip': '유효한 IP 주소를 입력하세요 (예: 192.168.1.29)',
  'player.find_dac_hint': 'DAC의 IP 주소는 DAC 화면이나 라우터의 기기 목록에서 확인할 수 있습니다',
  'player.this_device': '시스템 오디오',
  'player.usb_dac': 'USB DAC',
  'player.usb_dac_connected': '연결됨',
  'player.usb_dac_win_hint': 'USB DAC가 표시되지 않나요? 제조사 드라이버를 설치해야 할 수 있습니다.',
  'player.local_audio_outputs': '로컬 오디오 출력',
  'player.change_output': '변경...',
  'exclusive.format_error_title': '지원되지 않는 형식',
  'exclusive.switch_system_audio': '시스템 오디오로 전환',
  'exclusive.bit_perfect': 'Bit-Perfect',
  'dsd.native_dsd_label': '네이티브 DSD',
  'dsd.dop_supported': '예 ({rate}까지 DoP 지원)',
  'dsd.pcm_only': '아니오 (PCM만 지원)',
  'dsd.unknown_dac': '알 수 없는 DAC: PCM 기본값',
  'dsd.force_pcm': 'PCM 강제 (DoP 비활성화)',
  'dsd.force_pcm_hint': 'DSD를 고해상도 PCM으로 재생',
  'common.continue': '계속',
  'common.skip': '건너뛰기',
  'common.skip_step': '이 단계 건너뛰기',
  'common.cancel': '취소',
  'common.save': '저장',
  'common.back': '뒤로',
  'common.close': '닫기',
  'common.search': '검색',
  'common.menu': '메뉴',
  'common.home': '홈',
  'common.help': '도움말',
  'common.about': 'Maestro 소개',
  'onboard.step_of': '단계 {step} / {total}',
  'onboard.welcome_name': '환영합니다, {name}님!',
  'onboard.welcome_generic': 'Maestro에 오신 것을 환영합니다!',
  'onboard.welcome_intro': '저는 Maestro의 창시자 폴 맥고완입니다. 함께하게 되어 정말 기쁩니다.',
  'onboard.welcome_body': 'Maestro는 오랫동안 꿈꿔온 것입니다 — 음악을 듣는 것만큼 아름답게 사용할 수 있는 음악 동반자입니다. 함께 음악을 발견하고, 관리하고, 즐기는 방식을 변화시켜 나가겠습니다.',
  'onboard.welcome_cta': '시작은 간단합니다 — 세 가지 빠른 단계만 거치면 바로 음악을 들을 수 있습니다.',
  'onboard.step1_title': '계정 보호',
  'onboard.step1_desc': '음악을 보호할 비밀번호를 선택하세요',
  'onboard.step2_title': '좋아하는 것을 알려주세요',
  'onboard.step2_desc': 'Maestro가 당신의 취향을 알 수 있도록 장르와 아티스트를 선택하세요',
  'onboard.step3_title': '음악 연결',
  'onboard.step3_desc': 'Qobuz를 연결하여 고해상도 스트리밍, 또는 미리보기로 탐색',
  'onboard.all_set': '모든 준비 완료',
  'onboard.account_ready': '계정이 준비되었습니다.',
  'onboard.start_step1': '1단계부터 시작하겠습니다',
  'onboard.choose_password': '계정을 보호할 비밀번호를 선택하세요.',
  'onboard.loading_account': '계정 정보를 불러오는 중…',
  'onboard.signed_in_as': '로그인 중:',
  'onboard.get_started': '시작하기 →',
  'onboard.label_email': '이메일',
  'onboard.label_password': '비밀번호',
  'onboard.label_confirm': '비밀번호 확인',
  'onboard.label_phone': '휴대폰 번호',
  'onboard.phone_helper': '비밀번호를 잊으셨나요? 걱정 마세요 — 매직 코드를 보내드려 다시 로그인할 수 있습니다.',
  'onboard.setting_up': '설정 중…',
  'onboard.error_password_length': '비밀번호는 최소 8자 이상이어야 합니다',
  'onboard.error_password_match': '비밀번호가 일치하지 않습니다',
  'onboard.choose_language': '언어를 선택하세요',
  'onboard.choose_language_desc': '설정에서 언제든 변경할 수 있습니다.',
  'onboard.genre_title': '어떤 음악을 좋아하세요?',
  'onboard.genre_desc': '3개 이상 선택하세요. 좋아할 만한 음악을 찾는 데 도움이 됩니다.',
  'onboard.genre_hint_0': '좋아하는 장르를 3개 이상 선택하세요',
  'onboard.genre_hint_few': '{count}개 선택됨 — {remaining}개 더 선택하세요',
  'onboard.genre_hint_ready': '{count}개 선택됨 — 좋습니다!',
  'onboard.genre_tap': '좋아하는 것을 탭하여 시작하세요',
  'onboard.streaming_title': '음악을 연결하세요',
  'onboard.streaming_desc': 'Maestro는 스트리밍 서비스와 함께 사용할 때 가장 좋지만, 무료 미리듣기로도 탐색할 수 있습니다.',
  'onboard.favs_title': '좋아하는 것을 선택하세요',
  'onboard.favs_desc': '홈 화면을 맞춤 설정하는 데 사용됩니다.',
  'onboard.complete_title': '준비 완료!',
  'onboard.complete_desc': 'Maestro가 당신의 완벽한 음악 경험을 지휘할 준비가 되었습니다.',
  'onboard.start_listening': '듣기 시작 →',
  'onboard.saving': '설정 저장 중…',
  'onboard.i_like_everything': '다 좋아해요',
  'onboard.almost_there': '거의 다 됐어요!',
  'onboard.experience_maestro': '곧 Maestro를 경험하게 됩니다!',
  'onboard.favs_hint_0': '좋아하는 아티스트를 몇 명 선택하세요',
  'onboard.favs_hint_few': '{count}명 선택됨 — {remaining}명 더 선택하세요',
  'onboard.favs_hint_ready': '{count}명 선택됨 — 훌륭한 취향이에요!',
  'onboard.almost_done': '거의 완료!',
  'onboard.preview_note': '각 트랙의 30초 미리듣기가 재생됩니다.\n언제든 서비스를 연결하면 전체 곡을 들을 수 있습니다.',
  'tour.skip': '투어 건너뛰기',
  'tour.next': '다음 →',
  'tour.start_exploring': '탐색 시작 →',
  'tour.section_browse': '둘러보기',
  'tour.section_services': '서비스',
  'tour.section_valet': '발레',
  'tour.settings_title': '설정',
  'tour.settings_body': '스트리밍 서비스를 선택하고, 테마 색상을 맞춤 설정하고, 구독을 관리하세요.',
  'tour.home_title': '홈',
  'tour.home_body': '개인 맞춤 음악 대시보드. 취향에 맞는 앨범, 플레이리스트, 추천.',
  'tour.genres_title': '장르',
  'tour.genres_body': '장르별로 음악을 탐색하세요. 재즈, 클래식, 록 등에서 새 앨범을 발견하세요.',
  'tour.qobuz_title': 'Qobuz',
  'tour.qobuz_body': '고해상도 스트리밍 서비스. 놀라운 품질의 수백만 곡 — 또는 30초 미리듣기.',
  'tour.valet_title': '발레의 추천',
  'tour.valet_body': '당신만의 음악 발레. 좋아하는 것을 배우고 좋아할 앨범을 추천합니다. 더 많이 들을수록 당신을 더 잘 알게 됩니다.',
  'tour.radio_title': '라이브 라디오',
  'tour.radio_body': '전 세계 수천 개의 방송국이 손끝에. 재즈, 클래식, 월드 뮤직 등.',
  'tour.done_title': '즐기세요! 🎶',
  'tour.done_body': '탐색할 준비가 되었습니다. 이전에 없던 방식으로 음악을 발견하고, 듣고, 즐기세요.',

  // ── Smart Playlist ──
  'smart.title': "{valetName}의 추천",
  'smart.ask_ella': "{valetName}에게 물어보기",
  'smart.tell_ella': "{valetName}에게 듣고 싶은 음악을 알려주세요",
  'smart.type_request': "또는 여기에 요청을 입력하세요...",
  'smart.cancel': "취소",
  'smart.create': "만들기",
  'smart.creating': "만드는 중...",
  'smart.crafting': "{valetName}이(가) 플레이리스트를 만들고 있어요...",
  'smart.crafting_sub': "완벽한 트랙을 찾고, 흐름에 맞게 배치하는 중",
  'smart.ella_acknowledged': "고마워요! 요청을 잘 받았어요. 플레이리스트를 만들 테니 잠깐만 기다려 주세요.",
  'smart.no_playlists': "아직 플레이리스트가 없어요",
  'smart.no_playlists_sub': "{valetName}에게 만들어 달라고 해보세요 — 분위기와 순간을 설명하면 완벽한 음악 여행을 만들어 줄 거예요.",
  'smart.play_all': "전체 재생",
  'smart.talk_to_ella': "이 플레이리스트 편집",
  'smart.tell_change': "{valetName}에게 변경할 내용을 알려주세요...",
  'smart.fixing': "보내는 중...",
  'smart.ella_thinking': "{valetName}이(가) 생각 중...",
  'smart.changes_applied': "변경된 내용입니다",
  'smart.happy_with_this': "마음에 드시나요?",
  'smart.keep_changes': "좋아요",
  'smart.try_different': "아직요",
  'smart.rename': "이름 변경",
  'smart.fix_it': "보내기",
  'smart.back': "뒤로",
  'smart.tracks': "곡",
  'smart.min': "분",
  'smart.score': "점수",
  'smart.match': "일치",
  'smart.refined': "조정됨",
  'smart.listening': "듣고 있어요...",
  'smart.not_found': "플레이리스트를 찾을 수 없어요",
  'smart.error_generate': "죄송해요, 준비하는 데 문제가 있었어요. 다시 시도해 주시겠어요?",
  'smart.loved': "좋아요",
  'smart.disliked': "별로예요",
  'smart.created': "{date} 생성",
  'smart.revised': "{date} 수정",
  'smart.save_to_library': "내 플레이리스트에 저장",
  'smart.saved_to_library': "내 플레이리스트에 저장됨",
  'smart.delete_or_replace': "이 트랙을 삭제하거나 교체할까요?",
  'smart.delete_track': "삭제",
  'smart.replace_track': "교체",
  'smart.edit_or_delete': "이 트랙을 어떻게 할까요?",
  'smart.edit_track': "편집",
  'smart.replace_ask': "문제없어요. 어떤 종류의 곡으로 바꿀까요?",
  'smart.replace_working': "알겠어요, 바로 할게요.",
  'smart.replace_done': "원하시던 건지 알려주세요.",
  'smart.add_to_my_playlists': "내 플레이리스트에 추가",
  'smart.added_to_playlists': "추가했어요!",
  'smart.review_title': "플레이리스트 검토",
  'smart.looks_good': "좋아요 — 재생!",
  'smart.send': "보내기",
  'smart.try_again': "다시 시도",

  // ── Qobuz playlist import ──
  'qobuz.playlists.title': 'Qobuz 재생목록',
  'qobuz.playlists.description': 'Qobuz 재생목록을 내 재생목록으로 복사하여 편집하고 Maestro가 취향을 학습할 수 있도록 하세요.',
  'qobuz.playlists.refresh': 'Qobuz 재생목록 새로고침',
  'qobuz.playlists.importing': '가져오는 중…',
  'qobuz.playlists.complete': '{added}개 추가, {updated}개 업데이트됨.',
  'qobuz.playlists.preservedEdited': 'Maestro에서 편집된 {n}개가 유지되었습니다.',
  'qobuz.playlists.error': '가져오기에 실패했습니다.',
  // ── Station Tweaks ──
  'tweak_title': '스테이션 조정',
  'tweak_btn': '조정',
  'tweak_tune_btn': '튜닝',
  'tweak_queue_btn': '대기열',
  'tweak_placeholder': 'Ella에게 이 스테이션을 어떻게 조정할지 알려주세요…',
  'tweak_examples_label': '이런 걸 시도해 보세요:',
  'tweak_example_1': '10년 이상 된 음악 제외',
  'tweak_example_2': '숨겨진 명곡 위주, 히트곡 줄이기',
  'tweak_example_3': '부드럽고 어쿠스틱하게',
  'tweak_example_4': '여성 보컬 추가',
  'fda.title': 'Maestro가 음악 라이브러리에 접근할 권한이 필요합니다',
  'fda.description': 'macOS가 Maestro의 파일 접근 권한을 제거했습니다. 아마 마지막 앱 업데이트 이후일 것입니다. 음악 라이브러리는 안전합니다 — 접근 권한만 다시 부여하면 됩니다.',
  'fda.open_settings': '시스템 설정 열기',
  'fda.recheck': '완료 — 다시 확인',
  'source_health.offline_disconnected': '{minutes}분간 오프라인 — 드라이브 연결 해제됨',
  'source_health.offline_timeout': '{minutes}분간 오프라인 — 응답 느림',
  'source_health.toast_offline': '이 음악은 현재 오프라인인 \'{source_name}\'에 있습니다. 드라이브를 다시 연결하세요.',
  'source_health.toast_permission': 'Maestro가 \'{source_name}\'을(를) 읽을 수 없습니다. 폴더 권한을 확인하세요.',
  'faq.title': '자주 묻는 질문',
  'faq.subtitle': '일반적인 질문에 대한 빠른 답변',
  'faq.empty': '아직 FAQ가 없습니다.',
  'faq.loading': '로딩 중…',
  'support.message_paul': 'Paul에게 메시지',
  'support.goes_to': 'paul@psaudio.com으로 직접 전달됩니다',
  'support.intro': 'Maestro 베타 팀에 참여해 주셔서 감사합니다. 의견, 버그 보고, 아이디어를 듣고 싶습니다 — 모든 메시지가 저에게 직접 전달됩니다.',
  'support.name': '이름',
  'support.name_placeholder': '이름을 입력하세요',
  'support.email': '이메일',
  'support.email_placeholder': 'your@email.com',
  'support.subject': '제목',
  'support.subject_placeholder': '무엇이 궁금하신가요?',
  'support.message': '메시지',
  'support.message_placeholder': '무엇이든 말씀해 주세요...',
  'support.platform': '플랫폼',
  'support.send': '메시지 보내기',
  'support.sending': '전송 중…',
  'support.sent': '메시지가 전송되었습니다 ({ticketId})! 확인 이메일을 받으실 것이며, 아래에서 대화를 추적할 수 있습니다.',
  'support.version': '버전',
  'support.diagnostic.title': '진단 모드',
  'support.diagnostic.checking': '확인 중…',
  'support.diagnostic.state_a_body': 'Maestro 지원팀에서 진단 로깅을 켜 달라고 요청한 경우, 여기에서 활성화할 수 있습니다. 연결 세부 정보가 팀과 공유되어 문제 해결에 도움이 됩니다.',
  'support.diagnostic.contact_support': '활성화하려면 지원팀에 문의',
  'support.diagnostic.state_b_body_ticket': '지원 티켓 {ticket}에 대한 진단 로깅을 사용할 수 있습니다.',
  'support.diagnostic.state_b_body': '진단 로깅을 사용할 수 있습니다.',
  'support.diagnostic.state_c_instruction': '진단 데이터가 수집 중입니다. 문제가 발생할 때까지 Maestro를 평소처럼 사용한 뒤, 여기로 돌아와 로그를 보내 주세요.',
  'support.diagnostic.available_expires': '사용 가능 — {time} 후 만료',
  'support.diagnostic.recording_expires': '기록 중 — {time} 후 만료',
  'support.diagnostic.send_log': '로그 보내기',
  'support.diagnostic.sending': '보내는 중…',
  'support.diagnostic.log_sent': '지원팀으로 로그를 보냈습니다',
  'support.diagnostic.reference': '참조',
  'support.diagnostic.send_failed': '로그를 보낼 수 없습니다. 다시 시도하세요.',
  'support.diagnostic.expired': '만료됨',
};

const zh = {
  'nav.browse': '浏览',
  'nav.home': '首页',
  'nav.settings': '设置',
  'nav.genres': '风格',
  'nav.history': '历史记录',
  'nav.support': '支持',
  'nav.devices': '设备',
  'nav.prism': 'Prism DSP',
  'devices.title': '设备',
  'devices.subtitle': '配置您的音频区域',
  'nav.services': '服务',
  'nav.playlists': '我的播放列表',
  'nav.my_playlists': '我的播放列表',
  'nav.favorites': '收藏',
  'nav.audiophile': '高端试听音乐',
  'nav.genre_playlists': '风格',
  'nav.mood_playlists': '心情',
  'nav.season_playlists': '季节',
  'nav.discover': '发现',
  'nav.valet_picks': '{valetName}的推荐',
  'nav.trending': '热门',
  'nav.new_releases': '新发行',
  'nav.community': '社区',
  'nav.personalize': '个性化',
  'nav.my_library': '我的音乐库',
  'nav.your_library': '你的音乐库',
  'nav.local_library': '本地音乐库',
  'nav.my_music': '我的流媒体音乐',
  'nav.local_files': '我的本地文件',
  'nav.tools': '工具',
  'nav.recently_played': '最近播放',
  'nav.manage': '管理',
  'nav.local': '本地',
  'nav.albums': '我的专辑',
  'nav.library': '音乐库',
  'nav.artists': '我的艺术家',
  'nav.lib_playlists': '播放列表',
  'nav.lib_albums': '专辑',
  'nav.lib_artists': '艺术家',
  'nav.tracks': '曲目',
  'nav.composers': '作曲家',
  'nav.my_live_radio': '我的在线电台',
  'nav.folders': '文件夹',
  'nav.standard': '标准',
  'nav.full_featured': '完整功能',
  'help.local_features': '媒体库和网络播放器',
  'trackMenu.removeFromPlaylist': '从播放列表中移除',
  'trackMenu.playNow': '立即播放',
  'trackMenu.playNext': '下一首播放',
  'trackMenu.addToQueue': '添加到队列',
  'settings.dark_mode': '深色模式',
  'settings.dark_mode_desc': '切换浅色和深色主题',
  'settings.theme': '主题',
  'settings.theme_desc': '选择您的视觉风格',
  'settings.theme_light': '浅色',
  'settings.theme_dark': '深色',
  'settings.theme_high_contrast': '高对比度',
  'settings.display_size': '显示大小',
  'settings.display_size_desc': '根据屏幕调整界面大小',
  'settings.size_small': '小',
  'settings.size_default': '默认',
  'settings.size_large': '大',
  'settings.size_xl': '特大',
  'home.jukebox_title': 'Ella的点唱机',
  'home.jukebox_desc': '30张你很久没听的专辑，逐张专辑播放',
  'home.jukebox_loading': '正在创建播放列表...',
  'home.jukebox_loading_desc': '正在加载专辑和曲目...',
  'settings.language': '语言',
  'settings.language_desc': '选择显示语言',
  'settings.desktop_full': 'Maestro Connector',
  'settings.desktop_full_desc': 'NAS浏览、网络渲染器、DSP',
  'settings.voice_search': '语音搜索',
  'settings.voice_search_desc': '启用麦克风进行语音命令',
  'settings.ella_voice': 'Ella 语音',
  'settings.ella_voice_desc': 'Ella说话时对音乐的处理方式',
  'settings.ella_voice_duck': '降低',
  'settings.ella_voice_pause': '暂停',
  'settings.ella_voice_off': '关闭',
  'settings.services': '服务',
  'settings.account': '账户',
  'settings.subscription': '订阅',
  'settings.quick_settings': '快速设置',
  'settings.connected': '已连接',
  'settings.connect': '连接',
  'settings.coming_soon': '即将推出',
  'settings.enabled': '已启用',
  'settings.disabled': '已禁用',
  'help.title': '如何使用 Maestro',
  'help.intro': 'Maestro 是您的专属音乐伙伴。以下是您充分利用它所需了解的一切。',
  'help.getting_started': '入门指南',
  'help.playing_music': '播放音乐',
  'help.streaming_services': '流媒体服务',
  'help.your_valet': '您的管家',
  'help.full_featured': '媒体库和网络播放器',
  'help.playlists_favorites': '播放列表与收藏',
  'help.close': '关闭帮助',
  'help.footer': '需要更多帮助？前往设置 → 邮件支持联系我们。',
  'help.home_label': '首页',
  'help.home_desc': '您的个性化主页，汇集精选推荐、最近播放和新发现。',
  'help.settings_label': '设置',
  'help.settings_desc': '点击侧边栏的齿轮图标可以连接 Qobuz、切换深色模式和管理订阅。',
  'help.search_label': '搜索',
  'help.search_desc': '点击顶部的放大镜搜索艺术家、专辑、曲目和播放列表。在设置中启用后可使用语音搜索。',
  'help.play_track_label': '播放曲目',
  'help.play_track_desc': '浏览专辑或播放列表，点击曲目即可开始播放。迷你播放器将显示在底部。',
  'help.mini_player_label': '迷你播放器',
  'help.mini_player_desc': '显示当前曲目的播放/暂停、跳转、进度条和音量控制。点击封面可查看完整专辑。',
  'help.queue_label': '播放队列',
  'help.queue_desc': '长按或右键点击曲目可将其添加到播放队列。迷你播放器的队列图标可查看接下来播放的内容。',
  'help.qobuz_label': 'Qobuz',
  'help.qobuz_desc': '在设置中连接您的 Qobuz 账户即可享受高解析度流媒体。未连接时将播放30秒预览。',
  'help.live_radio_label': '在线电台',
  'help.live_radio_desc': '在设置中启用在线电台，浏览精选的互联网电台。',
  'help.octave_radio_label': 'Octave Radio',
  'help.octave_radio_desc': 'Paul McGowan 精选的电台——在设置中启用。',
  'help.picks_label': '个性化推荐',
  'help.picks_desc': '您的管家会随着时间学习您的品味，推荐适合您的艺术家、专辑和播放列表。',
  'help.chat_label': '聊天',
  'help.chat_desc': '点击管家图标，询问音乐相关问题、获取推荐或探索风格。',
  'help.trending_label': '热门与新发行',
  'help.trending_desc': '在侧边栏管家名称下方查看热门音乐和新发行内容。',
  'help.enable_label': '启用',
  'help.enable_desc': '安装 Maestro Connector 应用即可访问 NAS 浏览、网络播放器选择和 DSP 控制。',
  'help.local_lib_label': '本地音乐库',
  'help.local_lib_desc': '使用 Maestro Connector 浏览和播放 NAS 或本地存储中的文件。',
  'help.renderers_label': '网络播放器',
  'help.renderers_desc': '使用 Maestro Connector 发现并播放到网络中的 UPnP/DLNA 播放器。',
  'help.favorites_label': '收藏',
  'help.favorites_desc': '为任何艺术家、专辑或曲目点击红心，保存到收藏以便快速访问。',
  'help.playlists_label': '播放列表',
  'help.playlists_desc': '浏览发烧友、风格、心情和季节的精选播放列表——或创建您自己的。',
  'help.search_pl_label': '搜索播放列表',
  'help.search_pl_desc': '使用侧边栏"播放列表"旁的搜索图标，按名称查找特定播放列表。',
  'search.placeholder': '搜索音乐...',
  'search.voice_search': '语音搜索',
  'search.stop_listening': '停止监听',
  'search.listening': '正在监听...',
  'search.top_result': '最佳结果',
  'search.try_again': '重试',
  'search.show_albums': '查看专辑',
  'search.showing_results_for': '搜索结果:',
  'search.albums': '专辑',
  'search.artists': '艺术家',
  'search.tracks': '曲目',
  'search.all': '全部',
  'search.playlists': '播放列表',
  'search.failed': '搜索失败，请重试。',
  'search.no_results': '未找到可播放的结果',
  'search.no_results_hint': '请尝试其他搜索词或检查已连接的服务。',
  'search.empty_title': '跨所有音乐服务搜索',
  'search.empty_hint_voice': '说话或输入来查找艺术家、专辑和曲目',
  'search.empty_hint': '输入以查找艺术家、专辑和曲目',
  'search.back': '返回搜索',
  'search.new_search': '新搜索',
  'search.view_artist': '查看完整资料',
  'player.this_computer': '系统音频 (测试版)',
  'player.iphone': 'iPhone',
  'player.system_output': '系统输出',
  'player.audio_output': '音频输出',
  'player.playback_zone': '播放区域',
  'player.scanning': '正在搜索设备...',
  'player.play': '播放',
  'player.pause': '暂停',
  'player.seek': '跳转',
  'player.volume': '音量',
  'player.queue': '播放队列',
  'player.output_device': '输出设备',
  'player.single_zone': '单区域',
  'player.multi_zone': '多区域',
  'player.master': '主控',
  'player.zone_volumes': '区域音量',
  'player.zones_active': '{count}个区域已激活',
  'player.select_two_zones': '选择2个或更多区域',
  'player.multi_zone_count': '多区域 ({count})',
  'player.multi_label': '多区',
  'player.playing_on': '正在{zone}播放',
  'player.network_renderers': '网络播放器',
  'player.find_my_dac': '找不到您的DAC？请输入其IP地址',
  'player.find_dac_title': '查找我的DAC',
  'player.find_dac_search': '搜索',
  'player.find_dac_searching': '搜索中...',
  'player.find_dac_found': '已找到',
  'player.find_dac_not_found': '在此IP未找到设备',
  'player.find_dac_invalid_ip': '请输入有效的IP地址（例如 192.168.1.29）',
  'player.find_dac_hint': '您可以在DAC的显示屏或路由器的设备列表中找到DAC的IP地址',
  'player.this_device': '系统音频',
  'player.usb_dac': 'USB DAC',
  'player.usb_dac_connected': '已连接',
  'player.usb_dac_win_hint': 'USB DAC未显示？您可能需要安装制造商的驱动程序。',
  'player.local_audio_outputs': '本地音频输出',
  'player.change_output': '更改...',
  'exclusive.format_error_title': '格式不支持',
  'exclusive.switch_system_audio': '切换到系统音频',
  'exclusive.bit_perfect': 'Bit-Perfect',
  'dsd.native_dsd_label': '原生DSD',
  'dsd.dop_supported': '是（最高{rate}，通过DoP）',
  'dsd.pcm_only': '否（仅PCM）',
  'dsd.unknown_dac': '未知DAC：默认PCM',
  'dsd.force_pcm': '强制PCM（禁用DoP）',
  'dsd.force_pcm_hint': '将DSD作为高分辨率PCM播放',
  'common.continue': '继续',
  'common.skip': '跳过',
  'common.skip_step': '跳过此步骤',
  'common.cancel': '取消',
  'common.save': '保存',
  'common.back': '返回',
  'common.close': '关闭',
  'common.search': '搜索',
  'common.menu': '菜单',
  'common.home': '首页',
  'common.help': '帮助',
  'common.about': '关于 Maestro',
  'onboard.step_of': '第 {step} 步，共 {total} 步',
  'onboard.welcome_name': '欢迎，{name}！',
  'onboard.welcome_generic': '欢迎来到 Maestro！',
  'onboard.welcome_intro': '我是 Paul McGowan，Maestro 的创始人，非常高兴您的加入。',
  'onboard.welcome_body': 'Maestro 是我多年来梦想打造的产品 — 一个使用起来和音乐一样美好的音乐伴侣。让我们一起改变您发现、管理和享受音乐的方式。',
  'onboard.welcome_cta': '开始很简单 — 只需三个快速步骤，您就可以开始聆听。',
  'onboard.step1_title': '保护您的账户',
  'onboard.step1_desc': '选择一个密码来保护您的音乐',
  'onboard.step2_title': '告诉我们您喜欢什么',
  'onboard.step2_desc': '选择流派和艺术家，让 Maestro 了解您的品味',
  'onboard.step3_title': '连接您的音乐',
  'onboard.step3_desc': '连接 Qobuz 享受高解析度流媒体，或使用预览来探索',
  'onboard.all_set': '一切就绪',
  'onboard.account_ready': '您的账户已准备就绪。',
  'onboard.start_step1': '让我们从第 1 步开始',
  'onboard.choose_password': '选择一个密码来保护您的账户。',
  'onboard.loading_account': '正在加载账户信息…',
  'onboard.signed_in_as': '已登录为',
  'onboard.get_started': '开始 →',
  'onboard.label_email': '电子邮件',
  'onboard.label_password': '密码',
  'onboard.label_confirm': '确认密码',
  'onboard.label_phone': '手机号码',
  'onboard.phone_helper': '忘记密码了？别担心 — 我们会发送一个魔法代码帮您重新登录。',
  'onboard.setting_up': '设置中…',
  'onboard.error_password_length': '密码必须至少8个字符',
  'onboard.error_password_match': '密码不匹配',
  'onboard.choose_language': '选择您的语言',
  'onboard.choose_language_desc': '您可以随时在设置中更改。',
  'onboard.genre_title': '您喜欢什么样的音乐？',
  'onboard.genre_desc': '请选择至少3个。这有助于我们为您找到喜欢的音乐。',
  'onboard.genre_hint_0': '请选择至少3个您喜欢的风格',
  'onboard.genre_hint_few': '已选 {count} 个——再选 {remaining} 个',
  'onboard.genre_hint_ready': '已选 {count} 个——不错！',
  'onboard.genre_tap': '点击您喜欢的开始吧',
  'onboard.streaming_title': '连接您的音乐',
  'onboard.streaming_desc': 'Maestro 配合流媒体服务使用效果最佳，但您也可以通过免费预览来探索。',
  'onboard.favs_title': '选择一些收藏',
  'onboard.favs_desc': '我们将用这些来个性化您的主页。',
  'onboard.complete_title': '一切就绪！',
  'onboard.complete_desc': 'Maestro 已准备好为您指挥完美的音乐体验。',
  'onboard.start_listening': '开始聆听 →',
  'onboard.saving': '正在保存您的偏好…',
  'onboard.i_like_everything': '我什么都喜欢',
  'onboard.almost_there': '快好了！',
  'onboard.experience_maestro': '您即将体验 Maestro！',
  'onboard.favs_hint_0': '选择一些您喜欢的艺术家',
  'onboard.favs_hint_few': '已选 {count} 个——再选 {remaining} 个',
  'onboard.favs_hint_ready': '已选 {count} 个——品味不错！',
  'onboard.almost_done': '即将完成！',
  'onboard.preview_note': '您将听到每首曲目的30秒预览。\n随时连接服务即可收听完整曲目。',
  'tour.skip': '跳过导览',
  'tour.next': '下一步 →',
  'tour.start_exploring': '开始探索 →',
  'tour.section_browse': '浏览',
  'tour.section_services': '服务',
  'tour.section_valet': '管家',
  'tour.settings_title': '设置',
  'tour.settings_body': '选择您的流媒体服务，自定义主题颜色，并管理您的订阅。',
  'tour.home_title': '首页',
  'tour.home_body': '您的个性化音乐仪表板。基于您品味的专辑、播放列表和推荐。',
  'tour.genres_title': '流派',
  'tour.genres_body': '按流派浏览音乐。在爵士、古典、摇滚等类型中发现新专辑。',
  'tour.qobuz_title': 'Qobuz',
  'tour.qobuz_body': '您的高解析度流媒体服务。数百万首曲目，音质惊人 — 或享受30秒预览。',
  'tour.valet_title': '管家精选',
  'tour.valet_body': '您的私人音乐管家。它了解您的喜好并推荐您会喜欢的专辑。您听得越多，它就越了解您。',
  'tour.radio_title': '在线电台',
  'tour.radio_body': '来自世界各地的数千个电台，触手可及。爵士、古典、世界音乐等。',
  'tour.done_title': '尽情享受！🎶',
  'tour.done_body': '您已准备好探索。以前所未有的方式发现、聆听和享受您的音乐。',

  // ── Smart Playlist ──
  'smart.title': "{valetName}的精选",
  'smart.ask_ella': "问问{valetName}",
  'smart.tell_ella': "告诉{valetName}你想听什么",
  'smart.type_request': "或在此输入你的请求...",
  'smart.cancel': "取消",
  'smart.create': "创建",
  'smart.creating': "创建中...",
  'smart.crafting': "{valetName}正在为你打造播放列表...",
  'smart.crafting_sub': "寻找完美曲目，精心排列最佳顺序",
  'smart.ella_acknowledged': "谢谢！我收到你的要求了，给我一点时间来打造你的播放列表。",
  'smart.no_playlists': "还没有播放列表",
  'smart.no_playlists_sub': "让{valetName}为你创建一个吧 — 描述你想要的氛围和场景，让她为你打造完美的音乐之旅。",
  'smart.play_all': "全部播放",
  'smart.talk_to_ella': "编辑此播放列表",
  'smart.tell_change': "告诉{valetName}需要修改什么...",
  'smart.fixing': "发送中...",
  'smart.ella_thinking': "{valetName}正在思考...",
  'smart.changes_applied': "以下是更改内容",
  'smart.happy_with_this': "满意吗？",
  'smart.keep_changes': "很好",
  'smart.try_different': "还需调整",
  'smart.rename': "重命名",
  'smart.fix_it': "发送",
  'smart.back': "返回",
  'smart.tracks': "首",
  'smart.min': "分钟",
  'smart.score': "评分",
  'smart.match': "匹配",
  'smart.refined': "已优化",
  'smart.listening': "正在聆听...",
  'smart.not_found': "未找到播放列表",
  'smart.error_generate': "抱歉，准备时出了点问题。能再试一次吗？",
  'smart.loved': "喜欢",
  'smart.disliked': "不太适合我",
  'smart.created': "{date} 创建",
  'smart.revised': "{date} 修改",
  'smart.save_to_library': "保存到我的播放列表",
  'smart.saved_to_library': "已保存到我的播放列表",
  'smart.delete_or_replace': "删除还是替换这首曲目？",
  'smart.delete_track': "删除",
  'smart.replace_track': "替换",
  'smart.edit_or_delete': "您想对这首曲目做什么？",
  'smart.edit_track': "编辑",
  'smart.replace_ask': "没问题。你想换成什么样的曲目？",
  'smart.replace_working': "好的，马上处理。",
  'smart.replace_done': "告诉我这是不是你想要的。",
  'smart.add_to_my_playlists': "添加到我的播放列表",
  'smart.added_to_playlists': "已添加！",
  'smart.review_title': "查看您的播放列表",
  'smart.looks_good': "很好——播放！",
  'smart.send': "发送",
  'smart.try_again': "重试",

  // ── Qobuz playlist import ──
  'qobuz.playlists.title': 'Qobuz 播放列表',
  'qobuz.playlists.description': '将您的 Qobuz 播放列表复制到「我的播放列表」中，方便您编辑，同时 Maestro 可以学习您的品味。',
  'qobuz.playlists.refresh': '刷新 Qobuz 播放列表',
  'qobuz.playlists.importing': '正在导入…',
  'qobuz.playlists.complete': '已添加 {added} 个，已更新 {updated} 个。',
  'qobuz.playlists.preservedEdited': 'Maestro 中编辑过的 {n} 个已保留。',
  'qobuz.playlists.error': '导入失败。',
  // ── Station Tweaks ──
  'tweak_title': '调整电台',
  'tweak_btn': '调整',
  'tweak_tune_btn': '调谐',
  'tweak_queue_btn': '队列',
  'tweak_placeholder': '告诉Ella如何调整这个电台…',
  'tweak_examples_label': '试试这样说：',
  'tweak_example_1': '不要超过10年的音乐',
  'tweak_example_2': '更多冷门佳作，少些热门歌曲',
  'tweak_example_3': '保持柔和原声风格',
  'tweak_example_4': '添加更多女歌手',
  'fda.title': 'Maestro需要访问您音乐库的权限',
  'fda.description': 'macOS取消了Maestro的文件访问权限，可能是在上次应用更新之后。您的音乐库没有问题 — 我们只需要重新授予访问权限。',
  'fda.open_settings': '打开系统设置',
  'fda.recheck': '已授权 — 重新检查',
  'source_health.offline_disconnected': '已离线 {minutes} 分钟 — 驱动器已断开',
  'source_health.offline_timeout': '已离线 {minutes} 分钟 — 响应缓慢',
  'source_health.toast_offline': '这些音乐在"{source_name}"上，目前处于离线状态。请重新连接驱动器后重试。',
  'source_health.toast_permission': 'Maestro无法读取"{source_name}"。请检查文件夹权限。',
  'faq.title': '常见问题',
  'faq.subtitle': '常见问题的快速解答',
  'faq.empty': '暂无常见问题。',
  'faq.loading': '加载中…',
  'support.message_paul': '给Paul留言',
  'support.goes_to': '直接发送至 paul@psaudio.com',
  'support.intro': '感谢您加入Maestro测试团队。我很想听听您的评论、错误报告和想法——每条消息都会直接发给我。',
  'support.name': '姓名',
  'support.name_placeholder': '您的姓名',
  'support.email': '邮箱',
  'support.email_placeholder': 'your@email.com',
  'support.subject': '主题',
  'support.subject_placeholder': '您有什么想说的？',
  'support.message': '消息',
  'support.message_placeholder': '告诉我您的想法...',
  'support.platform': '平台',
  'support.send': '发送消息',
  'support.sending': '发送中…',
  'support.sent': '消息已发送（{ticketId}）！您将收到确认邮件，可以在下方跟踪我们的对话。',
  'support.version': '版本',
  'support.diagnostic.title': '诊断模式',
  'support.diagnostic.checking': '正在检查…',
  'support.diagnostic.state_a_body': '若 Maestro 支持团队请您启用诊断日志，可在此开启。我们会收集连接信息以帮助排查问题。',
  'support.diagnostic.contact_support': '请联系支持以启用',
  'support.diagnostic.state_b_body_ticket': '可为您的支持工单 {ticket} 使用诊断日志。',
  'support.diagnostic.state_b_body': '诊断日志可用。',
  'support.diagnostic.state_c_instruction': '正在捕获诊断数据。请照常使用 Maestro，出现问题后返回此处发送日志。',
  'support.diagnostic.available_expires': '可用 — {time} 后过期',
  'support.diagnostic.recording_expires': '录制中 — {time} 后过期',
  'support.diagnostic.send_log': '发送日志',
  'support.diagnostic.sending': '发送中…',
  'support.diagnostic.log_sent': '日志已发送至支持团队',
  'support.diagnostic.reference': '参考编号',
  'support.diagnostic.send_failed': '无法发送日志，请重试。',
  'support.diagnostic.expired': '已过期',
};

const nl = {
  'nav.browse': 'Bladeren',
  'nav.home': 'Home',
  'nav.settings': 'Instellingen',
  'nav.genres': 'Genres',
  'nav.history': 'Geschiedenis',
  'nav.support': 'Ondersteuning',
  'nav.devices': 'Apparaten',
  'nav.prism': 'Prism DSP',
  'devices.title': 'Apparaten',
  'devices.subtitle': 'Configureer uw audiozones',
  'nav.services': 'Diensten',
  'nav.playlists': 'Mijn Afspeellijsten',
  'nav.my_playlists': 'Mijn Afspeellijsten',
  'nav.favorites': 'Favorieten',
  'nav.audiophile': 'Hi-Fi Demo Muziek',
  'nav.genre_playlists': 'Stijlen',
  'nav.mood_playlists': 'Sferen',
  'nav.season_playlists': 'Seizoenen',
  'nav.discover': 'Ontdekken',
  'nav.valet_picks': 'Keuzes van {valetName}',
  'nav.trending': 'Trending',
  'nav.new_releases': 'Nieuw',
  'nav.community': 'Community',
  'nav.personalize': 'Personaliseren',
  'nav.my_library': 'Mijn Bibliotheek',
  'nav.your_library': 'Jouw Bibliotheek',
  'nav.local_library': 'Lokale Bibliotheek',
  'nav.my_music': 'Mijn Streaming Muziek',
  'nav.local_files': 'Mijn Lokale Bestanden',
  'nav.tools': 'Hulpmiddelen',
  'nav.recently_played': 'Recent Afgespeeld',
  'nav.manage': 'Beheren',
  'nav.local': 'Lokaal',
  'nav.albums': 'Mijn Albums',
  'nav.library': 'Bibliotheek',
  'nav.artists': 'Mijn Artiesten',
  'nav.lib_playlists': 'Afspeellijsten',
  'nav.lib_albums': 'Albums',
  'nav.lib_artists': 'Artiesten',
  'nav.tracks': 'Nummers',
  'nav.composers': 'Componisten',
  'nav.my_live_radio': 'Mijn Live Radio',
  'nav.folders': 'Mappen',
  'nav.standard': 'Standaard',
  'nav.full_featured': 'Volledig',
  'help.local_features': 'Bibliotheek & Netwerkspelers',
  'trackMenu.removeFromPlaylist': 'Verwijderen uit afspeellijst',
  'trackMenu.playNow': 'Nu afspelen',
  'trackMenu.playNext': 'Hierna afspelen',
  'trackMenu.addToQueue': 'Toevoegen aan wachtrij',
  'settings.dark_mode': 'Donkere Modus',
  'settings.dark_mode_desc': 'Schakel tussen licht en donker thema',
  'settings.theme': 'Thema',
  'settings.theme_desc': 'Kies uw visuele stijl',
  'settings.theme_light': 'Licht',
  'settings.theme_dark': 'Donker',
  'settings.theme_high_contrast': 'Hoog contrast',
  'settings.display_size': 'Weergavegrootte',
  'settings.display_size_desc': 'Pas de interface aan voor uw scherm',
  'settings.size_small': 'Klein',
  'settings.size_default': 'Normaal',
  'settings.size_large': 'Groot',
  'settings.size_xl': 'Zeer groot',
  'home.jukebox_title': "Ella's Jukebox",
  'home.jukebox_desc': '30 albums die je al lang niet hebt gehoord, album voor album',
  'home.jukebox_loading': 'Je afspeellijst wordt gemaakt...',
  'home.jukebox_loading_desc': 'Albums en nummers worden geladen...',
  'settings.language': 'Taal',
  'settings.language_desc': 'Kies uw weergavetaal',
  'settings.desktop_full': 'Maestro Connector',
  'settings.desktop_full_desc': 'NAS, netwerkspelers, DSP',
  'settings.voice_search': 'Spraakzoeken',
  'settings.voice_search_desc': 'Microfoon inschakelen voor spraakopdrachten',
  'settings.ella_voice': 'Ella Stem',
  'settings.ella_voice_desc': 'Wat er met je muziek gebeurt als Ella spreekt',
  'settings.ella_voice_duck': 'Zachter',
  'settings.ella_voice_pause': 'Pauze',
  'settings.ella_voice_off': 'Uit',
  'settings.services': 'Diensten',
  'settings.account': 'Account',
  'settings.subscription': 'Abonnement',
  'settings.quick_settings': 'Snelle Instellingen',
  'settings.connected': 'Verbonden',
  'settings.connect': 'Verbinden',
  'settings.coming_soon': 'Binnenkort',
  'settings.enabled': 'Ingeschakeld',
  'settings.disabled': 'Uitgeschakeld',
  'help.title': 'Hoe Maestro te gebruiken',
  'help.intro': 'Maestro is uw persoonlijke muziekpartner. Hier vindt u alles wat u moet weten om er het beste uit te halen.',
  'help.getting_started': 'Aan de Slag',
  'help.playing_music': 'Muziek Afspelen',
  'help.streaming_services': 'Streamingdiensten',
  'help.your_valet': 'Ella',
  'help.full_featured': 'Bibliotheek & Netwerkspelers',
  'help.playlists_favorites': 'Afspeellijsten & Favorieten',
  'help.close': 'Help sluiten',
  'help.footer': 'Meer hulp nodig? Ga naar Instellingen → E-mailondersteuning om contact op te nemen.',
  'help.home_label': 'Home',
  'help.home_desc': 'Uw gepersonaliseerde startpagina met samengestelde keuzes, recente nummers en nieuwe ontdekkingen.',
  'help.settings_label': 'Instellingen',
  'help.settings_desc': 'Tik op het tandwiel in de zijbalk om Qobuz te verbinden, de donkere modus in te schakelen en uw abonnement te beheren.',
  'help.search_label': 'Zoeken',
  'help.search_desc': 'Tik op het vergrootglas in de kop om te zoeken naar artiesten, albums, nummers en afspeellijsten. Spraakzoeken is beschikbaar wanneer ingeschakeld in Instellingen.',
  'help.play_track_label': 'Nummer Afspelen',
  'help.play_track_desc': 'Blader naar een album of afspeellijst en tik op een nummer om af te spelen. De minispeler verschijnt onderaan.',
  'help.mini_player_label': 'Minispeler',
  'help.mini_player_desc': 'Toont het huidige nummer met afspelen/pauzeren, overslaan, voortgangsbalk en volume. Tik op de hoes om het volledige album te zien.',
  'help.queue_label': 'Wachtrij',
  'help.queue_desc': 'Houd een nummer ingedrukt of klik met de rechtermuisknop om het aan de wachtrij toe te voegen. Het wachtrij-icoon in de minispeler toont wat er volgt.',
  'help.qobuz_label': 'Qobuz',
  'help.qobuz_desc': 'Verbind uw Qobuz-account in Instellingen voor hi-res streaming. Zonder account hoort u voorbeelden van 30 seconden.',
  'help.live_radio_label': 'Live Radio',
  'help.live_radio_desc': 'Schakel Live Radio in via Instellingen om samengestelde internetradiostations te verkennen.',
  'help.octave_radio_label': 'Octave Radio',
  'help.octave_radio_desc': 'Het door Paul McGowan samengestelde radiostation — schakel het in via Instellingen.',
  'help.picks_label': 'Persoonlijke Aanbevelingen',
  'help.picks_desc': 'Uw valet leert uw smaak kennen en stelt artiesten, albums en afspeellijsten voor die bij u passen.',
  'help.chat_label': 'Chat',
  'help.chat_desc': 'Tik op het valet-icoon om vragen over muziek te stellen, aanbevelingen te krijgen of genres te verkennen.',
  'help.trending_label': 'Trending & Nieuw',
  'help.trending_desc': 'Blijf op de hoogte van populaire en nieuwe releases in de zijbalk onder de naam van uw valet.',
  'help.enable_label': 'Inschakelen',
  'help.enable_desc': 'Installeer de Maestro Connector app voor NAS-browsing, netwerkspeler-selectie en DSP-bediening.',
  'help.local_lib_label': 'Lokale Bibliotheek',
  'help.local_lib_desc': 'Blader en speel bestanden van uw NAS of lokale opslag met de Maestro Connector.',
  'help.renderers_label': 'Netwerkspelers',
  'help.renderers_desc': 'Ontdek en speel af via UPnP/DLNA-spelers op uw netwerk met de Maestro Connector.',
  'help.favorites_label': 'Favorieten',
  'help.favorites_desc': 'Geef een hartje aan een artiest, album of nummer om het op te slaan in uw Favorieten.',
  'help.playlists_label': 'Afspeellijsten',
  'help.playlists_desc': 'Verken samengestelde audiofiele, genre-, sfeer- en seizoensafspeellijsten — of maak uw eigen.',
  'help.search_pl_label': 'Afspeellijsten Zoeken',
  'help.search_pl_desc': 'Gebruik het zoekicoon naast "Afspeellijsten" in de zijbalk om specifieke afspeellijsten op naam te vinden.',
  'search.placeholder': 'Muziek zoeken...',
  'search.voice_search': 'Spraakzoeken',
  'search.stop_listening': 'Stop met luisteren',
  'search.listening': 'Luisteren...',
  'search.top_result': 'Beste resultaat',
  'search.try_again': 'Opnieuw proberen',
  'search.show_albums': 'Albums tonen',
  'search.showing_results_for': 'Resultaten voor',
  'search.albums': 'Albums',
  'search.artists': 'Artiesten',
  'search.tracks': 'Nummers',
  'search.all': 'Alles',
  'search.playlists': 'Afspeellijsten',
  'search.failed': 'Zoeken mislukt. Probeer het opnieuw.',
  'search.no_results': 'Geen afspeelbare resultaten gevonden',
  'search.no_results_hint': 'Probeer een andere zoekterm of controleer uw verbonden diensten.',
  'search.empty_title': 'Zoek in al uw muziekdiensten',
  'search.empty_hint_voice': 'Spreek of typ om artiesten, albums en nummers te vinden',
  'search.empty_hint': 'Typ om artiesten, albums en nummers te vinden',
  'search.back': 'Terug naar zoeken',
  'search.new_search': 'Nieuwe zoekopdracht',
  'search.view_artist': 'Bekijk volledig profiel',
  'player.this_computer': 'Systeemaudio (bèta)',
  'player.iphone': 'iPhone',
  'player.system_output': 'Systeemuitvoer',
  'player.audio_output': 'Audio-uitvoer',
  'player.playback_zone': 'Afspeelzone',
  'player.scanning': 'Apparaten zoeken...',
  'player.play': 'Afspelen',
  'player.pause': 'Pauzeren',
  'player.seek': 'Zoeken',
  'player.volume': 'Volume',
  'player.queue': 'Wachtrij',
  'player.output_device': 'Uitvoerapparaat',
  'player.single_zone': 'Enkele Zone',
  'player.multi_zone': 'Multi-Zone',
  'player.master': 'Master',
  'player.zone_volumes': 'Zone Volumes',
  'player.zones_active': '{count} Zones Actief',
  'player.select_two_zones': 'Selecteer 2 of meer zones',
  'player.multi_zone_count': 'Multi-Zone ({count})',
  'player.multi_label': 'Multi',
  'player.playing_on': 'Speelt af op {zone}',
  'player.network_renderers': 'Netwerkspelers',
  'player.find_my_dac': 'DAC niet gevonden? Voer het IP-adres in',
  'player.find_dac_title': 'Mijn DAC Zoeken',
  'player.find_dac_search': 'Zoeken',
  'player.find_dac_searching': 'Zoeken...',
  'player.find_dac_found': 'Gevonden',
  'player.find_dac_not_found': 'Geen apparaat gevonden op dit IP',
  'player.find_dac_invalid_ip': 'Voer een geldig IP-adres in (bijv. 192.168.1.29)',
  'player.find_dac_hint': 'Vind het IP-adres van uw DAC op het scherm of in de apparatenlijst van uw router',
  'player.this_device': 'Systeemaudio',
  'player.usb_dac': 'USB-DAC',
  'player.usb_dac_connected': 'Verbonden',
  'player.usb_dac_win_hint': 'USB-DAC wordt niet weergegeven? Mogelijk moet u het stuurprogramma van de fabrikant installeren.',
  'player.local_audio_outputs': 'Lokale audio-uitgangen',
  'player.change_output': 'Wijzigen...',
  'exclusive.format_error_title': 'Formaat niet ondersteund',
  'exclusive.switch_system_audio': 'Overschakelen naar Systeemgeluid',
  'exclusive.bit_perfect': 'Bit-Perfect',
  'dsd.native_dsd_label': 'Native DSD',
  'dsd.dop_supported': 'Ja (tot {rate} via DoP)',
  'dsd.pcm_only': 'Nee (alleen PCM)',
  'dsd.unknown_dac': 'Onbekende DAC: standaard PCM',
  'dsd.force_pcm': 'PCM forceren (DoP uitschakelen)',
  'dsd.force_pcm_hint': 'DSD afspelen als hi-res PCM',
  'common.continue': 'Doorgaan',
  'common.skip': 'Overslaan',
  'common.skip_step': 'Deze stap overslaan',
  'common.cancel': 'Annuleren',
  'common.save': 'Opslaan',
  'common.back': 'Terug',
  'common.close': 'Sluiten',
  'common.search': 'Zoeken',
  'common.menu': 'Menu',
  'common.home': 'Home',
  'common.help': 'Help',
  'common.about': 'Over Maestro',
  'onboard.step_of': 'Stap {step} van {total}',
  'onboard.welcome_name': 'Welkom, {name}!',
  'onboard.welcome_generic': 'Welkom bij Maestro!',
  'onboard.welcome_intro': 'Ik ben Paul McGowan, bedenker van Maestro, en ik ben blij dat u hier bent.',
  'onboard.welcome_body': 'Maestro is iets waar ik al jaren van droom — een muziekpartner die net zo mooi is om te gebruiken als muziek is om te beluisteren. Samen gaan we de manier veranderen waarop u muziek ontdekt, beheert en ervan geniet.',
  'onboard.welcome_cta': 'Beginnen is eenvoudig — slechts drie snelle stappen en u luistert.',
  'onboard.step1_title': 'Beveilig uw Account',
  'onboard.step1_desc': 'Kies een wachtwoord om uw muziek te beschermen',
  'onboard.step2_title': 'Vertel ons wat u Leuk vindt',
  'onboard.step2_desc': 'Kies genres en artiesten zodat Maestro uw smaak kent',
  'onboard.step3_title': 'Verbind uw Muziek',
  'onboard.step3_desc': 'Koppel Qobuz voor hi-res streaming, of verken met voorbeelden',
  'onboard.all_set': 'Alles klaar',
  'onboard.account_ready': 'Uw account is gereed.',
  'onboard.start_step1': 'Laten we beginnen met Stap 1',
  'onboard.choose_password': 'Kies een wachtwoord om uw account te beveiligen.',
  'onboard.loading_account': 'Accountgegevens laden…',
  'onboard.signed_in_as': 'Ingelogd als',
  'onboard.get_started': 'Beginnen →',
  'onboard.label_email': 'E-mail',
  'onboard.label_password': 'Wachtwoord',
  'onboard.label_confirm': 'Bevestig Wachtwoord',
  'onboard.label_phone': 'Mobiel Nummer',
  'onboard.phone_helper': 'Wachtwoord vergeten? Geen probleem — we sturen u een magische code om weer in te loggen.',
  'onboard.setting_up': 'Instellen…',
  'onboard.error_password_length': 'Het wachtwoord moet minimaal 8 tekens bevatten',
  'onboard.error_password_match': 'De wachtwoorden komen niet overeen',
  'onboard.choose_language': 'Kies uw taal',
  'onboard.choose_language_desc': 'U kunt dit op elk moment wijzigen in Instellingen.',
  'onboard.genre_title': 'Van welke muziek houdt u?',
  'onboard.genre_desc': 'Kies er minstens 3. Dit helpt ons muziek te vinden die u leuk vindt.',
  'onboard.genre_hint_0': 'Kies minstens 3 genres die u leuk vindt',
  'onboard.genre_hint_few': '{count} geselecteerd — kies er nog {remaining}',
  'onboard.genre_hint_ready': '{count} geselecteerd — geweldig!',
  'onboard.genre_tap': 'Tik op uw favorieten om te beginnen',
  'onboard.streaming_title': 'Verbind uw muziek',
  'onboard.streaming_desc': 'Maestro werkt het beste met een streamingdienst, maar u kunt ook verkennen met gratis voorbeelden.',
  'onboard.favs_title': 'Kies uw favorieten',
  'onboard.favs_desc': 'We gebruiken deze om uw startscherm te personaliseren.',
  'onboard.complete_title': 'Alles klaar!',
  'onboard.complete_desc': 'Maestro is klaar om uw perfecte muziekervaring te dirigeren.',
  'onboard.start_listening': 'Begin met Luisteren →',
  'onboard.saving': 'Uw voorkeuren worden opgeslagen…',
  'onboard.i_like_everything': 'Ik vind alles leuk',
  'onboard.almost_there': 'Bijna klaar!',
  'onboard.experience_maestro': 'U staat op het punt Maestro te ervaren!',
  'onboard.favs_hint_0': 'Kies een paar artiesten waar u van houdt',
  'onboard.favs_hint_few': '{count} geselecteerd — kies er nog {remaining}',
  'onboard.favs_hint_ready': '{count} geselecteerd — uitstekende smaak!',
  'onboard.almost_done': 'Bijna klaar!',
  'onboard.preview_note': 'U hoort voorbeelden van 30 seconden per nummer.\nVerbind op elk moment een dienst om volledige nummers te beluisteren.',
  'tour.skip': 'Tour Overslaan',
  'tour.next': 'Volgende →',
  'tour.start_exploring': 'Begin met Verkennen →',
  'tour.section_browse': 'Bladeren',
  'tour.section_services': 'Diensten',
  'tour.section_valet': 'Bediende',
  'tour.settings_title': 'Instellingen',
  'tour.settings_body': 'Kies uw streamingdiensten, pas de themakleuren aan en beheer uw abonnement.',
  'tour.home_title': 'Home',
  'tour.home_body': 'Uw gepersonaliseerd muziekdashboard. Albums, afspeellijsten en aanbevelingen op basis van uw smaak.',
  'tour.genres_title': 'Genres',
  'tour.genres_body': 'Blader door muziek per genre. Ontdek nieuwe albums in Jazz, Klassiek, Rock en meer.',
  'tour.qobuz_title': 'Qobuz',
  'tour.qobuz_body': 'Uw hi-res streamingdienst. Miljoenen nummers in adembenemende kwaliteit — of voorbeelden van 30 seconden.',
  'tour.valet_title': 'Keuzes van de Bediende',
  'tour.valet_body': 'Uw persoonlijke muziekbediende. Leert wat u leuk vindt en stelt albums voor die u zult waarderen. Hoe meer u luistert, hoe beter hij u kent.',
  'tour.radio_title': 'Live Radio',
  'tour.radio_body': 'Duizenden zenders van over de hele wereld, binnen handbereik. Jazz, klassiek, wereldmuziek en meer.',
  'tour.done_title': 'Veel Plezier! 🎶',
  'tour.done_body': 'U bent klaar om te verkennen. Ontdek, luister en geniet van uw muziek als nooit tevoren.',

  // ── Smart Playlist ──
  'smart.title': "Keuzes van {valetName}",
  'smart.ask_ella': "Vraag {valetName}",
  'smart.tell_ella': "Vertel {valetName} wat je graag wilt horen",
  'smart.type_request': "Of typ je verzoek hier...",
  'smart.cancel': "Annuleren",
  'smart.create': "Maken",
  'smart.creating': "Bezig met maken...",
  'smart.crafting': "{valetName} stelt je playlist samen...",
  'smart.crafting_sub': "De perfecte nummers zoeken, gerangschikt voor de beste flow",
  'smart.ella_acknowledged': "Bedankt! Ik heb je wensen. Geef me even de tijd om je playlist samen te stellen.",
  'smart.no_playlists': "Nog geen playlists",
  'smart.no_playlists_sub': "Vraag {valetName} er een te maken — beschrijf de sfeer, het moment, en laat haar je perfecte muzikale reis samenstellen.",
  'smart.play_all': "Alles afspelen",
  'smart.talk_to_ella': "Bewerk deze playlist",
  'smart.tell_change': "Vertel {valetName} wat er moet veranderen...",
  'smart.fixing': "Verzenden...",
  'smart.ella_thinking': "{valetName} denkt na...",
  'smart.changes_applied': "Dit is er veranderd",
  'smart.happy_with_this': "Tevreden hiermee?",
  'smart.keep_changes': "Ziet er goed uit",
  'smart.try_different': "Nog niet helemaal",
  'smart.rename': "Hernoemen",
  'smart.fix_it': "Verzenden",
  'smart.back': "Terug",
  'smart.tracks': "nummers",
  'smart.min': "min",
  'smart.score': "Score",
  'smart.match': "overeenkomst",
  'smart.refined': "verfijnd",
  'smart.listening': "Luisteren...",
  'smart.not_found': "Playlist niet gevonden",
  'smart.error_generate': "Sorry, het lukte me niet om dat samen te stellen. Kun je het opnieuw proberen?",
  'smart.loved': "Geweldig",
  'smart.disliked': "Niet voor mij",
  'smart.created': "Aangemaakt op {date}",
  'smart.revised': "Herzien op {date}",
  'smart.save_to_library': "Opslaan in Mijn Afspeellijsten",
  'smart.saved_to_library': "Opgeslagen in Mijn Afspeellijsten",
  'smart.delete_or_replace': "Dit nummer verwijderen of vervangen?",
  'smart.delete_track': "Verwijderen",
  'smart.replace_track': "Vervangen",
  'smart.edit_or_delete': "Wat wil je doen met dit nummer?",
  'smart.edit_track': "Bewerken",
  'smart.replace_ask': "Geen probleem. Wat voor nummer wil je ervoor in de plaats?",
  'smart.replace_working': "Ok, ik ga ervoor.",
  'smart.replace_done': "Laat me weten of dit is wat je zocht.",
  'smart.add_to_my_playlists': "Toevoegen aan Mijn Playlists",
  'smart.added_to_playlists': "Toegevoegd!",
  'smart.review_title': "Bekijk je afspeellijst",
  'smart.looks_good': "Ziet er goed uit — afspelen!",
  'smart.send': "Verzenden",
  'smart.try_again': "Opnieuw proberen",

  // ── Qobuz playlist import ──
  'qobuz.playlists.title': 'Qobuz-afspeellijsten',
  'qobuz.playlists.description': 'Kopieer je Qobuz-afspeellijsten naar Mijn Playlists zodat je ze kunt bewerken en Maestro je smaak leert kennen.',
  'qobuz.playlists.refresh': 'Qobuz-afspeellijsten vernieuwen',
  'qobuz.playlists.importing': 'Importeren…',
  'qobuz.playlists.complete': '{added} toegevoegd, {updated} bijgewerkt.',
  'qobuz.playlists.preservedEdited': '{n} bewerkt in Maestro zijn behouden.',
  'qobuz.playlists.error': 'Import mislukt.',
  // ── Station Tweaks ──
  'tweak_title': 'Zender Aanpassen',
  'tweak_btn': 'Aanpassen',
  'tweak_tune_btn': 'Afstemmen',
  'tweak_queue_btn': 'Wachtrij',
  'tweak_placeholder': 'Vertel Ella hoe dit station aan te passen…',
  'tweak_examples_label': 'Probeer zoiets als:',
  'tweak_example_1': 'Geen muziek ouder dan 10 jaar',
  'tweak_example_2': 'Meer verborgen pareltjes, minder hits',
  'tweak_example_3': 'Houd het zacht en akoestisch',
  'tweak_example_4': 'Voeg meer vrouwelijke zangers toe',
  'fda.title': 'Maestro heeft toestemming nodig om toegang te krijgen tot je muziekbibliotheek',
  'fda.description': 'macOS heeft de toegangsrechten van Maestro ingetrokken, waarschijnlijk na de laatste app-update. Je muziekbibliotheek is in orde — we hoeven alleen de toegang opnieuw te verlenen.',
  'fda.open_settings': 'Systeeminstellingen openen',
  'fda.recheck': 'Gedaan — opnieuw controleren',
  'source_health.offline_disconnected': 'Offline voor {minutes} min — station losgekoppeld',
  'source_health.offline_timeout': 'Offline voor {minutes} min — trage respons',
  'source_health.toast_offline': 'Deze muziek staat op \'{source_name}\', dat momenteel offline is. Sluit de schijf opnieuw aan en probeer het opnieuw.',
  'source_health.toast_permission': 'Maestro kan \'{source_name}\' niet lezen. Controleer de mapmachtigingen.',
  'faq.title': 'Veelgestelde Vragen',
  'faq.subtitle': 'Snelle antwoorden op veelgestelde vragen',
  'faq.empty': 'Nog geen FAQ\'s beschikbaar.',
  'faq.loading': 'Laden…',
  'support.message_paul': 'Bericht aan Paul',
  'support.goes_to': 'Gaat rechtstreeks naar paul@psaudio.com',
  'support.intro': 'Bedankt dat je deel uitmaakt van het Maestro Beta-team. Ik hoor graag je opmerkingen, bugrapporten en ideeën — elk bericht komt rechtstreeks bij mij terecht.',
  'support.name': 'Naam',
  'support.name_placeholder': 'Je naam',
  'support.email': 'E-mail',
  'support.email_placeholder': 'jouw@email.nl',
  'support.subject': 'Onderwerp',
  'support.subject_placeholder': 'Waar denk je aan?',
  'support.message': 'Bericht',
  'support.message_placeholder': 'Vertel me wat je bezighoudt...',
  'support.platform': 'Platform',
  'support.send': 'Bericht versturen',
  'support.sending': 'Versturen…',
  'support.sent': 'Bericht verzonden ({ticketId})! Je ontvangt een bevestigingsmail en kunt ons gesprek hieronder volgen.',
  'support.version': 'Versie',
  'support.diagnostic.title': 'Diagnosemodus',
  'support.diagnostic.checking': 'Controleren…',
  'support.diagnostic.state_a_body': 'Als Maestro-support heeft gevraagd om diagnostische logboekregistratie in te schakelen, kun je dat hier doen. Verbindingsdetails worden met ons team gedeeld.',
  'support.diagnostic.contact_support': 'Neem contact op met support om in te schakelen',
  'support.diagnostic.state_b_body_ticket': 'Diagnostische logging is beschikbaar voor je supportticket {ticket}.',
  'support.diagnostic.state_b_body': 'Diagnostische logging is beschikbaar.',
  'support.diagnostic.state_c_instruction': 'Diagnostische gegevens worden vastgelegd. Gebruik Maestro normaal tot het probleem optreedt; kom dan hier terug en verzend het logboek.',
  'support.diagnostic.available_expires': 'Beschikbaar — verloopt over {time}',
  'support.diagnostic.recording_expires': 'Opname — verloopt over {time}',
  'support.diagnostic.send_log': 'Logboek verzenden',
  'support.diagnostic.sending': 'Verzenden…',
  'support.diagnostic.log_sent': 'Logboek naar support verzonden',
  'support.diagnostic.reference': 'referentie',
  'support.diagnostic.send_failed': 'Logboek kon niet worden verzonden. Probeer opnieuw.',
  'support.diagnostic.expired': 'verlopen',
};

const translations = { en, es, fr, de, it, pt, ja, ko, zh, nl };
export default translations;
